/* tslint:disable */
/* eslint-disable */
/**
 * APEX REST API
 * Documentation for APEX REST API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';


export const AddonOrderStatus = {
    New: 'new',
    Denied: 'denied',
    Canceled: 'canceled',
    Accepted: 'accepted',
} as const;

export type AddonOrderStatus = typeof AddonOrderStatus[keyof typeof AddonOrderStatus];



export const AddressType = {
    Mail: 'mail',
    Invoice: 'invoice',
    Visit: 'visit',
} as const;

export type AddressType = typeof AddressType[keyof typeof AddressType];



export const AgreementPageOptionsOrderBy = {
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type AgreementPageOptionsOrderBy = typeof AgreementPageOptionsOrderBy[keyof typeof AgreementPageOptionsOrderBy];



export const AllowedAddressModel = {
    Company: 'Company',
    Project: 'Project',
    Apartment: 'Apartment',
    User: 'User',
    Object: 'Object',
    CrmUser: 'CrmUser',
} as const;

export type AllowedAddressModel = typeof AllowedAddressModel[keyof typeof AllowedAddressModel];



export const AllowedArticleModel = {
    Project: 'Project',
    Object: 'Object',
    Company: 'Company',
    ConstructionSite: 'ConstructionSite',
    Agreement: 'Agreement',
} as const;

export type AllowedArticleModel = typeof AllowedArticleModel[keyof typeof AllowedArticleModel];



export const AllowedArticleUsageModel = {
    Project: 'Project',
    Object: 'Object',
    Company: 'Company',
    ProjectApartment: 'ProjectApartment',
} as const;

export type AllowedArticleUsageModel = typeof AllowedArticleUsageModel[keyof typeof AllowedArticleUsageModel];


export interface ApprovedResponseDto {
    'approved': boolean;
}

export const ArticlePageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Title: 'title',
} as const;

export type ArticlePageOptionsOrderBy = typeof ArticlePageOptionsOrderBy[keyof typeof ArticlePageOptionsOrderBy];



export const ArticleUsageCompany = {
    TakeoverOwnershipNew: 'takeover-ownership-new',
    TakeoverOwnershipUsed: 'takeover-ownership-used',
    AddonConfirmation: 'addon-confirmation',
    AddonPdf: 'addon-pdf',
    AddonProjectText: 'addon-project-text',
    TakeoverTenancyPrivate: 'takeover-tenancy-private',
    TakeoverTenancyCommercial: 'takeover-tenancy-commercial',
    TakeoverTenancyPrivateReturn: 'takeover-tenancy-private-return',
    TakeoverTenancyCommercialReturn: 'takeover-tenancy-commercial-return',
} as const;

export type ArticleUsageCompany = typeof ArticleUsageCompany[keyof typeof ArticleUsageCompany];



export const ArticleUsageObject = {
    TakeoverTenancyPrivate: 'takeover-tenancy-private',
    TakeoverTenancyCommercial: 'takeover-tenancy-commercial',
    TakeoverTenancyPrivateReturn: 'takeover-tenancy-private-return',
    TakeoverTenancyCommercialReturn: 'takeover-tenancy-commercial-return',
    TakeoverOwnershipNew: 'takeover-ownership-new',
    TakeoverOwnershipUsed: 'takeover-ownership-used',
} as const;

export type ArticleUsageObject = typeof ArticleUsageObject[keyof typeof ArticleUsageObject];



export const ArticleUsageProject = {
    TakeoverOwnershipNew: 'takeover-ownership-new',
    TakeoverOwnershipUsed: 'takeover-ownership-used',
    AddonConfirmation: 'addon-confirmation',
    AddonPdf: 'addon-pdf',
    AddonProjectText: 'addon-project-text',
    RequestConsent: 'request-consent',
} as const;

export type ArticleUsageProject = typeof ArticleUsageProject[keyof typeof ArticleUsageProject];



export const ArticleUsageProjectApartment = {
    TakeoverNew: 'takeover-new',
    TakeoverUsed: 'takeover-used',
} as const;

export type ArticleUsageProjectApartment = typeof ArticleUsageProjectApartment[keyof typeof ArticleUsageProjectApartment];


export interface ArticleUsagesNamesDto {
    'articleUsageProject': ArticleUsageProject;
    'articleUsageObject': ArticleUsageObject;
    'articleUsageCompany': ArticleUsageCompany;
    'articleUsageProjectApartment': ArticleUsageProjectApartment;
}



export const AuthDestination = {
    App: 'app',
    Inspection: 'inspection',
    Portal: 'portal',
    Print: 'print',
    Reporting: 'reporting',
    Requests: 'requests',
} as const;

export type AuthDestination = typeof AuthDestination[keyof typeof AuthDestination];


export interface BooleanEntityResponse {
    'data'?: object;
    'Entity'?: object;
}
export interface CaseApartmentPrintDto {
    'id': number;
    'name': string | null;
    'Clients'?: Array<ResponseUserCardDto>;
    'Addresses'?: Array<ResponseAddressDto>;
}
export interface CaseContractorPrintDto {
    'status': CaseContractorStatus;
}



export const CaseContractorStatus = {
    New: 'new',
    Accepted: 'accepted',
    Declined: 'declined',
    Completed: 'completed',
} as const;

export type CaseContractorStatus = typeof CaseContractorStatus[keyof typeof CaseContractorStatus];


export interface CaseExportPrintDto {
    'locale': Locale;
    'Cases'?: Array<CasePrintDto>;
    'Creator': UserPrintDto;
}


export interface CaseFilters {
    /**
     * Include cases in the report
     */
    'includeCases'?: boolean;
    'includeLogs'?: boolean;
    'includeObject'?: boolean;
    'includeClient'?: boolean;
    'includeObjectField'?: boolean;
    'includeField'?: boolean;
    'includeChecklist'?: boolean;
    'includeFileUsages'?: boolean;
    'includeMarkings'?: boolean;
    'includeClosedCases'?: boolean;
    'includeCompletedCases'?: boolean;
    'deviationsOnly'?: boolean;
    'onlyCaseList'?: boolean;
}
export interface CaseObjectPrintDto {
    'name': string;
}
export interface CasePrintDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'deadlineAt': string;
    'name': string;
    'description': string | null;
    'location': string;
    'Field'?: FieldPrintDto;
    'ObjectField'?: ResponseObjectFieldIdnDto;
    'CaseManager'?: UserPrintDto;
    'Contractors'?: Array<ContractorPrintDto>;
    'Client'?: ResponseUserCardDto;
    'Object'?: CaseObjectPrintDto;
    'Project'?: CaseProjectPrintDto;
    'Apartment'?: CaseApartmentPrintDto;
    'FileUsages'?: Array<ResponseFileUsageDto>;
    'Markings'?: Array<ResponseMarkingDto>;
    'Checklist'?: ChecklistPrintDto;
    'CaseLogs'?: Array<ResponseCaseLogDto>;
    'completedAt': string | null;
    'Creator'?: PrintCreatorDto;
    'Tenancy'?: TenancyPrintDto;
    'ObjectOwnership'?: ObjectOwnershipPrintDto;
}
export interface CaseProjectPrintDto {
    'name': string | null;
    'Company'?: CompanyPrintDto;
}
export interface ChecklistCaseManagerPrintDto {
    'name': string;
}
export interface ChecklistCategoryPrintDto {
    'name': string;
}
export interface ChecklistFilters {
    /**
     * Show only checklist items with deviations
     */
    'showOnlyDeviations'?: boolean;
    /**
     * Include checklist data in the report
     */
    'showChecklist'?: boolean;
    /**
     * Include completed checklist items
     */
    'includeCompletedItems'?: boolean;
}
export interface ChecklistGroupPrintDto {
    'id': number;
    'ParentId': number | null;
    'name': string;
    'description': string | null;
    'Checklists': Array<ChecklistPrintDto>;
    'Children': Array<ChecklistGroupPrintDto>;
    'CaseManager': ChecklistCaseManagerPrintDto;
    'Object'?: CaseObjectPrintDto;
    'Project'?: CaseProjectPrintDto;
    'Apartment'?: ProjectApartmentPrintDto;
    'sortOrder': number;
}
export interface ChecklistItemCasePrintDto {
    'id': number;
    'description': string | null;
    'name': string;
    'completed': number;
    'FileUsages'?: Array<ResponseFileUsageDto>;
}
export interface ChecklistItemPrintDto {
    'id': number;
    'SectionId'?: number;
    'note': string;
    'notApplicable': boolean;
    'Case': ChecklistItemCasePrintDto;
    'Cases': Array<ChecklistItemCasePrintDto>;
}

export const ChecklistItemType = {
    Checkbox: 'checkbox',
    Text: 'text',
    Number: 'number',
    Date: 'date',
    Image: 'image',
    Select: 'select',
} as const;

export type ChecklistItemType = typeof ChecklistItemType[keyof typeof ChecklistItemType];



export const ChecklistPageOptionsOrderBy = {
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type ChecklistPageOptionsOrderBy = typeof ChecklistPageOptionsOrderBy[keyof typeof ChecklistPageOptionsOrderBy];


export interface ChecklistPrintDto {
    'id': number;
    'name': string;
    'description': string | null;
    'Items': Array<ChecklistItemPrintDto>;
    'ChecklistSections': Array<ChecklistSectionPrintDto>;
    'Category'?: ChecklistCategoryPrintDto;
    'CaseManager'?: ChecklistCaseManagerPrintDto | null;
    'Object'?: CaseObjectPrintDto;
    'Project'?: CaseProjectPrintDto;
    'Apartment'?: ProjectApartmentPrintDto;
    'sortOrder': number;
}

export const ChecklistSectionPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
} as const;

export type ChecklistSectionPageOptionsOrderBy = typeof ChecklistSectionPageOptionsOrderBy[keyof typeof ChecklistSectionPageOptionsOrderBy];


export interface ChecklistSectionPrintDto {
    'id': number;
    'ParentId': number | null;
    'name': string;
    'ChecklistItems': Array<ChecklistItemPrintDto>;
    'ChecklistSections': Array<ChecklistSectionPrintDto>;
}

export const ChecklistTemplatePageOptionsOrderBy = {
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type ChecklistTemplatePageOptionsOrderBy = typeof ChecklistTemplatePageOptionsOrderBy[keyof typeof ChecklistTemplatePageOptionsOrderBy];



export const ChecklistTemplateSectionPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
} as const;

export type ChecklistTemplateSectionPageOptionsOrderBy = typeof ChecklistTemplateSectionPageOptionsOrderBy[keyof typeof ChecklistTemplateSectionPageOptionsOrderBy];


export interface CollectionResponseDto {
    'data'?: object;
    'Collection': Array<string>;
}
export interface CompanyConsentCompanyConsentDataDto {
    'name'?: string;
    'mail'?: string;
}
export interface CompanyPrintDto {
    'name': string;
}
export interface ContractorPrintDto {
    'name': string;
    'mail'?: string | null;
    'mobile'?: string | null;
    'Company'?: CompanyPrintDto;
    'CaseContractor': CaseContractorPrintDto;
}

export const CpiCountryCode = {
    No: 'no',
} as const;

export type CpiCountryCode = typeof CpiCountryCode[keyof typeof CpiCountryCode];


export interface CreateAddressDto {
    'type': AddressType;
    /**
     * A two char ISO31661 Alpha2 code
     */
    'countryCode'?: string;
    'line1': string;
    'line2'?: string | null;
    'postal'?: string | null;
    'email'?: string | null;
    'note'?: string | null;
    'reference'?: string | null;
    'placeId'?: string | null;
    'latitude'?: number | null;
    'longitude'?: number | null;
}


export interface CreateArticleDto {
    /**
     * The Id of the Company creating the article
     */
    'CompanyId': number;
    /**
     * List of FileKeys to associate with this Article
     */
    'filesFileKeys': Array<string>;
    /**
     * List of FileKeys for the images of this Article
     */
    'imagesFileKeys': Array<string>;
    'FolderId': string | null;
    'title': string;
    'lead'?: string | null;
    'content': string;
    'articleModels': Array<CreateArticleModelDto>;
}
export interface CreateArticleModelDto {
    'model': AllowedArticleModel;
    'from': string;
    'to'?: string;
    'modelId': string;
    'public': boolean;
    'forClients'?: boolean;
}


export interface CreateArticleUsageDto {
    'ArticleId': string;
    'requireExplicitConsent': boolean;
}

export const CreateCaseTime = {
    _1: '1',
    _3: '3',
    _6: '6',
    _12: '12',
    _24: '24',
} as const;

export type CreateCaseTime = typeof CreateCaseTime[keyof typeof CreateCaseTime];


export interface CreateChecklistTemplateDto {
    'name': string;
    'CategoryId': number;
    'customerAccess': boolean;
    'CompanyId': number;
    'description': string;
}
export interface CreateChecklistTemplateItemDto {
    'CategoryId': number;
    'sortOrder': number;
    'data': object;
    'fieldId': number;
    'checklistItemType'?: ChecklistItemType;
    'name': string;
    'description': string | null;
    'selectOptions'?: Array<string> | null;
}


export interface CreateChecklistTemplateSectionDto {
    'name': string;
    'description': string;
}
export interface CreateCompanyConsentCompanyContactDto {
    /**
     * The id of the user who should be able to give consent
     */
    'UserId': number;
}
export interface CreateCompanyConsentCompanyDto {
    /**
     * The id of the company receiving the consent. If different from the request user´s CompanyId, it is checked to see if request user is admin for this Company and used in stead if it is
     */
    'CompanyId': number;
    /**
     * If admins are allowed to consent
     */
    'allowAdmins': boolean;
    /**
     * If all contacts must consent before the consent is considered approved
     */
    'requireAllContacts': boolean;
    /**
     * The ids of the users who should be able to consent. Admins have implicit access
     */
    'UserIds'?: Array<number>;
}
export interface CreateCompanyConsentDto {
    /**
     * Name of the Consent to be created
     */
    'name': string;
    /**
     * The ID of the Company asking for consent
     */
    'CompanyId': number;
    /**
     * List of FileIds to associate with this Consent
     */
    'FileIds': Array<number>;
    /**
     * List of ConsentCompanies to associate with this Consent
     */
    'CompanyConsentCompanies'?: Array<CreateCompanyConsentCompanyDto>;
}
export interface CreateConsentCompanyConsentDto {
    /**
     * If the User has approved the associated consent
     */
    'approved': boolean;
}
export interface CreateCrmUserDto {
    'dateOfBirth'?: string;
    'CompanyId': number;
    'UserId'?: number;
    'firstName': string;
    'lastName': string;
    'mail'?: string;
    'mobile'?: string;
    'addressLine1'?: string;
    'addressLine2'?: string;
    'city'?: string;
    'postal'?: string;
    'country'?: string;
    'language'?: string;
}
export interface CreateFieldDto {
    'name': string;
    'CompanyId': number;
    /**
     * A hexadecimal color with leading # like your browser likes
     */
    'color'?: string | null;
    'status': number;
}
export interface CreateFileSigningPolicyDto {
    /**
     * Intended filename
     */
    'name': string;
    /**
     * The file\'s mimetype
     */
    'type': string;
    /**
     * Size in bytes, a maximum of 4GB is allowed
     */
    'size': number;
}
export interface CreateFileUsageDto {
    'FileId': number;
    'fileSort': number;
    'fileName': string;
}
export interface CreateFolderDto {
    'ParentId'?: string;
    'name': string;
    'description'?: string;
}
export interface CreateHelpUrlDto {
    'path': string;
    'url': string;
    'language': string;
}
export interface CreateModelTraitDto {
    'name': string;
    'value': string;
    'public': boolean;
}
export interface CreateObjectFieldReportDto {
    'ObjectId': number;
    'ObjectFieldId': number;
    'from': string;
    'to': string;
    /**
     * Report settings configuration for filters and inclusions
     */
    'settings': object;
}
export interface CreatePortalCaseLogDto {
    'message': string;
    'forContractor'?: number;
}
export interface CreateProjectApartmentClientDto {
    'CrmUserId': string;
}
export interface CreateProjectApartmentTakeoverDto {
    'signatures'?: Array<ProjectApartmentTakeoverSignatureDto>;
    'data': ProjectApartmentTakeoverDataDto;
    'hash': string;
}
export interface CreateSidebarItemPinnedDto {
    'model': SidebarModel;
    'modelId': string;
}


export interface CreateUnwantedIncidentDto {
    /**
     * The id of the project associated with this unwanted incident
     */
    'ProjectId'?: number | null;
    /**
     * The id of the object associated with this unwanted incident
     */
    'ObjectId'?: number | null;
    /**
     * The name of the user reporting this unwanted incident
     */
    'reporterName'?: string;
    /**
     * The email of the user reporting this unwanted incident
     */
    'reporterEmail'?: string | null;
    /**
     * The mobile phone number of the user reporting this unwanted incident
     */
    'reporterMobile'?: string | null;
    /**
     * The name of the company of the reporting user reporting this unwanted incident
     */
    'reporterCompany'?: string;
    /**
     * The description of the unwanted incident
     */
    'incident': string;
    /**
     * The immediate action taken when the unwanted incident occurred
     */
    'immediateAction': string;
    /**
     * The consequence of the incident
     */
    'consequence'?: string;
    /**
     * The types of unwanted incident. Can be more than one
     */
    'types': Array<CreateUnwantedIncidentDtoTypesEnum>;
    /**
     * List of FileKeys to associate with this UnwantedIncident
     */
    'fileKeys': Array<string>;
    'Markings'?: Array<UnwantedIncidentMarkingDto>;
}

export const CreateUnwantedIncidentDtoTypesEnum = {
    PersonInjury: 'person-injury',
    MaterialDamage: 'material-damage',
    Accident: 'accident',
    NearAccident: 'near-accident',
    Observation: 'observation',
} as const;

export type CreateUnwantedIncidentDtoTypesEnum = typeof CreateUnwantedIncidentDtoTypesEnum[keyof typeof CreateUnwantedIncidentDtoTypesEnum];

export interface CreateUnwantedIncidentProcessActionCaseDto {
    /**
     * Name of the case to create
     */
    'name': string;
    /**
     * A description for the case to create
     */
    'description': string;
    /**
     * The id of the project associated with this unwanted incident
     */
    'ProjectId'?: number;
    /**
     * The id of the object associated with this unwanted incident
     */
    'ObjectId'?: number;
    /**
     * The deadline date in Date format
     */
    'deadlineAt'?: string;
    /**
     * The id of the case category to attach to this case
     */
    'CaseCategoryId': number;
    /**
     * The id of the User that should be CaseManager for the Action, defaults to CaseManager from Project
     */
    'CaseManagerId'?: number;
}
export interface CreateUnwantedIncidentProcessActionDto {
    'type': UnwantedIncidentProcessActionType;
    'Case': CreateUnwantedIncidentProcessActionCaseDto;
}


export interface CreateUnwantedIncidentProcessDto {
    /**
     * Notes on the unwanted incident
     */
    'notes': string;
    'status': UnwantedIncidentProcessStatus;
}


export interface CreateUserStartPageDto {
    /**
     * The start page to set
     */
    'startPage': string | null;
}

export const CrmUserPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type CrmUserPageOptionsOrderBy = typeof CrmUserPageOptionsOrderBy[keyof typeof CrmUserPageOptionsOrderBy];


export interface CrmUserPrintDto {
    'name': string;
    'User'?: ResponseUserCardDto;
}
export interface DeleteResponseDto {
    'data'?: object;
    'deleted': boolean;
}
export interface EntityResponseDto {
    'data'?: object;
}

export const FieldPageOptionsOrderBy = {
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type FieldPageOptionsOrderBy = typeof FieldPageOptionsOrderBy[keyof typeof FieldPageOptionsOrderBy];


export interface FieldPrintDto {
    'name': string;
    'color': string | null;
}
export interface FileUsageCountDto {
    'count': number;
}
export interface FileUsageCountDtoEntityResponse {
    'data'?: object;
    'Entity'?: FileUsageCountDto;
}
export interface FileUsageFileSortDto {
    'FileId': number;
    'fileSort': number;
}
export interface FileUsageFileSortDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<FileUsageFileSortDto>;
}
export interface FileUsageSortDto {
    'sorts': Array<FileUsageFileSortDto>;
}
export interface FilterDto {
    'Parent'?: FilterDto;
    'id': string;
    'name': string;
}
export interface FilterDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<FilterDto>;
}

export const FolderItemPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
    Type: 'type',
} as const;

export type FolderItemPageOptionsOrderBy = typeof FolderItemPageOptionsOrderBy[keyof typeof FolderItemPageOptionsOrderBy];



export const FolderItemType = {
    Folder: 'folder',
    File: 'file',
} as const;

export type FolderItemType = typeof FolderItemType[keyof typeof FolderItemType];



export const FolderModel = {
    Customer: 'customer',
    User: 'user',
    Project: 'project',
    Apartment: 'apartment',
    Object: 'object',
    Field: 'field',
    ObjectField: 'object-field',
    Mom: 'mom',
    Upload: 'upload',
    Hse: 'hse',
} as const;

export type FolderModel = typeof FolderModel[keyof typeof FolderModel];



export const FolderPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
} as const;

export type FolderPageOptionsOrderBy = typeof FolderPageOptionsOrderBy[keyof typeof FolderPageOptionsOrderBy];


export interface GeometryCrs {
    'properties': GeometryCrsProperties;
}
export interface GeometryCrsProperties {
    'name': string;
}
export interface GeometryDto {
    'type': GeometryType;
    'coordinates': GeometryDtoCoordinates;
    'crs'?: GeometryCrs;
}


/**
 * @type GeometryDtoCoordinates
 */
export type GeometryDtoCoordinates = Array<Array<number>> | Array<number>;


export const GeometryType = {
    Point: 'Point',
    LineString: 'LineString',
    Polygon: 'Polygon',
} as const;

export type GeometryType = typeof GeometryType[keyof typeof GeometryType];


export interface InspectionFilters {
    /**
     * Include inspections in the report
     */
    'includeInspections'?: boolean;
    /**
     * Include associated cases in the inspection report
     */
    'includeAssociatedCases'?: boolean;
    'includeChecklists'?: boolean;
    'includeChecklistGroups'?: boolean;
    'includeDeviations'?: boolean;
    'includeInvolved'?: boolean;
    'includeNotes'?: boolean;
    'includeSignatures'?: boolean;
    'includeAttachments'?: boolean;
    'includeCaseMarkings'?: boolean;
    'onlyInspectionList'?: boolean;
}

export const InspectionInvolvedUserType = {
    CurrentUser: 'current-user',
    Casemanager: 'casemanager',
    Contractor: 'contractor',
    Client: 'client',
} as const;

export type InspectionInvolvedUserType = typeof InspectionInvolvedUserType[keyof typeof InspectionInvolvedUserType];


export interface InspectionPrintDataDto {
    'inspectionDate': string;
    'customerLogos'?: Array<ResponseFileUsageDto>;
    'projectLogos'?: Array<ResponseFileUsageDto>;
    'Category': ResponseCaseCategoryDto;
    'Field'?: ResponseFieldDto;
    'Tenancies': Array<ResponseTenancyIdnDto>;
    'Project'?: ProjectPrintDto;
    'Object'?: ObjectPrintDto;
    'ObjectField'?: ResponseObjectFieldIdnDto;
    'Users': Array<InvolvedUserPrintDto>;
    'CaseManager': UserPrintDto;
    'Checklists'?: Array<ChecklistPrintDto>;
    'ChecklistGroups'?: Array<ChecklistGroupPrintDto>;
    'Cases'?: Array<CasePrintDto>;
    'Files'?: Array<ResponseFileDto>;
    'notes'?: string;
    'Article'?: InspectionPrintDataDtoArticle;
}
export interface InspectionPrintDataDtoArticle {
    'id'?: string;
    'title'?: string;
    'content'?: string;
}
export interface InspectionPrintDto {
    'locale': Locale;
    'data': InspectionPrintDataDto;
    'Creator': PrintCreatorDto;
    'signatures'?: Array<InspectionPrintSignaturesDto>;
}


export interface InspectionPrintSignaturesDto {
    'id': number;
    'name': string;
    'signature': string;
}
export interface InvolvedUserPrintDto {
    'type'?: InspectionInvolvedUserType;
    'name': string;
    'mail': string;
    'present'?: boolean;
    'signer'?: boolean;
    'report'?: boolean;
}


/**
 * Language code for protocol
 */

export const Locale = {
    Nb: 'nb',
    En: 'en',
    Da: 'da',
    De: 'de',
    El: 'el',
    Et: 'et',
    Lt: 'lt',
    Lv: 'lv',
    Pl: 'pl',
    Pt: 'pt',
    Sq: 'sq',
    Sv: 'sv',
} as const;

export type Locale = typeof Locale[keyof typeof Locale];


export interface LoginDto {
    'destination'?: AuthDestination;
    'email': string;
    'password': string;
}


export interface MarkingDataDto {
    'imageHeight'?: number;
    'imageWidth'?: number;
}

export const MarkingModel = {
    Case: 'case',
    AddonApartment: 'addon-apartment',
} as const;

export type MarkingModel = typeof MarkingModel[keyof typeof MarkingModel];



export const MeterType = {
    ColdWater: 'cold-water',
    HotWater: 'hot-water',
    DistrictHeating: 'district-heating',
    Power: 'power',
    Gas: 'gas',
    Temperature: 'temperature',
    Moisture: 'moisture',
    SprinklerPressure: 'sprinkler-pressure',
    Other: 'other',
} as const;

export type MeterType = typeof MeterType[keyof typeof MeterType];



export const MeteringPointStatus = {
    Active: 'Active',
    Inactive: 'Inactive',
    Invalid: 'Invalid',
} as const;

export type MeteringPointStatus = typeof MeteringPointStatus[keyof typeof MeteringPointStatus];


/**
 * The mime type of the file
 */

export const MimeType = {
    ApplicationPdf: 'application/pdf',
    AudioAac: 'audio/aac',
    ApplicationXAbiword: 'application/x-abiword',
    ApplicationXFreearc: 'application/x-freearc',
    ImageAvif: 'image/avif',
    VideoXMsvideo: 'video/x-msvideo',
    ApplicationVndAmazonEbook: 'application/vnd.amazon.ebook',
    ApplicationOctetStream: 'application/octet-stream',
    ImageBmp: 'image/bmp',
    ApplicationXBzip: 'application/x-bzip',
    ApplicationXBzip2: 'application/x-bzip2',
    ApplicationXCdf: 'application/x-cdf',
    ApplicationXCsh: 'application/x-csh',
    TextCss: 'text/css',
    TextCsv: 'text/csv',
    ApplicationMsword: 'application/msword',
    ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    ApplicationVndMsFontobject: 'application/vnd.ms-fontobject',
    ApplicationEpubzip: 'application/epub+zip',
    ApplicationGzip: 'application/gzip',
    ImageGif: 'image/gif',
    TextHtml: 'text/html',
    ImageVndMicrosoftIcon: 'image/vnd.microsoft.icon',
    TextCalendar: 'text/calendar',
    ApplicationJavaArchive: 'application/java-archive',
    ImageJpeg: 'image/jpeg',
    TextJavascript: 'text/javascript',
    ApplicationJson: 'application/json',
    ApplicationLdjson: 'application/ld+json',
    AudioMidi: 'audio/midi',
    AudioXMidi: 'audio/x-midi',
    AudioMpeg: 'audio/mpeg',
    VideoMp4: 'video/mp4',
    VideoMpeg: 'video/mpeg',
    ApplicationVndAppleInstallerxml: 'application/vnd.apple.installer+xml',
    ApplicationVndOasisOpendocumentPresentation: 'application/vnd.oasis.opendocument.presentation',
    ApplicationVndOasisOpendocumentSpreadsheet: 'application/vnd.oasis.opendocument.spreadsheet',
    ApplicationVndOasisOpendocumentText: 'application/vnd.oasis.opendocument.text',
    AudioOgg: 'audio/ogg',
    VideoOgg: 'video/ogg',
    ApplicationOgg: 'application/ogg',
    AudioOpus: 'audio/opus',
    FontOtf: 'font/otf',
    ImagePng: 'image/png',
    ApplicationXHttpdPhp: 'application/x-httpd-php',
    ApplicationVndMsPowerpoint: 'application/vnd.ms-powerpoint',
    ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation: 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    ApplicationVndRar: 'application/vnd.rar',
    ApplicationRtf: 'application/rtf',
    ApplicationXSh: 'application/x-sh',
    ImageSvgxml: 'image/svg+xml',
    ApplicationXShockwaveFlash: 'application/x-shockwave-flash',
    ApplicationXTar: 'application/x-tar',
    ImageTiff: 'image/tiff',
    VideoMp2t: 'video/mp2t',
    FontTtf: 'font/ttf',
    TextPlain: 'text/plain',
    ApplicationVndVisio: 'application/vnd.visio',
    AudioWav: 'audio/wav',
    AudioWebm: 'audio/webm',
    VideoWebm: 'video/webm',
    ImageWebp: 'image/webp',
    FontWoff: 'font/woff',
    FontWoff2: 'font/woff2',
    ApplicationXhtmlxml: 'application/xhtml+xml',
    ApplicationVndMsExcel: 'application/vnd.ms-excel',
    ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    ApplicationXml: 'application/xml',
    ApplicationVndMozillaXulxml: 'application/vnd.mozilla.xul+xml',
    ApplicationZip: 'application/zip',
    Video3gppAudio3gpp: 'video/3gpp; audio/3gpp',
    Video3gpp2Audio3gpp2: 'video/3gpp2; audio/3gpp2',
    ApplicationX7zCompressed: 'application/x-7z-compressed',
} as const;

export type MimeType = typeof MimeType[keyof typeof MimeType];



export const ModelTraitModel = {
    Project: 'Project',
    ProjectApartment: 'ProjectApartment',
    Addon: 'Addon',
    ContractorAddon: 'ContractorAddon',
    Object: 'Object',
} as const;

export type ModelTraitModel = typeof ModelTraitModel[keyof typeof ModelTraitModel];



export const ModelTraitPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    Name: 'name',
    Value: 'value',
} as const;

export type ModelTraitPageOptionsOrderBy = typeof ModelTraitPageOptionsOrderBy[keyof typeof ModelTraitPageOptionsOrderBy];


export interface NumberIdnDto {
    'id': number;
    'name': string;
}

export const ObjectFieldReportPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type ObjectFieldReportPageOptionsOrderBy = typeof ObjectFieldReportPageOptionsOrderBy[keyof typeof ObjectFieldReportPageOptionsOrderBy];


export interface ObjectFieldReportPdfDto {
    /**
     * Case-related filter options
     */
    'caseFilters'?: CaseFilters;
    /**
     * Inspection-related filter options
     */
    'inspectionFilters'?: InspectionFilters;
    /**
     * Checklist-related filter options
     */
    'checklistFilters'?: ChecklistFilters;
    'from'?: string;
    'to'?: string;
    'includeFolders'?: boolean;
}

export const ObjectInvolvedUser = {
    CaseManager: 'case-manager',
    Custodian: 'custodian',
    ProjectManager: 'project-manager',
    Contact: 'contact',
    Contractor: 'contractor',
    UnwantedIncidentManager: 'unwanted-incident-manager',
    ResponsibleWithinUs: 'responsible-within-us',
    AgreementInvolved: 'agreement-involved',
} as const;

export type ObjectInvolvedUser = typeof ObjectInvolvedUser[keyof typeof ObjectInvolvedUser];


export interface ObjectOwnershipPrintDto {
    'Users'?: Array<ResponseUserCardDto>;
    'CRMUsers'?: Array<CrmUserPrintDto>;
}
export interface ObjectPrintDataDto {
    'address'?: string;
    'zipcode'?: number;
    'postal'?: string;
}
export interface ObjectPrintDto {
    'name': string;
    'Children'?: Array<ObjectPrintDto>;
    'data': ObjectPrintDataDto;
}

export const Order = {
    Asc: 'ASC',
    Desc: 'DESC',
} as const;

export type Order = typeof Order[keyof typeof Order];


export interface PageMetaDto {
    'page': number;
    'limit': number;
    'itemCount': number;
    'pageCount': number;
    'hasPreviousPage': boolean;
    'hasNextPage': boolean;
}

export const PageOptionsDefaultOrderBy = {
    Id: 'id',
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type PageOptionsDefaultOrderBy = typeof PageOptionsDefaultOrderBy[keyof typeof PageOptionsDefaultOrderBy];


export interface PageResponseDto {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<string>;
}

export const PortalCaseLogPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type PortalCaseLogPageOptionsOrderBy = typeof PortalCaseLogPageOptionsOrderBy[keyof typeof PortalCaseLogPageOptionsOrderBy];



export const PortalCasePageOptionsOrderBy = {
    Name: 'name',
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
    ArchivedAt: 'archivedAt',
} as const;

export type PortalCasePageOptionsOrderBy = typeof PortalCasePageOptionsOrderBy[keyof typeof PortalCasePageOptionsOrderBy];



export const PortalCasesPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
} as const;

export type PortalCasesPageOptionsOrderBy = typeof PortalCasesPageOptionsOrderBy[keyof typeof PortalCasesPageOptionsOrderBy];


export interface PostFolderFieldMappingDto {
    'ObjectFieldId': number;
}
export interface PrintCreatorDto {
    'name': string;
    'Company': CompanyPrintDto;
}

export const ProjectApartmentAgreementType = {
    NUMBER_1: 1,
    NUMBER_2: 2,
} as const;

export type ProjectApartmentAgreementType = typeof ProjectApartmentAgreementType[keyof typeof ProjectApartmentAgreementType];


export interface ProjectApartmentPrintDto {
    'name': string | null;
}
export interface ProjectApartmentTakeoverAddonCategoryDto {
    'name': string;
}
export interface ProjectApartmentTakeoverDataAddonOrderAddonDto {
    'name': string;
    'description': string;
    'AddonCategory'?: ProjectApartmentTakeoverAddonCategoryDto;
}
export interface ProjectApartmentTakeoverDataAddonOrderCaseDto {
    'completed': number;
}
export interface ProjectApartmentTakeoverDataAddonOrderDto {
    'CaseId'?: number | null;
    'Case'?: ProjectApartmentTakeoverDataAddonOrderCaseDto;
    'Addon': ProjectApartmentTakeoverDataAddonOrderAddonDto;
    'ClientComment'?: string | null;
    'ManagerComment'?: string | null;
    'quantity'?: number | null;
}
export interface ProjectApartmentTakeoverDataApartmentDto {
    'id': number;
    'name': string | null;
    'unitType'?: string | null;
    'typeModel'?: string | null;
    'municipalityLandNumber'?: string | null;
    'titleNumber'?: string | null;
    'sectionNumber'?: string | null;
    'parkingLot'?: string | null;
    'storageRoomNumber'?: string | null;
    'agreementType': number;
    'modelTraits'?: Array<ResponseModelTraitDto>;
    'Addresses'?: Array<ResponseAddressDto>;
}
export interface ProjectApartmentTakeoverDataCaseDto {
    'id': number;
    'CaseCategoryId': number;
    'name': string;
}
export interface ProjectApartmentTakeoverDataChecklistDto {
    'id': number;
    'name': string;
    'description'?: string;
    'cases'?: number;
    'casesCompleted'?: number;
}
export interface ProjectApartmentTakeoverDataChecklistGroupDto {
    'id': number;
    'name': string;
    'description'?: string | null;
    'cases'?: number;
    'casesCompleted'?: number;
}
export interface ProjectApartmentTakeoverDataConsentDto {
    'articleUsage': ResponseArticleUsageDto;
    'readAndUnderstood'?: boolean;
}
export interface ProjectApartmentTakeoverDataDocumentsDto {
    'certificatesOfCompletion'?: Array<ProjectApartmentTakeoverDataDocumentsFileUsageDto>;
    'temporaryUsePermits'?: Array<ProjectApartmentTakeoverDataDocumentsFileUsageDto>;
    'amendmentAgreements'?: Array<ProjectApartmentTakeoverDataDocumentsFileUsageDto>;
}
export interface ProjectApartmentTakeoverDataDocumentsFileUsageDto {
    'fileName': string;
}
export interface ProjectApartmentTakeoverDataDto {
    'involved': Array<ProjectApartmentTakeoverDataInvolvedUserDto>;
    'checklists': Array<ProjectApartmentTakeoverDataChecklistDto>;
    'checklistGroups': Array<ProjectApartmentTakeoverDataChecklistGroupDto>;
    'cases': Array<ProjectApartmentTakeoverDataCaseDto>;
    'suppliers'?: Array<ProjectApartmentTakeoverDataSupplierDto>;
    'signatureType': ProjectApartmentTakeoverSignatureType;
    'attachments': Array<ProjectApartmentTakeoverDataFileDto>;
    'meters': Array<ProjectApartmentTakeoverDataMeterDto>;
    'documents': ProjectApartmentTakeoverDataDocumentsDto;
    'consents': Array<ProjectApartmentTakeoverDataConsentDto>;
    'addonOrders'?: Array<ProjectApartmentTakeoverDataAddonOrderDto>;
    'caseManagerId': number;
    'recipients': Array<ProjectApartmentTakeoverDestinationDto>;
    'simultaneousSigners'?: Array<ProjectApartmentTakeoverSimultaneousSignerDto>;
    'locale': Locale;
    'powerMethod': ProjectApartmentTakeoverElectricityContractMethod;
    'note'?: string;
    'project': ProjectApartmentTakeoverDataProjectDto;
    'apartment': ProjectApartmentTakeoverDataApartmentDto;
    'remediation'?: string;
    'receivedSettlement': boolean;
    'clientMoveIn': boolean;
    'clientChoosesSupplierConsent'?: boolean;
    'seller': ProjectSellerDto;
}


export interface ProjectApartmentTakeoverDataFileDto {
    'type': MimeType;
    /**
     * The file key of the file
     */
    'key': string;
    'name': string;
    'size': number;
}


export interface ProjectApartmentTakeoverDataInvolvedUserDto {
    'id'?: number;
    'dateOfBirth'?: string;
    'organizationalNumber'?: string;
    'mobile'?: string;
    'address'?: string;
    'zip'?: string;
    'city'?: string;
    'role'?: ProjectApartmentTakeoverInvolvedUserRole;
    'name': string;
    'mail': string;
    'present': boolean;
    'report': boolean;
    'contactPerson'?: TakeoverSupplierOptionSubscriberContactPersonDto;
    'signer'?: boolean;
    'proxy'?: boolean;
}


export interface ProjectApartmentTakeoverDataMeterDto {
    'type': MeterType;
    'number'?: string;
    'externalNumber'?: string;
    'externalNumberStatus'?: string;
    'value'?: number;
    'send': boolean;
    'contact'?: ProjectApartmentTakeoverDataInvolvedUserDto;
}


export interface ProjectApartmentTakeoverDataPrintDto {
    'involved': Array<ProjectApartmentTakeoverDataInvolvedUserDto>;
    'recipients': Array<ProjectApartmentTakeoverDestinationDto>;
    'simultaneousSigners'?: Array<ProjectApartmentTakeoverSimultaneousSignerDto>;
    'consents': Array<ProjectApartmentTakeoverDataConsentDto>;
    'addonOrders'?: Array<ProjectApartmentTakeoverDataAddonOrderDto>;
    'meters': Array<ProjectApartmentTakeoverDataMeterDto>;
    'suppliers'?: Array<ProjectApartmentTakeoverDataSupplierPrintDto>;
    'project'?: ProjectApartmentTakeoverDataProjectDto;
    'seller'?: ResponseMainObjectSellerDto;
    'apartment'?: ResponseProjectApartmentCardDto;
    'checklists'?: Array<ChecklistPrintDto>;
    'checklistGroups'?: Array<ChecklistGroupPrintDto>;
    'cases'?: Array<CasePrintDto>;
    'receivedSettlement': boolean;
    'clientMoveIn': boolean;
    'remediation'?: string;
    'clientChoosesSupplierConsent'?: boolean;
    'note'?: string;
    'attachments'?: Array<ResponseFileDto>;
}
export interface ProjectApartmentTakeoverDataProjectDto {
    'id': number;
    'name': string | null;
    'projectOwner': string | null;
    'projectOwnerCompanyIdentification': string | null;
    'meterWarmWaterMail'?: string | null;
    'meterColdWaterMail'?: string | null;
    'meterDistrictHeatingMail'?: string | null;
    'meterPowerLineMail'?: string | null;
    'meterGasMail'?: string | null;
}
export interface ProjectApartmentTakeoverDataSupplierDto {
    'subscriber': ProjectApartmentTakeoverDataInvolvedUserDto;
    'option': ProjectApartmentTakeoverSupplierOptionDto;
    'commonText': string;
    'readAndUnderstood': boolean;
    'readRightsOfWithdrawal'?: boolean;
    'readRightsOfWithdrawalForm'?: boolean;
}
export interface ProjectApartmentTakeoverDataSupplierPrintDto {
    'subscriber': ProjectApartmentTakeoverDataInvolvedUserDto;
    'option': ResponseTakeoverSupplierOptionDto;
    'commonText': string;
    'readAndUnderstood': boolean;
    'readRightsOfWithdrawal'?: boolean;
    'readRightsOfWithdrawalForm'?: boolean;
}
export interface ProjectApartmentTakeoverDataTransferMeterDto {
    'type': MeterType;
    'name'?: string;
    'externalNumber'?: string;
    'value'?: number;
    'send': boolean;
    'contact': ProjectApartmentTakeoverDataInvolvedUserDto;
    'email': string;
}


export interface ProjectApartmentTakeoverDestinationDto {
    'contentType': ProjectTakeoverDestinationContentTypeToken;
    'recipientName': string;
    'recipientDestination'?: string;
}


/**
 * Method for ordering power
 */

export const ProjectApartmentTakeoverElectricityContractMethod = {
    ApexOvero: 'apex-overo',
    Self: 'self',
} as const;

export type ProjectApartmentTakeoverElectricityContractMethod = typeof ProjectApartmentTakeoverElectricityContractMethod[keyof typeof ProjectApartmentTakeoverElectricityContractMethod];


export interface ProjectApartmentTakeoverInvolvedUserRecipientDto {
    'id'?: number;
    'dateOfBirth'?: string;
    'organizationalNumber'?: string;
    'mobile'?: string;
    'address'?: string;
    'zip'?: string;
    'city'?: string;
    'role'?: ProjectApartmentTakeoverInvolvedUserRole;
    'name': string;
    'mail': string;
    'present': boolean;
    'report': boolean;
    'contactPerson'?: TakeoverSupplierOptionSubscriberContactPersonDto;
    'signer'?: boolean;
    'proxy'?: boolean;
}



export const ProjectApartmentTakeoverInvolvedUserRole = {
    Casemanager: 'casemanager',
    Contractor: 'contractor',
    Client: 'client',
    Owner: 'owner',
    PowerSubscriber: 'power-subscriber',
    GasSubscriber: 'gas-subscriber',
    MeterContact: 'meter-contact',
} as const;

export type ProjectApartmentTakeoverInvolvedUserRole = typeof ProjectApartmentTakeoverInvolvedUserRole[keyof typeof ProjectApartmentTakeoverInvolvedUserRole];


export interface ProjectApartmentTakeoverPrintDto {
    'locale': Locale;
    'data': ProjectApartmentTakeoverDataPrintDto;
    'Creator': PrintCreatorDto;
    'signatures': Array<InspectionPrintSignaturesDto>;
}


export interface ProjectApartmentTakeoverSignatureDto {
    'id': number;
    'name': string;
    'signature': string;
}

export const ProjectApartmentTakeoverSignatureType = {
    Handwritten: 'handwritten',
    Bankid: 'bankid',
} as const;

export type ProjectApartmentTakeoverSignatureType = typeof ProjectApartmentTakeoverSignatureType[keyof typeof ProjectApartmentTakeoverSignatureType];


export interface ProjectApartmentTakeoverSimultaneousSignerDto {
    'id': number;
    /**
     * Reason why this user needs to sign
     */
    'comment': string | null;
    'name': string;
    'company': ResponseCompanyIDNDto;
    'mail': string;
}
export interface ProjectApartmentTakeoverSupplierOptionDto {
    'id': number;
    'type': TakeoverSupplierOptionType;
    'name': string;
    'b2b': boolean;
}


export interface ProjectApartmentTakeoverTransferDataFileDto {
    'locale': Locale;
    'createdAt': string;
    'meter': ProjectApartmentTakeoverDataTransferMeterDto;
    'signature': ProjectApartmentTakeoverSignatureDto;
    'project': ProjectApartmentTakeoverDataProjectDto;
    'apartment': ProjectApartmentTakeoverDataApartmentDto;
}



export const ProjectInvolvedUser = {
    CaseManager: 'case-manager',
    Contractor: 'contractor',
    UnwantedIncidentManager: 'unwanted-incident-manager',
    ProjectManager: 'project-manager',
    AddonManager: 'addon-manager',
} as const;

export type ProjectInvolvedUser = typeof ProjectInvolvedUser[keyof typeof ProjectInvolvedUser];


export interface ProjectPrintDto {
    'name': string | null;
    'Apartment': ProjectApartmentPrintDto;
}
export interface ProjectSellerDto {
    'name': string;
    'companyIdentification': string;
}

export const ProjectTakeoverDestinationContentTypeToken = {
    Protocol: 'protocol',
    MeasurementsAndClientInfo: 'measurements-and-client-info',
} as const;

export type ProjectTakeoverDestinationContentTypeToken = typeof ProjectTakeoverDestinationContentTypeToken[keyof typeof ProjectTakeoverDestinationContentTypeToken];



export const RepeatWeekOn = {
    EveryWeek: 'every-week',
    EveryTwoWeeks: 'every-two-weeks',
} as const;

export type RepeatWeekOn = typeof RepeatWeekOn[keyof typeof RepeatWeekOn];



export const RepeatYearOn = {
    Day: 'day',
    Week: 'week',
} as const;

export type RepeatYearOn = typeof RepeatYearOn[keyof typeof RepeatYearOn];



export const RepeatableCaseInterval = {
    Daily: 'daily',
    Weekly: 'weekly',
    Monthly: 'monthly',
    Quarterly: 'quarterly',
    Yearly: 'yearly',
} as const;

export type RepeatableCaseInterval = typeof RepeatableCaseInterval[keyof typeof RepeatableCaseInterval];


export interface ResponseAddonCardDto {
    'id': number;
    'AddonCategory': NumberIdnDto | null;
    'name': string;
    'description': string;
}
export interface ResponseAddonOrderCardDto {
    'id': number;
    'Addon'?: ResponseAddonCardDto;
    'CaseId'?: number | null;
    'Case'?: ProjectApartmentTakeoverDataAddonOrderCaseDto;
    'ClientComment'?: string | null;
    'ManagerComment'?: string | null;
    'quantity'?: number | null;
}
export interface ResponseAddonOrderStatusSummaryDto {
    'new': number;
    'accepted': number;
    'denied': number;
    'canceled': number;
}
export interface ResponseAddonSummaryDto {
    'total': number;
    'expired': number;
    'active': number;
    'contractorAddonsAwaitingApproval': number;
    'ordersByStatus': ResponseAddonOrderStatusSummaryDto;
}
export interface ResponseAddressDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'model': AllowedAddressModel;
    'type': AddressType;
    'CreatorId': number | null;
    'modelId': string;
    'line1': string;
    'line2'?: string | null;
    'postal'?: string | null;
    'countryCode': string;
    'email'?: string | null;
    'note'?: string | null;
    'reference'?: string | null;
    'placeId'?: string | null;
    'latitude'?: number | null;
    'longitude'?: number | null;
    'Creator': ResponseUserCardDto | null;
}


export interface ResponseAddressDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseAddressDto>;
}
export interface ResponseAddressDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseAddressDto;
}
export interface ResponseAgreementDto {
    'id': number;
    'CreatorId'?: number;
    'ObjectFieldId': number;
    'requireReports': boolean;
    /**
     * The role the user has
     */
    'role': string;
    /**
     * Cases linked to this agreement
     */
    'Cases'?: Array<ResponseCaseDto>;
    /**
     * Repeatable cases linked to this agreement
     */
    'RepeatableCases'?: Array<ResponseRepeatableCaseDto>;
    'ObjectId'?: ResponseObjectIDNDto;
    'name': string;
    'description'?: string;
    'active': boolean;
    'from': string;
    'to'?: string;
    'ObjectField'?: ResponseObjectFieldIdnDto | null;
    'objectName': string;
    'companyName': string;
}
export interface ResponseAgreementDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseAgreementDto>;
}
export interface ResponseAgreementDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseAgreementDto;
}
export interface ResponseAgreementDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseAgreementDto>;
}
export interface ResponseAgreementSummaryDto {
    'total': number;
    'active': number;
}
export interface ResponseArticleDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'CreatorId': number | null;
    'CompanyId': number;
    'FolderId': string | null;
    'title': string;
    'lead': string;
    'content': string;
    'Creator': ResponseUserCardDto | null;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseArticleDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseArticleDto;
}
export interface ResponseArticleDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseArticleDto>;
}
export interface ResponseArticleModelDto {
    'id': string;
    'model': AllowedArticleModel;
    'ArticleId': string;
    'modelId': string;
    'modelName': string;
    'from': string;
    'to'?: string;
    'public': boolean;
    'forClients': boolean;
}


export interface ResponseArticleModelDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseArticleModelDto>;
}
export interface ResponseArticleModelDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseArticleModelDto;
}
export interface ResponseArticleModelItemDto {
    'parent'?: ResponseIdNameAndParentDto | null;
    'model': AllowedArticleModel;
    'id': string;
    'name': string;
}


export interface ResponseArticleModelItemDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseArticleModelItemDto>;
}
export interface ResponseArticleSummaryDto {
    'total': number;
    'active': number;
}
export interface ResponseArticleUsageDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'model': AllowedArticleUsageModel;
    'modelId': string;
    'Article': ResponseArticleDto;
    'ArticleId': string;
    'name': string;
    'requireExplicitConsent': boolean;
}


export interface ResponseArticleUsageDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseArticleUsageDto>;
}
export interface ResponseArticleUsageDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseArticleUsageDto;
}
export interface ResponseAssumeUserDto {
    'id': number;
    'name': string;
    'mail': string;
    'Company'?: ResponseCompanyIDNDto;
}
export interface ResponseAssumeUserDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseAssumeUserDto>;
}
export interface ResponseCaseCategoryDto {
    'id': number;
    'name': string;
}
export interface ResponseCaseCategorySummaryDto {
    'preInspection': number;
    'takeoverInspection': number;
    'oneYearInspection': number;
    'claim': number;
    'request': number;
    'completionInspection': number;
    'inspectionCommonArea': number;
    'task': number;
    'projecting': number;
    'other': number;
    'hse': number;
    'qa': number;
    'addon': number;
    'operations': number;
    'maintenance': number;
    'deviation': number;
    'safetyInspection': number;
    'trialOperations': number;
    'startUp': number;
    'mom': number;
    'energyReading': number;
    'movingIn': number;
    'movingOut': number;
}
export interface ResponseCaseContractorStatusSummaryDto {
    'declined': number;
    'new': number;
    'accepted': number;
    'completed': number;
}
export interface ResponseCaseDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'location': string | null;
    'deadlineAt': string;
    'FieldId'?: number;
    'name': string;
    'description': string | null;
    'completedAt': string | null;
    'Creator'?: PrintCreatorDto;
    'Field'?: ResponseFieldIDNDto;
    'ObjectId'?: ResponseObjectIDNDto;
    'CaseManager'?: UserPrintDto;
    'Contractors'?: Array<ContractorPrintDto>;
    'Client'?: ResponseUserCardDto;
    'Object'?: CaseObjectPrintDto;
    'Apartment'?: CaseApartmentPrintDto;
    'FileUsages'?: Array<ResponseFileUsageDto>;
    'Markings'?: Array<ResponseMarkingDto>;
    'Checklist'?: ChecklistPrintDto;
    'CaseLogs'?: Array<ResponseCaseLogDto>;
    'Tenancy'?: TenancyPrintDto;
    'ObjectOwnership'?: ObjectOwnershipPrintDto;
}
export interface ResponseCaseLogDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'CaseId': number;
    'CreatorId': number | null;
    'EmailId'?: number;
    'translateVars': { [key: string]: string; };
    'Creator'?: ResponseUserCardDto;
    'Email'?: ResponsePortalCaseLogEmailDto;
    'message': string | null;
    'status': number;
    'kt': number;
    'creatorRole': number;
    'forClient': number;
    'forContractor': number;
    'error': boolean;
    'system': boolean;
    'translate': boolean;
}
export interface ResponseCaseSummaryDto {
    'total': number;
    'open': number;
    'completed': number;
    'unread': number;
    'overdue': number;
    'withoutCaseManager': number;
    'withoutContractor': number;
    'withoutField': number;
    'deadlineToday': number;
    'archived': number;
    /**
     * Object with field as key and amount of cases as value
     */
    'byField': { [key: string]: number; };
    'statusesByContractor': ResponseCaseContractorStatusSummaryDto;
    'byCategory': ResponseCaseCategorySummaryDto;
}
export interface ResponseChecklistDto {
    'CompanyId': number;
    'CategoryId': number | null;
    'sortOrder': number;
    'ObjectId': number;
    'CaseManagerId': number | null;
    'ProjectId': number | null;
    'FieldId': number;
    'ObjectFieldId': number;
    'ApartmentId': number;
    'openItems': number;
    'itemsCompletedAt': string | null;
    'deviationsCompletedAt': string | null;
    'name': string;
    'description': string | null;
    'caseCount': number;
    'openDeviations': number;
    'closedDeviations': number;
}
export interface ResponseChecklistDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistDto;
}
export interface ResponseChecklistDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistDto>;
}
export interface ResponseChecklistItemDto {
    'id': number;
    'ChecklistTemplateItemId': number;
    'SectionId': number;
    'CaseId': number;
    'sortOrder': number;
    'note': string;
    'notApplicable': boolean;
    'checklistItemType'?: ChecklistItemType;
    'value': string;
    'selectOptions'?: Array<string> | null;
}


export interface ResponseChecklistItemDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistItemDto;
}
export interface ResponseChecklistItemDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistItemDto>;
}
export interface ResponseChecklistSectionDto {
    'CreatorId': number;
    'ChecklistId': number;
    'ChecklistTemplateSectionId': number;
    'ParentId': number | null;
    'description': string;
    'sortOrder': number;
    'name': string;
}
export interface ResponseChecklistSectionDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistSectionDto;
}
export interface ResponseChecklistSectionDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistSectionDto>;
}
export interface ResponseChecklistSummaryDto {
    'total': number;
    'open': number;
    'completed': number;
    /**
     * Object with field as key and count as value
     */
    'fieldsCount': { [key: string]: number; };
    'byCategory': ResponseCaseCategorySummaryDto;
}
export interface ResponseChecklistTemplateDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'creatorId': number | null;
    'CompanyId': number;
    'CategoryId': number;
    'CreatorId': number | null;
    'name': string;
    'description': string | null;
    'customerAccess': boolean;
}
export interface ResponseChecklistTemplateDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistTemplateDto;
}
export interface ResponseChecklistTemplateDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistTemplateDto>;
}
export interface ResponseChecklistTemplateItemDto {
    'id': number;
    'ChecklistTemplateId': number;
    'SectionId': number | null;
    'CreatorId': number | null;
    'CategoryId': number;
    'sortOrder': number;
    'fieldId': number;
    'data': object;
    'checklistItemType'?: ChecklistItemType;
    'name': string;
    'description': string | null;
    'selectOptions'?: Array<string> | null;
}


export interface ResponseChecklistTemplateItemDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistTemplateItemDto;
}
export interface ResponseChecklistTemplateItemDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistTemplateItemDto>;
}
export interface ResponseChecklistTemplateSectionDto {
    'CreatorId': number | null;
    'ChecklistTemplateId': number;
    'ParentId': number | null;
    'name': string;
    'description': string;
    'sortOrder': number;
}
export interface ResponseChecklistTemplateSectionDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseChecklistTemplateSectionDto;
}
export interface ResponseChecklistTemplateSectionDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseChecklistTemplateSectionDto>;
}
export interface ResponseClonedChecklistTemplateDto {
    'id': number;
}
export interface ResponseClonedChecklistTemplateDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseClonedChecklistTemplateDto;
}
export interface ResponseCompanyConsentCollectionItemDto {
    'id': string;
    'CompanyId': number;
    'canEdit': boolean;
    'approved': boolean;
    'name': string;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseCompanyConsentCollectionItemDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseCompanyConsentCollectionItemDto>;
}
export interface ResponseCompanyConsentCompanyConsentDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'approved': boolean;
    'id': string;
    'UserId': number;
    'CompanyConsentCompanyId': string;
    'User': ResponseUserCardDto;
    'data': CompanyConsentCompanyConsentDataDto;
}
export interface ResponseCompanyConsentCompanyConsentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCompanyConsentCompanyConsentDto;
}
export interface ResponseCompanyConsentCompanyContactDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'UserId': number;
    'CompanyConsentCompanyId': string;
    'User': ResponseUserCardDto;
    'CompanyConsentCompany'?: ResponseCompanyConsentCompanyDto;
}
export interface ResponseCompanyConsentCompanyContactDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCompanyConsentCompanyContactDto;
}
export interface ResponseCompanyConsentCompanyContactDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseCompanyConsentCompanyContactDto>;
}
export interface ResponseCompanyConsentCompanyDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'CompanyConsentId': string;
    'CompanyId': number;
    'allowAdmins': boolean;
    'requireAllContacts': boolean;
    'canConsent': boolean;
    'approved': boolean;
    'CompanyConsentCompanyContacts': Array<ResponseCompanyConsentCompanyContactDto>;
    'CompanyConsentCompanyConsents': Array<ResponseCompanyConsentCompanyConsentDto>;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseCompanyConsentCompanyDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCompanyConsentCompanyDto;
}
export interface ResponseCompanyConsentCompanyDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseCompanyConsentCompanyDto>;
}
export interface ResponseCompanyConsentDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'CompanyId': number;
    'canEdit': boolean;
    'approved': boolean;
    'name': string;
    'Company': ResponseCompanyIDNDto;
    'CompanyConsentCompanies': Array<ResponseCompanyConsentCompanyDto>;
}
export interface ResponseCompanyConsentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCompanyConsentDto;
}
export interface ResponseCompanyConsentIDNDto {
    'id': string;
    'name': string;
    'Company': ResponseCompanyIDNDto | null;
}
export interface ResponseCompanyConsentIDNDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseCompanyConsentIDNDto>;
}
export interface ResponseCompanyIDNDto {
    'id': number;
    'name': string;
}
export interface ResponseCompanyIDNDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseCompanyIDNDto>;
}
export interface ResponseCompanyTakeoverSettingsDto {
    'caseListCategories'?: Array<number>;
    'caseProtocolCategories'?: Array<number>;
    'caseListShowOpen'?: boolean;
    'caseListShowCompleted'?: boolean;
    'caseProtocolShowOpen'?: boolean;
    'caseProtocolShowCompleted'?: boolean;
    'caseProtocolIgnoreCasesFromData'?: boolean;
}
export interface ResponseContractorSetStatusDto {
    'status': CaseContractorStatus;
}


export interface ResponseContractorSetStatusDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseContractorSetStatusDto;
}
export interface ResponseContractorStatusDto {
    'fieldId': number;
    'completion': boolean;
    'id': number;
    'name': string;
}
export interface ResponseContractorStatusReportDto {
    'meta': ResponseContractorStatusReportMetaDto;
    'fields': Array<NumberIdnDto>;
    'contractors': Array<ResponseContractorStatusDto>;
    'folders': ResponseContractorStatusReportFoldersDto;
    'fileCreators': Array<ResponseUserIdnDto>;
}
export interface ResponseContractorStatusReportDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseContractorStatusReportDto;
}
export interface ResponseContractorStatusReportFolderDto {
    'folders': Array<ResponseFolderDto>;
    'files': Array<ResponseFileDto>;
}
export interface ResponseContractorStatusReportFoldersDto {
    'project': ResponseContractorStatusReportFolderDto;
    'apartments': ResponseContractorStatusReportFolderDto;
    /**
     * Map of ProjectApartmentId to array of folder ids pointing to field folders
     */
    'apartmentFieldFolderIdsMap': { [key: string]: Array<string>; };
}
export interface ResponseContractorStatusReportMetaDto {
    'countApartments': number;
    'countFields': number;
    'countContractors': number;
    'countContractorsCompleted': number;
}
export interface ResponseCountryDto {
    'country': string;
    'alpha2': string;
    'alpha3': string;
    'num3': string;
}
export interface ResponseCountryDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseCountryDto>;
}
export interface ResponseCpiYearlyAdjustmentDto {
    'from': ResponseYearMonthValueDto;
    'to': ResponseYearMonthValueDto;
    'country': CpiCountryCode;
    'value': number;
    'percent': number;
    'stepsFromMonth': number;
}


export interface ResponseCpiYearlyAdjustmentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCpiYearlyAdjustmentDto;
}
export interface ResponseCrmUserDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'dateOfBirth'?: string;
    'CompanyId': number;
    'UserId'?: number;
    'firstName': string;
    'lastName': string;
    'mail'?: string;
    'mobile'?: string;
    'addressLine1'?: string;
    'addressLine2'?: string;
    'city'?: string;
    'postal'?: string;
    'country'?: string;
    'language'?: string;
    'Company': ResponseCompanyIDNDto;
    'User'?: ResponseUserCardDto;
    'UserInvites'?: Array<ResponseUserInviteDto>;
}
export interface ResponseCrmUserDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseCrmUserDto;
}
export interface ResponseCrmUserDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseCrmUserDto>;
}
export interface ResponseFieldDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'name': string;
    'CompanyId': number;
    /**
     * A hexadecimal color with leading # like your browser likes
     */
    'color'?: string | null;
    'status': number;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseFieldDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFieldDto;
}
export interface ResponseFieldDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseFieldDto>;
}
export interface ResponseFieldIDNDto {
    'id': number;
    'name': string;
    /**
     * A hexadecimal color with leading # like your browser likes
     */
    'color'?: string | null;
}
export interface ResponseFieldIDNDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseFieldIDNDto>;
}
export interface ResponseFieldSummaryDto {
    'total': number;
    'hasContractor': number;
    'missingContractor': number;
}
export interface ResponseFileDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    /**
     * MIME type of the File
     */
    'type': string | null;
    /**
     * File size in bytes
     */
    'size': number;
    /**
     * S3 Path
     */
    'path': string;
    'CreatorId': number | null;
    'Creator': ResponseUserCardDto | null;
    'CompanyId': number | null;
    'FolderId': string | null;
    'name': string;
    'description': string | null;
    'signed': ResponseFileSignedDto;
    'eTag': string | null;
    'Company': ResponseCompanyIDNDto | null;
}
export interface ResponseFileDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseFileDto>;
}
export interface ResponseFileSignedDto {
    'url': string;
    'withDispositionUrl': string;
    'imageUrl'?: string | null;
    'thumbnailUrl'?: string | null;
    'imageUrl1k'?: string | null;
}
export interface ResponseFileSigningPolicyDto {
    'acl': SigningPolicyACL;
    'mimeType'?: MimeType;
    'awsAccessKeyId': string;
    'bucket': string;
    'bucketUrl': string;
    'key': string;
    'policy': string;
    'signature': string;
    'type': string;
    'xAmzMetaFilename': string;
}


export interface ResponseFileSigningPolicyDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFileSigningPolicyDto;
}
export interface ResponseFileUsageDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'UserId'?: number | null;
    'User': ResponseUserCardDto | null;
    'FileId': number;
    'fileName': string;
    'fileSort': number;
    'self': ResponseFileUsageDtoSelfEnum;
    'selfId': string;
    'name': string;
    'File': ResponseFileDto;
}

export const ResponseFileUsageDtoSelfEnum = {
    Apex: 'apex',
    Customer: 'customer',
    User: 'user',
    Consent: 'consent',
    Massmailing: 'massmailing',
    Addon: 'addon',
    AddonCart: 'addon-cart',
    AddonCategoryProject: 'addon-category-project',
    AddonOrder: 'addon-order',
    AddonProject: 'addon-project',
    ContractorAddon: 'contractor-addon',
    Object: 'object',
    ObjectFieldReport: 'object-field-report',
    Agreement: 'agreement',
    Tenancy: 'tenancy',
    Project: 'project',
    Apartment: 'apartment',
    ProjectApartmentTakeover: 'project-apartment-takeover',
    Takeover: 'takeover',
    Inspection: 'inspection',
    Case: 'case',
    RepeatableCase: 'repeatable-case',
    Request: 'request',
    Checklist: 'checklist',
    ChecklistItem: 'checklist-item',
    ChecklistTemplate: 'checklist-template',
    ChecklistTemplateItem: 'checklist-template-item',
    UnwantedIncident: 'unwanted-incident',
    Signing: 'signing',
    Article: 'article',
    TakeoverSupplierOption: 'takeover-supplier-option',
} as const;

export type ResponseFileUsageDtoSelfEnum = typeof ResponseFileUsageDtoSelfEnum[keyof typeof ResponseFileUsageDtoSelfEnum];

export interface ResponseFileUsageDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseFileUsageDto>;
}
export interface ResponseFileUsageDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFileUsageDto;
}
export interface ResponseFolderAccessMetaDto {
    'view': boolean;
    'collaborator': boolean;
    'edit': boolean;
    'owner': boolean;
}
export interface ResponseFolderDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'modelName': FolderModel;
    'name': string;
    'description': string | null;
    'ParentId': string | null;
    'modelId': number | null;
    'accessMeta'?: ResponseFolderAccessMetaDto;
    'Parents'?: Array<ResponseFolderIdnDto>;
}


export interface ResponseFolderDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseFolderDto>;
}
export interface ResponseFolderDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFolderDto;
}
export interface ResponseFolderDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseFolderDto>;
}
export interface ResponseFolderFieldMappingDto {
    'id': string;
    'ObjectFieldId': number;
}
export interface ResponseFolderFieldMappingDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFolderFieldMappingDto;
}
export interface ResponseFolderIdnDto {
    'id': string;
    'ParentId': string | null;
    'name': string;
}
export interface ResponseFolderInfoDto {
    'id': string;
    'modelName': FolderModel;
    'ParentId': string | null;
    'name': string;
    'description': string | null;
    'modelId': number | null;
    'accessMeta': ResponseFolderAccessMetaDto;
    'tree': Array<ResponseFolderIdnDto>;
}


export interface ResponseFolderInfoDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseFolderInfoDto;
}
export interface ResponseFolderItemDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'type': FolderItemType;
    'modelName': FolderModel;
    'id': string;
    'name': string;
    'modelId': number | null;
    'isEmpty'?: boolean;
    'shared': boolean;
    'signed'?: ResponseFileSignedDto;
}


export interface ResponseFolderItemDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseFolderItemDto>;
}
export interface ResponseHashDto {
    /**
     * A HEX representation of the hashed value according to provided algorithm
     */
    'hash': string;
}
export interface ResponseHashDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseHashDto;
}
export interface ResponseHelpUrlDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'path': string;
    'url': string;
    'language': string;
}
export interface ResponseHelpUrlDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseHelpUrlDto>;
}
export interface ResponseHelpUrlDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseHelpUrlDto;
}
export interface ResponseIdNameAndParentDto {
    'parent'?: ResponseIdNameAndParentDto | null;
    'id': string;
    'name': string;
}
export interface ResponseInspectionSummaryDto {
    'total': number;
    'byCategory': ResponseCaseCategorySummaryDto;
}
export interface ResponseLoginDto {
    'destination': AuthDestination;
    'accessToken': string;
    'userId': number;
    'companyId': number | null;
    'success': boolean;
}


export interface ResponseLogoutDto {
    'success': boolean;
}
export interface ResponseMainObjectSellerDto {
    'logos': Array<ResponseFileUsageDto>;
    'name': string;
    'companyIdentification': string;
}
export interface ResponseMarkingDataDto {
    'imageWidth'?: number;
    'imageHeight'?: number;
}
export interface ResponseMarkingDto {
    'id': number;
    'CreatorId': number | null;
    'model': MarkingModel;
    'FileUsageId': number;
    'icon': string | null;
    'geometry': GeometryDto;
    'Creator'?: ResponseUserIdnDto;
    'modelId': number;
    'FileUsage'?: ResponseFileUsageDto;
    'correct': boolean;
    'data': ResponseMarkingDataDto;
}


export interface ResponseMeterSummaryDto {
    'total': number;
    'inWarning': number;
    'inError': number;
}
export interface ResponseMeteringPointStatusDto {
    'status': MeteringPointStatus;
}


export interface ResponseMeteringPointStatusDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseMeteringPointStatusDto;
}
export interface ResponseModelTraitDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'model': ModelTraitModel;
    'CreatorId'?: number | null;
    'Creator'?: ResponseUserIdnDto;
    'modelId': string;
    'name': string;
    'value': string;
    'public'?: boolean;
}


export interface ResponseModelTraitDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseModelTraitDto>;
}
export interface ResponseModelTraitDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseModelTraitDto;
}
export interface ResponseModelTraitDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseModelTraitDto>;
}
export interface ResponseNearbyUnwantedIncidentProjectDto {
    'type': UnwantedIncidentProjectType;
    'id': number;
    'name': string;
    'constructionSiteName': string;
    'distance': number;
    'Company': ResponseCompanyIDNDto;
}


export interface ResponseNearbyUnwantedIncidentProjectDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseNearbyUnwantedIncidentProjectDto>;
}
export interface ResponseNeedToConsentForRequestsForApartmentDto {
    /**
     * Indicates if the user needs to give consent for requests for this apartment
     */
    'requiresConsentForRequests': boolean;
    /**
     * The article that the user needs to consent to for requests for this apartment
     */
    'requiresConsentForRequestsArticle': ResponseArticleDto | null;
    /**
     * Indicates if the user explicitly needs to give consent for requests
     */
    'requiresExplicitConsent': boolean;
}
export interface ResponseNeedToConsentForRequestsForApartmentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseNeedToConsentForRequestsForApartmentDto;
}
export interface ResponseNewProjectApartmentTakeoverDto {
    'apartment': ResponseProjectApartmentCardDto;
    'project': ResponseProjectCardDto;
    'meters': Array<ResponseProjectApartmentMeterCardDto>;
    'involved': Array<ResponseProjectApartmentTakeoverInvolvedDto>;
    'addonOrders': Array<ResponseAddonOrderCardDto>;
    'protocolRecipients': Array<ProjectApartmentTakeoverDestinationDto>;
    'supplierOptions': Array<ResponseTakeoverSupplierOptionDto>;
    'simultaneousSigners': Array<ProjectApartmentTakeoverSimultaneousSignerDto>;
    'files': ResponseProjectApartmentTakeoverFilesDto;
    'articleUsages': Array<ResponseArticleUsageDto>;
    'companyTakeoverSettings': ResponseCompanyTakeoverSettingsDto;
    'seller': ResponseMainObjectSellerDto;
}
export interface ResponseNewProjectApartmentTakeoverDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseNewProjectApartmentTakeoverDto;
}
export interface ResponseNotificationTokenDto {
    'token': string;
}
export interface ResponseNotificationTokenDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseNotificationTokenDto;
}
export interface ResponseObjectFieldDto {
    'id': number;
    'ObjectId'?: number | null;
    'FieldId': number | null;
    'Field': ResponseFieldDto | null;
    'name': string | null;
    'color': string | null;
    'description': string | null;
    'CreatorId': number | null;
    'Object'?: ResponseObjectIDNDto;
    'Contractors'?: Array<ResponseUserDto>;
}
export interface ResponseObjectFieldDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseObjectFieldDto;
}
export interface ResponseObjectFieldFolderDto {
    'id': string;
    'files': Array<ResponseFileDto>;
    'name': string;
    'description': string | null;
}
export interface ResponseObjectFieldIdnDto {
    'id': number;
    'name': string | null;
    'color': string | null;
}
export interface ResponseObjectFieldReportDto {
    'id': number;
    'ObjectId': number;
    'ObjectFieldId': number;
    'CreatorId': number;
    'FileUsageId': number | null;
    'from': string;
    'to': string;
    'hash': string | null;
    'FileUsage': ResponseFileUsageDto;
}
export interface ResponseObjectFieldReportDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectFieldReportDto>;
}
export interface ResponseObjectFieldReportDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseObjectFieldReportDto;
}
export interface ResponseObjectFieldSummaryDto {
    'total': number;
    'hasContractor': number;
    'missingContractor': number;
}
export interface ResponseObjectFileUsageSummaryDto {
    'total': number;
    'files': number;
    'bannerImages': number;
    'floorplans': number;
    'inspection': number;
    'fdv': number;
}
export interface ResponseObjectIDNDto {
    'id': number;
    'name': string;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseObjectIDNDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectIDNDto>;
}
export interface ResponseObjectInvolvedDto {
    /**
     * The object the user is involved on
     */
    'objectName': string;
    /**
     * The role the user has
     */
    'role': string;
    /**
     * Indicates if role should be translated
     */
    'translateRole': boolean;
    'name': string;
    'email': string;
    'mobile': string;
}
export interface ResponseObjectInvolvedDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectInvolvedDto>;
}
export interface ResponseObjectInvolvedSummaryDto {
    'total': number;
    'caseManager': number;
    'contact': number;
    'custodian': number;
    'projectManager': number;
    'unwantedIncidentManager': number;
    'responsibleWithinUs': number;
}
export interface ResponseObjectInvolvedUserDto {
    'id': number;
    'role': ObjectInvolvedUser;
    'companyId': number;
    'fieldId'?: number;
    'agreementId'?: number;
    'name': string;
    'companyName': string;
    'fieldName'?: string;
    'fieldColor'?: string | null;
    'agreementName'?: string;
}


export interface ResponseObjectInvolvedUserDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectInvolvedUserDto>;
}
export interface ResponseObjectObjectFieldReportDto {
    'cases': Array<CasePrintDto>;
    'inspections': Array<InspectionPrintDto>;
    'folders': Array<ResponseObjectFieldFolderDto>;
    'object'?: ObjectPrintDto;
    'objectField'?: ResponseObjectFieldIdnDto;
    'from': string;
    'to': string;
}
export interface ResponseObjectObjectFieldReportDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectObjectFieldReportDto>;
}
export interface ResponseObjectParentIdnDto {
    'id': number;
    'ParentId': number;
    'name': string;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseObjectParentIdnDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseObjectParentIdnDto>;
}
export interface ResponseObjectSummaryDto {
    'meter': ResponseMeterSummaryDto;
    'tenancy': ResponseTenancySummaryDto;
    'agreement': ResponseAgreementSummaryDto;
    'inspection': ResponseInspectionSummaryDto;
    'checklist': ResponseChecklistSummaryDto;
    'checklistGroup': ResponseChecklistSummaryDto;
    'ownership': ResponseOwnershipSummaryDto;
    'sale': ResponseSaleSummaryDto;
    'field': ResponseObjectFieldSummaryDto;
    'repeatableCase': ResponseRepeatableCaseSummaryDto;
    'involved': ResponseObjectInvolvedSummaryDto;
    'fileUsage': ResponseObjectFileUsageSummaryDto;
    'case': ResponseCaseSummaryDto;
    'unwantedIncident': ResponseUnwantedIncidentSummaryDto;
    'article': ResponseArticleSummaryDto;
}
export interface ResponseObjectSummaryDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseObjectSummaryDto;
}
export interface ResponseObjectUnwantedIncidentInfoDto {
    'id': number;
    'name': string;
    'address'?: string;
    'zipcode'?: number;
    'floorPlans'?: Array<ResponseFileUsageDto>;
}
export interface ResponseObjectUnwantedIncidentInfoDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseObjectUnwantedIncidentInfoDto;
}
export interface ResponseOwnershipSummaryDto {
    'total': number;
}
export interface ResponsePortalAddonApartmentDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'AddonId': number;
    'Addon': ResponsePortalAddonDto;
    'ProjectApartmentId': number;
    'ContractorId': number;
    'CreatorId': number;
    'filterFileUsage'?: Array<number> | null;
    'amount': number | null;
    'dateStart': string;
    'dateEnd': string | null;
    'unit': string | null;
    'unitPriceIn': number | null;
    'unitPrice': boolean;
    'priceIn': number;
    'priceOut': number;
    'VAT': number;
    'markingMin': number | null;
    'markingMax': number | null;
    'standardForCategory': boolean;
    'requireApproval': boolean;
    'requireSignature': boolean;
}
export interface ResponsePortalAddonApartmentDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponsePortalAddonApartmentDto>;
}
export interface ResponsePortalAddonDto {
    'id': number;
    'CompanyId': number;
    'CreatorId': number;
    'name': string;
}
export interface ResponsePortalAddonOrderDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'status': AddonOrderStatus;
    'ClientId': number;
    'ClientComment'?: string | null;
    'seller': string;
    'sellerOrgnr': string;
    'dateProcessed'?: string | null;
    'dateSignature'?: string | null;
    'ManagerId'?: number | null;
    'ManagerComment'?: string | null;
    'ProjectApartmentId': number;
    'AddonApartmentId': number;
    'AddonApartment': ResponsePortalAddonApartmentDto;
    'AddonId': number;
    'Addon': ResponsePortalAddonDto;
    'CartId'?: number | null;
    'Markings'?: Array<ResponseMarkingDto>;
    'priceIn': number;
    'priceOut': number;
    'VAT': number;
    'quantity'?: number | null;
    'CaseId'?: number | null;
    'invoiced'?: number | null;
}


export interface ResponsePortalAddonOrderDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponsePortalAddonOrderDto>;
}
export interface ResponsePortalApartmentDto {
    'id': number;
    'ProjectId': number;
    /**
     * Indicates if there are any available Addons or AddonPackages for this apartment
     */
    'hasAvailableAddonOrAddonPackage': boolean;
    /**
     * Indicates if the apartment has any AddonOrders or AddonPackageOrders
     */
    'hasOrderForAddonOrAddonPackage': boolean;
    'name': string;
    'Project': ResponsePortalApartmentProjectDto;
    'primarySpaceSquareMeter': number;
    'sectionNumber': string | null;
    'unitType': string | null;
    'takeoverAt': string | null;
    'model': string | null;
    'disableRequests': boolean;
    'Clients': Array<ResponseUserCardDto>;
    'Traits': Array<ResponseModelTraitDto>;
    'Addresses'?: Array<ResponseAddressDto>;
}
export interface ResponsePortalApartmentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponsePortalApartmentDto;
}
export interface ResponsePortalApartmentProjectDto {
    'id': number;
    'CompanyId': number;
    'name': string;
    'Company': ResponseCompanyIDNDto;
    'projectOwner': string | null;
    'projectOwnerOrgnr': string | null;
    'disableRequests': boolean | null;
}
export interface ResponsePortalArticleDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'CreatorId': number | null;
    'publishedDate'?: string;
    'title': string;
    'lead': string;
    'content': string;
    'Creator': ResponseUserCardDto | null;
    'Images': Array<ResponsePortalFileUsageDto>;
    'Files': Array<ResponsePortalFileUsageDto>;
}
export interface ResponsePortalArticleDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponsePortalArticleDto>;
}
export interface ResponsePortalCaseDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'archivedAt': string | null;
    'id': number;
    'deadlineAt': string;
    'completedAt': string;
    'FieldId'?: number;
    'CaseCategoryId': number;
    'AddonOrderId': number;
    'read': boolean;
    'ApartmentId'?: number;
    'ProjectId'?: number;
    'mergedTo'?: boolean | null;
    'disableMessages': boolean;
    'name': string;
    'description': string;
    'location': string;
    'Field'?: ResponseFieldIDNDto;
    'CaseCategory': ResponseCaseCategoryDto;
    'FileUsages': Array<ResponsePortalFileUsageDto>;
}
export interface ResponsePortalCaseDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponsePortalCaseDto>;
}
export interface ResponsePortalCaseLogDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'EmailId'?: number;
    'translateVars': { [key: string]: string; };
    'CreatorId': number | null;
    'message': string;
    'Email'?: ResponsePortalCaseLogEmailDto;
    'system': boolean;
    'translate': boolean;
    'Creator'?: ResponseUserCardDto;
}
export interface ResponsePortalCaseLogDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponsePortalCaseLogDto;
}
export interface ResponsePortalCaseLogDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponsePortalCaseLogDto>;
}
export interface ResponsePortalCaseLogEmailDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'fromEmail': string;
    'fromName': string;
    'subject': string;
    'bodyPlain': string;
    'bodyHTML': string;
}
export interface ResponsePortalFileDto {
    'createdAt': string;
    'updatedAt': string;
    'id': number;
    /**
     * MIME type of the File
     */
    'type': string | null;
    /**
     * File size in bytes
     */
    'size': number;
    'signed': ResponseFileSignedDto;
    'name': string;
    'description': string | null;
}
export interface ResponsePortalFileUsageDto {
    'createdAt': string;
    'updatedAt': string;
    'id': number;
    'File': ResponsePortalFileDto;
    'fileName': string;
    'fileSort': number;
}
export interface ResponsePortalFileUsageDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponsePortalFileUsageDto>;
}
export interface ResponsePortalMainObjectDto {
    'seller': ResponseMainObjectSellerDto;
    'Project'?: ResponseProjectIDNDto | null;
    'bannerImages': Array<ResponsePortalFileUsageDto>;
    'id': string;
    'name': string;
    'address'?: string;
    'zip'?: string;
    'postal'?: string;
    'type': ResponsePortalMainObjectDtoTypeEnum;
    'Addresses'?: Array<ResponseAddressDto>;
}

export const ResponsePortalMainObjectDtoTypeEnum = {
    ProjectApartment: 'project-apartment',
    Tenancy: 'tenancy',
    Ownership: 'ownership',
} as const;

export type ResponsePortalMainObjectDtoTypeEnum = typeof ResponsePortalMainObjectDtoTypeEnum[keyof typeof ResponsePortalMainObjectDtoTypeEnum];

export interface ResponsePortalMainObjectDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponsePortalMainObjectDto>;
}
export interface ResponseProjectApartmentCardDto {
    'id': number;
    'agreementType': ProjectApartmentAgreementType;
    'name': string | null;
    'sectionNumber': string | null;
    'fieldNumber': string | null;
    'titleNumber': string | null;
    'municipalityLandNumber': string | null;
    'takeoverDateUnix': number;
    'parkingLot': string | null;
    'storageRoomNumber': string | null;
    'unitType': string | null;
    'typeModel': string | null;
    'modelTraits'?: Array<ResponseModelTraitDto>;
    'Addresses'?: Array<ResponseAddressDto>;
}


export interface ResponseProjectApartmentCardDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseProjectApartmentCardDto>;
}
export interface ResponseProjectApartmentClientDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'ApartmentId': number;
    'CrmUserId': string;
    'CrmUser': ResponseCrmUserDto;
    'ProjectApartment': ResponseProjectApartmentCardDto;
}
export interface ResponseProjectApartmentClientDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseProjectApartmentClientDto;
}
export interface ResponseProjectApartmentClientDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseProjectApartmentClientDto>;
}
export interface ResponseProjectApartmentClientSummaryDto {
    'total': number;
    'invited': number;
    'accepted': number;
}
export interface ResponseProjectApartmentMeterCardDto {
    'type': MeterType;
    'number': string | null;
    'externalNumber'?: string;
    'value'?: number;
}


export interface ResponseProjectApartmentSummaryDto {
    'total': number;
    'hasOwner': number;
    'noOwners': number;
    'sold': number;
    'notSold': number;
    'includedInSalesReporting': number;
    'takeoverDatePast': number;
    'takeoverDateToday': number;
    'takeoverDateFuture': number;
    'unitTypeCount': { [key: string]: number; };
    /**
     * Object with field name as key and count as value
     */
    'fieldNumberCount': { [key: string]: number; };
}
export interface ResponseProjectApartmentTakeoverDestinationDto {
    'contentType': ProjectTakeoverDestinationContentTypeToken;
    'recipientName': string;
    'recipientDestination'?: string;
}


export interface ResponseProjectApartmentTakeoverDestinationDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseProjectApartmentTakeoverDestinationDto>;
}
export interface ResponseProjectApartmentTakeoverDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'ProjectId': number;
    'ApartmentId': number;
}
export interface ResponseProjectApartmentTakeoverDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseProjectApartmentTakeoverDto;
}
export interface ResponseProjectApartmentTakeoverFilesDto {
    'temporaryUsePermits'?: Array<ResponseFileUsageDto>;
    'certificatesOfCompletion'?: Array<ResponseFileUsageDto>;
    'amendmentAgreements'?: Array<ResponseFileUsageDto>;
}
export interface ResponseProjectApartmentTakeoverInvolvedDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'mail': string;
    'CompanyId': number | null;
    'role': ProjectApartmentTakeoverInvolvedUserRole;
    'report': boolean;
    'present': boolean;
    'signer': boolean;
    'proxy': boolean;
    'name': string;
    'mobile': string | null;
    'address': string | null;
    'zip': string | null;
    'city': string | null;
    'state': string | null;
    'gender': string | null;
    'dateOfBirth': string | null;
    'organizationalNumber': string | null;
    'mailNewCase': boolean;
    'mailNewMessage': boolean;
    'Company'?: ResponseCompanyIDNDto;
}


export interface ResponseProjectCardDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'TakeoverNewChecklistTemplateId'?: number | null;
    'TakeoverUsedChecklistTemplateId'?: number | null;
    'name': string | null;
    'projectOwner': string | null;
    'projectOwnerCompanyIdentification': string | null;
    'meterPowerMail'?: string | null;
    'meterWarmWaterMail'?: string | null;
    'meterColdWaterMail'?: string | null;
    'meterDistrictHeatingMail'?: string | null;
    'meterPowerLineMail'?: string | null;
    'meterGasMail'?: string | null;
    'countryCode': string;
}
export interface ResponseProjectFileUsageSummaryDto {
    'total': number;
    'approvedFrameworkApplications': number;
    'certificatesOfCompletion': number;
    'files': number;
    'floorplans': number;
    'inspection': number;
    'logos': number;
    'publicFiles': number;
    'temporaryUsePermits': number;
    'zoningPlans': number;
    'fieldReport': number;
}
export interface ResponseProjectIDNDto {
    'id': number;
    'name': string;
    'Company': ResponseCompanyIDNDto;
}
export interface ResponseProjectInvolvedSummaryDto {
    'total': number;
    'caseManager': number;
    'unwantedIncidentManager': number;
    'addonManager': number;
    'simultaneousSigner': number;
}
export interface ResponseProjectInvolvedUserDto {
    'id': number;
    'role': ProjectInvolvedUser;
    'companyId': number;
    'fieldId'?: number;
    'name': string;
    'companyName': string;
    'fieldName'?: string;
    'fieldColor'?: string;
}


export interface ResponseProjectInvolvedUserDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseProjectInvolvedUserDto>;
}
export interface ResponseProjectMomSummaryDto {
    'total': number;
    'active': number;
    /**
     * Object with field name as key and count as value
     */
    'collaboratorsByField': { [key: string]: number; };
}
export interface ResponseProjectSummaryDto {
    'apartment': ResponseProjectApartmentSummaryDto;
    'client': ResponseProjectApartmentClientSummaryDto;
    'inspection'?: ResponseInspectionSummaryDto | null;
    'checklist': ResponseChecklistSummaryDto;
    'checklistGroup': ResponseChecklistSummaryDto;
    'field': ResponseFieldSummaryDto;
    'fileUsage': ResponseProjectFileUsageSummaryDto;
    'projectMom': ResponseProjectMomSummaryDto;
    'addon'?: ResponseAddonSummaryDto | null;
    'involved': ResponseProjectInvolvedSummaryDto;
    'unwantedIncident': ResponseUnwantedIncidentSummaryDto;
    'case': ResponseCaseSummaryDto;
    'article': ResponseArticleSummaryDto;
    'repeatableCase': ResponseRepeatableCaseSummaryDto;
}
export interface ResponseProjectSummaryDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseProjectSummaryDto;
}
export interface ResponseProjectUnwantedIncidentInfoDto {
    'id': number;
    'name': string | null;
    'addresses': Array<ResponseAddressDto>;
    'floorPlans'?: Array<ResponseFileUsageDto>;
}
export interface ResponseProjectUnwantedIncidentInfoDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseProjectUnwantedIncidentInfoDto;
}
export interface ResponseRepeatableCaseDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'CreatorId': number;
    /**
     * Case data stored as JSONB
     */
    'case': object;
    'interval': RepeatableCaseInterval;
    'endDate': string | null;
    'createCaseTime': CreateCaseTime;
    'repeatYearOn': RepeatYearOn;
    'repeatWeekOn': RepeatWeekOn;
    'ChecklistTemplateId': number | null;
}


export interface ResponseRepeatableCaseSummaryDto {
    'total': number;
    /**
     * Object with interval as key and count as value
     */
    'byInterval': { [key: string]: number; };
}
export interface ResponseSaleSummaryDto {
    'total': number;
    'buyerIsCrmUser': number;
    'buyerIsCompany': number;
}
export interface ResponseSidebarItemPinnedDto {
    'model': SidebarModel;
    'id': string;
    'sortOrder': number;
    'modelId': string;
    'url'?: string;
    'name'?: string;
}


export interface ResponseSidebarItemPinnedDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseSidebarItemPinnedDto>;
}
export interface ResponseSidebarItemPinnedDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseSidebarItemPinnedDto;
}
export interface ResponseTakeoverSupplierOptionDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'type': TakeoverSupplierOptionType;
    'forCompany': number | null;
    'CompanyId': number;
    'name': string;
    'logo': string;
    'info': string;
    'infoLink': string;
    'terms': string;
    'termsLink': string;
    'destination': string;
    'approved': boolean;
    'countryCode': string;
    'productName': string;
    'productsLink'?: string | null;
    'b2b': boolean;
    'logos'?: Array<ResponseFileUsageDto>;
    'documents'?: ResponseTakeoverSupplierOptionsDocumentsDto;
}


export interface ResponseTakeoverSupplierOptionDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseTakeoverSupplierOptionDto>;
}
export interface ResponseTakeoverSupplierOptionsDocumentsDto {
    'termsOfService'?: ResponseFileUsageDto;
    'rightOfWithdrawalInformation'?: ResponseFileUsageDto;
    'rightOfWithdrawalForm'?: ResponseFileUsageDto;
}
export interface ResponseTenancyIdnDto {
    'id': number;
    'name': string;
}
export interface ResponseTenancySummaryDto {
    'total': number;
    'active': number;
    'privateTotal': number;
    'privateActive': number;
    'commercialTotal': number;
    'commercialActive': number;
}
export interface ResponseTimezoneDto {
    'name': string;
    'alternativeName': string;
    'group': Array<string>;
    'continentCode': string;
    'continentName': string;
    'countryName': string;
    'countryCode': string;
    'mainCities': Array<string>;
    'rawOffsetInMinutes': number;
    'abbreviation': string;
    'rawFormat': string;
    'currentTimeOffsetInMinutes': number;
    'currentTimeFormat': string;
}
export interface ResponseTimezoneDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseTimezoneDto>;
}
export interface ResponseUnwantedIncidentDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'ProjectId'?: number | null;
    'ObjectId'?: number | null;
    'CreatorId': number | null;
    /**
     * The types of unwanted incident. Can be more than one
     */
    'types': Array<ResponseUnwantedIncidentDtoTypesEnum>;
    'UnwantedIncidentProcesses'?: Array<ResponseUnwantedIncidentProcessDto>;
    'Markings'?: Array<ResponseUnwantedIncidentMarkingDto>;
    'Project'?: ResponseProjectIDNDto;
    'Object'?: ResponseObjectIDNDto;
    'Creator': ResponseUserCardDto | null;
    'reporterName'?: string | null;
    'reporterEmail': string | null;
    'reporterMobile': string | null;
    'reporterCompany': string | null;
    'incident': string;
    'immediateAction': string;
    'consequence': string;
    'serial': number;
}

export const ResponseUnwantedIncidentDtoTypesEnum = {
    PersonInjury: 'person-injury',
    MaterialDamage: 'material-damage',
    Accident: 'accident',
    NearAccident: 'near-accident',
    Observation: 'observation',
} as const;

export type ResponseUnwantedIncidentDtoTypesEnum = typeof ResponseUnwantedIncidentDtoTypesEnum[keyof typeof ResponseUnwantedIncidentDtoTypesEnum];

export interface ResponseUnwantedIncidentDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUnwantedIncidentDto;
}
export interface ResponseUnwantedIncidentDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseUnwantedIncidentDto>;
}
export interface ResponseUnwantedIncidentMarkingDto {
    'FileUsageId': number;
    'description'?: string;
    'icon'?: string;
    'geometry': GeometryDto;
    'modelId': string;
    'FileUsage'?: ResponseFileUsageDto;
    'correct'?: boolean;
    'data'?: MarkingDataDto;
}
export interface ResponseUnwantedIncidentProcessActionCaseDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'deadlineAt': string;
    'completedAt'?: string;
    /**
     * The id of the User that is the CaseManager for the Action
     */
    'CaseManagerId'?: number;
    'name': string;
    'description': string;
    'CaseManager'?: ResponseUserCardDto;
}
export interface ResponseUnwantedIncidentProcessActionDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'UnwantedIncidentProcessId': string;
    'CreatorId': number | null;
    'CaseId': number | null;
    'type': UnwantedIncidentProcessActionType;
    'Creator': ResponseUserCardDto | null;
    'Case': ResponseUnwantedIncidentProcessActionCaseDto;
}


export interface ResponseUnwantedIncidentProcessActionDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUnwantedIncidentProcessActionDto;
}
export interface ResponseUnwantedIncidentProcessActionDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseUnwantedIncidentProcessActionDto>;
}
export interface ResponseUnwantedIncidentProcessDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'UnwantedIncidentId': string;
    'CreatorId': number | null;
    'Creator': ResponseUserCardDto | null;
    /**
     * Notes on the unwanted incident
     */
    'notes': string;
    'status': UnwantedIncidentProcessStatus;
}


export interface ResponseUnwantedIncidentProcessDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUnwantedIncidentProcessDto;
}
export interface ResponseUnwantedIncidentProcessDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseUnwantedIncidentProcessDto>;
}
export interface ResponseUnwantedIncidentProcessStatusSummaryDto {
    'new': number;
    'processing': number;
    'pending': number;
    'finished': number;
}
export interface ResponseUnwantedIncidentProjectDto {
    'type': UnwantedIncidentProjectType;
    'id': number;
    'name': string;
    'Company': ResponseCompanyIDNDto;
}


export interface ResponseUnwantedIncidentProjectDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseUnwantedIncidentProjectDto>;
}
export interface ResponseUnwantedIncidentReportingProjectDto {
    'model': ResponseUnwantedIncidentReportingProjectModel;
    'name': string;
    'modelId': number;
    'companyId': number;
    'companyName': string;
    'types': ResponseUnwantedIncidentReportingProjectTypesDto;
    'processStatuses': ResponseUnwantedIncidentReportingProjectProcessStatusesDto;
    'unwantedIncidents': number;
    'unwantedIncidentActions': number;
    'casesOpen': number;
    'casesClosed': number;
}


export interface ResponseUnwantedIncidentReportingProjectDtoCollectionResponse {
    'data'?: object;
    'Collection': Array<ResponseUnwantedIncidentReportingProjectDto>;
}

export const ResponseUnwantedIncidentReportingProjectModel = {
    Project: 'Project',
    Object: 'Object',
} as const;

export type ResponseUnwantedIncidentReportingProjectModel = typeof ResponseUnwantedIncidentReportingProjectModel[keyof typeof ResponseUnwantedIncidentReportingProjectModel];


export interface ResponseUnwantedIncidentReportingProjectProcessStatusesDto {
    'new': number;
    'pending': number;
    'processing': number;
    'finished': number;
}
export interface ResponseUnwantedIncidentReportingProjectTypesDto {
    'accident': number;
    'near-accident': number;
    'material-damage': number;
    'person-injury': number;
    'observation': number;
}
export interface ResponseUnwantedIncidentSummaryDto {
    'total': number;
    'inProcess': number;
    'byType': ResponseUnwantedIncidentTypeSummaryDto;
    'processesByStatus': ResponseUnwantedIncidentProcessStatusSummaryDto;
}
export interface ResponseUnwantedIncidentTypeSummaryDto {
    'personInjury': number;
    'materialDamage': number;
    'accident': number;
    'nearAccident': number;
    'observation': number;
}
export interface ResponseUserCardDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'mail': string;
    'CompanyId': number | null;
    'name': string;
    'mobile': string | null;
    'address': string | null;
    'zip': string | null;
    'city': string | null;
    'state': string | null;
    'gender': string | null;
    'dateOfBirth': string | null;
    'organizationalNumber': string | null;
    'mailNewCase': boolean;
    'mailNewMessage': boolean;
    'Company'?: ResponseCompanyIDNDto;
}
export interface ResponseUserDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'CompanyId'?: number;
    'name': string;
    'mail': string;
    'mobile'?: string;
    'avatar'?: string;
    'address'?: string;
    'zip'?: string;
    'city'?: string;
    'state'?: string;
    'gender'?: string;
    'dateOfBirth'?: string;
    'mailNewCase'?: boolean;
    'mailNewMessage'?: boolean;
    'mailNewRequest'?: boolean;
    'mailChecklist'?: boolean;
    'digestHourly'?: boolean;
    'digestDaily'?: boolean;
    'pushNotifications'?: boolean;
    'mailVerified'?: number;
    'infoVerified'?: number;
    'hmsCard'?: string;
    'hmsCardExpire'?: string;
    'locale'?: ResponseUserDtoLocaleEnum;
    'paymentStatus'?: ResponseUserDtoPaymentStatusEnum;
    'contactName'?: string;
    'contactPhone'?: string;
    'contactEmail'?: string;
    'notes'?: string;
    'phonePrivate'?: string;
    'phoneWork'?: string;
    'lastActive'?: number;
    'lastLogin'?: number;
    'regDate'?: number;
    'startPage'?: string;
    'Company'?: ResponseCompanyIDNDto;
}

export const ResponseUserDtoLocaleEnum = {
    Nb: 'nb',
    En: 'en',
    Da: 'da',
    De: 'de',
    El: 'el',
    Et: 'et',
    Lt: 'lt',
    Lv: 'lv',
    Pl: 'pl',
    Pt: 'pt',
    Sq: 'sq',
    Sv: 'sv',
} as const;

export type ResponseUserDtoLocaleEnum = typeof ResponseUserDtoLocaleEnum[keyof typeof ResponseUserDtoLocaleEnum];
export const ResponseUserDtoPaymentStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
} as const;

export type ResponseUserDtoPaymentStatusEnum = typeof ResponseUserDtoPaymentStatusEnum[keyof typeof ResponseUserDtoPaymentStatusEnum];

export interface ResponseUserDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUserDto;
}
export interface ResponseUserFavoriteDto {
    'id': number;
    'UserId': number;
    'modelName': string;
    'modelId': number;
    'name'?: string;
    'User': ResponseUserIdnDto;
}
export interface ResponseUserIdnDto {
    'id': number;
    'name': string | null;
}
export interface ResponseUserInviteDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'CreatorId': number;
    'CompanyId': number;
    'CRMUserId': string | null;
    'acceptedAt': string | null;
    'declinedAt': string | null;
    'emailId': string | null;
    'name': string;
    'email': string;
    'language': string;
    'connectUser': boolean;
    'hasExpired': boolean;
}
export interface ResponseUserInviteDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUserInviteDto;
}
export interface ResponseUserNotificationDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': string;
    'UserId': number;
    'sentAt': string | null;
    'read': boolean;
    'sentReference': string | null;
    'translatedText': string;
    'data': UserNotificationDataDto;
}
export interface ResponseUserNotificationDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUserNotificationDto;
}
export interface ResponseUserNotificationDtoPageResponse {
    'data'?: object;
    'meta': PageMetaDto;
    'Collection': Array<ResponseUserNotificationDto>;
}
export interface ResponseUserProfileDto {
    'createdAt': string;
    'updatedAt': string;
    'deletedAt': string | null;
    'id': number;
    'hmsCardExpire'?: string;
    'CompanyId'?: number;
    'name': string;
    'mail': string;
    'mobile'?: string;
    'dateOfBirth'?: string;
    'address'?: string;
    'city'?: string;
    'state'?: string;
    'zip'?: string;
    'locale'?: ResponseUserProfileDtoLocaleEnum;
    'regdate'?: number;
    'location'?: string;
    'gender'?: string;
    'hmsCard'?: string;
    'paymentStatus'?: ResponseUserProfileDtoPaymentStatusEnum;
    'mailNewCase'?: boolean;
    'mailNewMessage'?: boolean;
    'mailNewRequest'?: boolean;
    'mailChecklist'?: boolean;
    'showTextOnButtons'?: boolean;
    'useExtendedFileViewer'?: boolean;
    'startPage'?: string;
    'ical'?: string;
    'timezone'?: string;
    'digestHourly'?: boolean;
    'digestDaily'?: boolean;
    'pushNotifications'?: boolean;
    'userFavorites': Array<ResponseUserFavoriteDto>;
    'tenancyCount': number;
    'agreementsCount': number;
    'salesCount': number;
    'addonContractorCount': number;
    'projectMOMCount': number;
}

export const ResponseUserProfileDtoLocaleEnum = {
    Nb: 'nb',
    En: 'en',
    Da: 'da',
    De: 'de',
    El: 'el',
    Et: 'et',
    Lt: 'lt',
    Lv: 'lv',
    Pl: 'pl',
    Pt: 'pt',
    Sq: 'sq',
    Sv: 'sv',
} as const;

export type ResponseUserProfileDtoLocaleEnum = typeof ResponseUserProfileDtoLocaleEnum[keyof typeof ResponseUserProfileDtoLocaleEnum];
export const ResponseUserProfileDtoPaymentStatusEnum = {
    NUMBER_0: 0,
    NUMBER_1: 1,
} as const;

export type ResponseUserProfileDtoPaymentStatusEnum = typeof ResponseUserProfileDtoPaymentStatusEnum[keyof typeof ResponseUserProfileDtoPaymentStatusEnum];

export interface ResponseUserProfileDtoEntityResponse {
    'data'?: object;
    'Entity'?: ResponseUserProfileDto;
}
export interface ResponseYearMonthValueDto {
    'year': number;
    'month': number;
    'value': number;
}

export const SidebarModel = {
    Sidebar: 'sidebar',
    Bookmark: 'bookmark',
} as const;

export type SidebarModel = typeof SidebarModel[keyof typeof SidebarModel];


/**
 * The ACL type. Only allows private.
 */

export const SigningPolicyACL = {
    Private: 'private',
} as const;

export type SigningPolicyACL = typeof SigningPolicyACL[keyof typeof SigningPolicyACL];


export interface SwapFileDto {
    'FileId': number;
}
export interface TakeoverSupplierOptionSubscriberContactPersonDto {
    'name': string;
    'mail': string;
    'phone': string;
}

export const TakeoverSupplierOptionType = {
    Power: 'power',
    Gas: 'gas',
} as const;

export type TakeoverSupplierOptionType = typeof TakeoverSupplierOptionType[keyof typeof TakeoverSupplierOptionType];


export interface TenancyPrintDto {
    'name': string;
    'Users'?: Array<ResponseUserCardDto>;
    'CRMUsers'?: Array<CrmUserPrintDto>;
}
export interface UnwantedIncidentMarkingDto {
    'FileUsageId': number;
    'description'?: string;
    'icon'?: string;
    'geometry': GeometryDto;
    'correct'?: boolean;
    'data'?: MarkingDataDto;
}

export const UnwantedIncidentPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type UnwantedIncidentPageOptionsOrderBy = typeof UnwantedIncidentPageOptionsOrderBy[keyof typeof UnwantedIncidentPageOptionsOrderBy];


/**
 * The type of action.
 */

export const UnwantedIncidentProcessActionType = {
    Immediate: 'immediate',
    Corrective: 'corrective',
    Preventive: 'preventive',
} as const;

export type UnwantedIncidentProcessActionType = typeof UnwantedIncidentProcessActionType[keyof typeof UnwantedIncidentProcessActionType];


/**
 * The status of this unwanted incident process.
 */

export const UnwantedIncidentProcessStatus = {
    New: 'new',
    Processing: 'processing',
    Pending: 'pending',
    Finished: 'finished',
} as const;

export type UnwantedIncidentProcessStatus = typeof UnwantedIncidentProcessStatus[keyof typeof UnwantedIncidentProcessStatus];



export const UnwantedIncidentProjectPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    Name: 'name',
} as const;

export type UnwantedIncidentProjectPageOptionsOrderBy = typeof UnwantedIncidentProjectPageOptionsOrderBy[keyof typeof UnwantedIncidentProjectPageOptionsOrderBy];



export const UnwantedIncidentProjectType = {
    Project: 'project',
    Object: 'object',
} as const;

export type UnwantedIncidentProjectType = typeof UnwantedIncidentProjectType[keyof typeof UnwantedIncidentProjectType];



export const UnwantedIncidentType = {
    PersonInjury: 'person-injury',
    MaterialDamage: 'material-damage',
    Accident: 'accident',
    NearAccident: 'near-accident',
    Observation: 'observation',
} as const;

export type UnwantedIncidentType = typeof UnwantedIncidentType[keyof typeof UnwantedIncidentType];


export interface UpdateAddressDto {
    'type'?: AddressType;
    'line1'?: string;
    'line2'?: string | null;
    'postal'?: string | null;
    'countryCode'?: string;
    'email'?: string | null;
    'note'?: string | null;
    'reference'?: string | null;
    'placeId'?: string | null;
    'latitude'?: number | null;
    'longitude'?: number | null;
}


export interface UpdateAgreementDto {
    'ObjectFieldId'?: number | null;
    'active'?: boolean;
    'from'?: string;
    'to'?: string;
    'requireReports'?: boolean;
    'name'?: string;
    'description'?: string;
}
export interface UpdateArticleDto {
    'FolderId': string | null;
    'title': string;
    'lead'?: string | null;
    'content': string;
}
export interface UpdateChecklistDto {
    'CompanyId': number;
    'CategoryId': number | null;
    'sortOrder': number;
    'ObjectId': number;
    'CaseManagerId': number | null;
    'ProjectId': number | null;
    'FieldId': number;
    'ObjectFieldId': number;
    'ApartmentId': number;
    'name': string;
    'description': string | null;
}
export interface UpdateChecklistItemDto {
    'checklistItemType'?: ChecklistItemType;
    'value': string;
    'sortOrder': number;
    'notApplicable': boolean;
    'note': string;
    'selectOptions'?: Array<string> | null;
}


export interface UpdateChecklistSectionDto {
    'description': string;
    'sortOrder': number;
    'name': string;
}
export interface UpdateChecklistTemplateDto {
    'CategoryId': number;
    'name': string;
    'description': string;
    'customerAccess': boolean;
}
export interface UpdateChecklistTemplateItemDto {
    'CategoryId': number;
    'sortOrder': number;
    'data': object;
    'fieldId': number;
    'checklistItemType'?: ChecklistItemType;
    'name': string;
    'description': string | null;
    'selectOptions'?: Array<string> | null;
}


export interface UpdateChecklistTemplateSectionDto {
    'name': string;
    'description': string;
}
export interface UpdateCompanyConsentCompanyDto {
    /**
     * If admins are allowed to consent
     */
    'allowAdmins': boolean;
    /**
     * If all contacts must consent before the consent is considered approved
     */
    'requireAllContacts': boolean;
}
export interface UpdateCrmUserDto {
    'dateOfBirth'?: string;
    'firstName'?: string;
    'lastName'?: string;
    'mail'?: string;
    'mobile'?: string;
    'addressLine1'?: string;
    'addressLine2'?: string;
    'city'?: string;
    'postal'?: string;
    'country'?: string;
    'language'?: string;
}
export interface UpdateFieldDto {
    /**
     * A hexadecimal color with leading # like your browser likes
     */
    'color'?: string | null;
    'name': string;
    'status': number;
}
export interface UpdateFileUsageDto {
    'fileSort': number;
    'fileName': string;
}
export interface UpdateFolderDto {
    'ParentId'?: string;
    'name'?: string;
    'description'?: string;
}
export interface UpdateHelpUrlDto {
    'path': string;
    'url': string;
    'language': string;
}
export interface UpdateModelTraitDto {
    'name': string;
    'value': string;
    'public'?: boolean;
}
export interface UpdateSidebarItemPinnedDto {
    'sortOrder': number;
}
export interface UpdateUnwantedIncidentProcessActionDto {
    'type': UnwantedIncidentProcessActionType;
}


export interface UpdateUnwantedIncidentProcessDto {
    /**
     * Notes on the unwanted incident
     */
    'notes': string;
    'status': UnwantedIncidentProcessStatus;
}


export interface UpdateUserDto {
    'CompanyId'?: number;
    'name'?: string;
    'mail'?: string;
    'mobile'?: string | null;
    'dateOfBirth'?: string | null;
    'address'?: string | null;
    'city'?: string | null;
    'zip'?: string | null;
    'locale'?: UpdateUserDtoLocaleEnum;
    'hmsCard'?: string | null;
    'hmsCardExpire'?: string | null;
    'mailNewCase'?: boolean;
    'mailNewMessage'?: boolean;
    'mailNewRequest'?: boolean;
    'mailChecklist'?: boolean;
    'showTextOnButtons'?: boolean;
    'useExtendedFileViewer'?: boolean | null;
    'digestHourly'?: boolean;
    'digestDaily'?: boolean;
    'pushNotifications'?: boolean;
    'status'?: UpdateUserDtoStatusEnum;
}

export const UpdateUserDtoLocaleEnum = {
    Nb: 'nb',
    En: 'en',
    Da: 'da',
    De: 'de',
    El: 'el',
    Et: 'et',
    Lt: 'lt',
    Lv: 'lv',
    Pl: 'pl',
    Pt: 'pt',
    Sq: 'sq',
    Sv: 'sv',
} as const;

export type UpdateUserDtoLocaleEnum = typeof UpdateUserDtoLocaleEnum[keyof typeof UpdateUserDtoLocaleEnum];
export const UpdateUserDtoStatusEnum = {
    NUMBER_MINUS_1: -1,
    NUMBER_0: 0,
    NUMBER_2: 2,
    NUMBER_3: 3,
} as const;

export type UpdateUserDtoStatusEnum = typeof UpdateUserDtoStatusEnum[keyof typeof UpdateUserDtoStatusEnum];

export interface UpdateUserNotificationDto {
    'read': boolean;
}
export interface UserNotificationDataDto {
    'model': UserNotificationModel;
    'type': UserNotificationType;
    'UserId': number;
    'changes': Array<UserNotificationDataDtoChangesInner>;
    'modelId': string;
    'modelTitle': string | null;
    'message': string | null;
}


export interface UserNotificationDataDtoChangesInner {
    'field'?: string;
    'previous'?: string;
    'current'?: string;
}

export const UserNotificationModel = {
    Case: 'Case',
    ObjectFieldReport: 'ObjectFieldReport',
} as const;

export type UserNotificationModel = typeof UserNotificationModel[keyof typeof UserNotificationModel];



export const UserNotificationPageOptionsOrderBy = {
    CreatedAt: 'createdAt',
    UpdatedAt: 'updatedAt',
} as const;

export type UserNotificationPageOptionsOrderBy = typeof UserNotificationPageOptionsOrderBy[keyof typeof UserNotificationPageOptionsOrderBy];



export const UserNotificationType = {
    CaseFileUsageCreate: 'CaseFileUsageCreate',
    CaseFileUsageDestroy: 'CaseFileUsageDestroy',
    CaseNew: 'CaseNew',
    CaseFinished: 'CaseFinished',
    CaseReopened: 'CaseReopened',
    System: 'System',
    CaseManagerMessage: 'CaseManagerMessage',
    ContractorMessage: 'ContractorMessage',
    ClientMessage: 'ClientMessage',
    StatusChangeAccepted: 'StatusChangeAccepted',
    StatusChangeDeclined: 'StatusChangeDeclined',
    StatusChangeCompleted: 'StatusChangeCompleted',
    AddedContractor: 'AddedContractor',
    RemovedContractor: 'RemovedContractor',
    StatusChangeFinished: 'StatusChangeFinished',
    StatusChangeReopened: 'StatusChangeReopened',
    CaseChanged: 'CaseChanged',
    PdfReady: 'PDFReady',
} as const;

export type UserNotificationType = typeof UserNotificationType[keyof typeof UserNotificationType];


export interface UserPrintDto {
    'name': string;
    'mail'?: string | null;
    'mobile'?: string | null;
    'Company'?: CompanyPrintDto;
}

/**
 * AddonApi - axios parameter creator
 */
export const AddonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonCreate: async (addonId: string, createModelTraitDto: CreateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonId' is not null or undefined
            assertParamExists('modelTraitControllerAddonCreate', 'addonId', addonId)
            // verify required parameter 'createModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerAddonCreate', 'createModelTraitDto', createModelTraitDto)
            const localVarPath = `/addon/{addonId}/model-traits`
                .replace(`{${"addonId"}}`, encodeURIComponent(String(addonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonDelete: async (addonId: string, modelTraitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonId' is not null or undefined
            assertParamExists('modelTraitControllerAddonDelete', 'addonId', addonId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerAddonDelete', 'modelTraitId', modelTraitId)
            const localVarPath = `/addon/{addonId}/model-traits/{modelTraitId}`
                .replace(`{${"addonId"}}`, encodeURIComponent(String(addonId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all traits on Addon by modelId
         * @summary 
         * @param {string} addonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadCollection: async (addonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonId' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadCollection', 'addonId', addonId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadCollection', 'limit', limit)
            const localVarPath = `/addon/{addonId}/model-traits`
                .replace(`{${"addonId"}}`, encodeURIComponent(String(addonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Addon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadCollectionOnModel: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadCollectionOnModel', 'name', name)
            const localVarPath = `/addon/model-traits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Addon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadNameCollection: async (name: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadNameCollection', 'name', name)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('modelTraitControllerAddonReadNameCollection', 'value', value)
            const localVarPath = `/addon/model-traits/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonUpdate: async (addonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'addonId' is not null or undefined
            assertParamExists('modelTraitControllerAddonUpdate', 'addonId', addonId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerAddonUpdate', 'modelTraitId', modelTraitId)
            // verify required parameter 'updateModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerAddonUpdate', 'updateModelTraitDto', updateModelTraitDto)
            const localVarPath = `/addon/{addonId}/model-traits/{modelTraitId}`
                .replace(`{${"addonId"}}`, encodeURIComponent(String(addonId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddonApi - functional programming interface
 */
export const AddonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddonApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonCreate(addonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonCreate(addonId, createModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonDelete(addonId: string, modelTraitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonDelete(addonId, modelTraitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all traits on Addon by modelId
         * @summary 
         * @param {string} addonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonReadCollection(addonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonReadCollection(addonId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Addon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonReadCollectionOnModel(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonReadCollectionOnModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Addon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonReadNameCollection(name, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonReadNameCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerAddonUpdate(addonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerAddonUpdate(addonId, modelTraitId, updateModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApi.modelTraitControllerAddonUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddonApi - factory interface
 */
export const AddonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddonApiFp(configuration)
    return {
        /**
         * Create a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonCreate(addonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerAddonCreate(addonId, createModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonDelete(addonId: string, modelTraitId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.modelTraitControllerAddonDelete(addonId, modelTraitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all traits on Addon by modelId
         * @summary 
         * @param {string} addonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadCollection(addonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoPageResponse> {
            return localVarFp.modelTraitControllerAddonReadCollection(addonId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Addon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerAddonReadCollectionOnModel(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Addon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerAddonReadNameCollection(name, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ModelTrait for Addon
         * @summary 
         * @param {string} addonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerAddonUpdate(addonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerAddonUpdate(addonId, modelTraitId, updateModelTraitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddonApi - object-oriented interface
 */
export class AddonApi extends BaseAPI {
    /**
     * Create a ModelTrait for Addon
     * @summary 
     * @param {string} addonId 
     * @param {CreateModelTraitDto} createModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonCreate(addonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonCreate(addonId, createModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ModelTrait for Addon
     * @summary 
     * @param {string} addonId 
     * @param {number} modelTraitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonDelete(addonId: string, modelTraitId: number, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonDelete(addonId, modelTraitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all traits on Addon by modelId
     * @summary 
     * @param {string} addonId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonReadCollection(addonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonReadCollection(addonId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Addon filtered by name
     * @summary 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonReadCollectionOnModel(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Addon
     * @summary 
     * @param {string} name 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonReadNameCollection(name, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ModelTrait for Addon
     * @summary 
     * @param {string} addonId 
     * @param {number} modelTraitId 
     * @param {UpdateModelTraitDto} updateModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerAddonUpdate(addonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig) {
        return AddonApiFp(this.configuration).modelTraitControllerAddonUpdate(addonId, modelTraitId, updateModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AddonApartmentApi - axios parameter creator
 */
export const AddonApartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a collection of AddonApartments
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAddonApartmentControllerReadCollection: async (projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalAddonApartmentControllerReadCollection', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalAddonApartmentControllerReadCollection', 'apartmentId', apartmentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalAddonApartmentControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalAddonApartmentControllerReadCollection', 'limit', limit)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/addon-apartments`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddonApartmentApi - functional programming interface
 */
export const AddonApartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddonApartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a collection of AddonApartments
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAddonApartmentControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalAddonApartmentDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAddonApartmentControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonApartmentApi.portalAddonApartmentControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddonApartmentApi - factory interface
 */
export const AddonApartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddonApartmentApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a collection of AddonApartments
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAddonApartmentControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalAddonApartmentDtoPageResponse> {
            return localVarFp.portalAddonApartmentControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddonApartmentApi - object-oriented interface
 */
export class AddonApartmentApi extends BaseAPI {
    /**
     * 
     * @summary Get a collection of AddonApartments
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalAddonApartmentControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return AddonApartmentApiFp(this.configuration).portalAddonApartmentControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AddonOrderApi - axios parameter creator
 */
export const AddonOrderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get a collection of AddonOrders
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAddonOrderControllerReadCollection: async (projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalAddonOrderControllerReadCollection', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalAddonOrderControllerReadCollection', 'apartmentId', apartmentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalAddonOrderControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalAddonOrderControllerReadCollection', 'limit', limit)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/addon-orders`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AddonOrderApi - functional programming interface
 */
export const AddonOrderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AddonOrderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get a collection of AddonOrders
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAddonOrderControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalAddonOrderDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAddonOrderControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AddonOrderApi.portalAddonOrderControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AddonOrderApi - factory interface
 */
export const AddonOrderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AddonOrderApiFp(configuration)
    return {
        /**
         * 
         * @summary Get a collection of AddonOrders
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAddonOrderControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalAddonOrderDtoPageResponse> {
            return localVarFp.portalAddonOrderControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AddonOrderApi - object-oriented interface
 */
export class AddonOrderApi extends BaseAPI {
    /**
     * 
     * @summary Get a collection of AddonOrders
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalAddonOrderControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return AddonOrderApiFp(this.configuration).portalAddonOrderControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AgreementApi - axios parameter creator
 */
export const AgreementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Read an agreement
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerRead: async (agreementId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('agreementControllerRead', 'agreementId', agreementId)
            const localVarPath = `/agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all agreements
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('agreementControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('agreementControllerReadCollection', 'limit', limit)
            const localVarPath = `/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['ObjectId'] = objectId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all agreements on Company
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerReadCollectionForCompany: async (page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('agreementControllerReadCollectionForCompany', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('agreementControllerReadCollectionForCompany', 'limit', limit)
            const localVarPath = `/agreements/company`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['ObjectId'] = objectId;
            }

            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            if (active !== undefined) {
                localVarQueryParameter['active'] = active;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an agreement
         * @param {number} agreementId 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerUpdate: async (agreementId: number, updateAgreementDto: UpdateAgreementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('agreementControllerUpdate', 'agreementId', agreementId)
            // verify required parameter 'updateAgreementDto' is not null or undefined
            assertParamExists('agreementControllerUpdate', 'updateAgreementDto', updateAgreementDto)
            const localVarPath = `/agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAgreementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AgreementApi - functional programming interface
 */
export const AgreementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AgreementApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Read an agreement
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementControllerRead(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.agreementControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all agreements
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementControllerReadCollection(page, limit, order, orderBy, objectId, id, name, active, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.agreementControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all agreements on Company
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementControllerReadCollectionForCompany(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementControllerReadCollectionForCompany(page, limit, order, orderBy, objectId, id, name, active, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.agreementControllerReadCollectionForCompany']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an agreement
         * @param {number} agreementId 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async agreementControllerUpdate(agreementId: number, updateAgreementDto: UpdateAgreementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.agreementControllerUpdate(agreementId, updateAgreementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AgreementApi.agreementControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AgreementApi - factory interface
 */
export const AgreementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AgreementApiFp(configuration)
    return {
        /**
         * 
         * @summary Read an agreement
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoEntityResponse> {
            return localVarFp.agreementControllerRead(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all agreements
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoPageResponse> {
            return localVarFp.agreementControllerReadCollection(page, limit, order, orderBy, objectId, id, name, active, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all agreements on Company
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {AgreementPageOptionsOrderBy} [orderBy] 
         * @param {number} [objectId] Filter results on Object
         * @param {number} [id] Filter results on AgreementId
         * @param {string} [name] 
         * @param {boolean} [active] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerReadCollectionForCompany(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoPageResponse> {
            return localVarFp.agreementControllerReadCollectionForCompany(page, limit, order, orderBy, objectId, id, name, active, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an agreement
         * @param {number} agreementId 
         * @param {UpdateAgreementDto} updateAgreementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        agreementControllerUpdate(agreementId: number, updateAgreementDto: UpdateAgreementDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoEntityResponse> {
            return localVarFp.agreementControllerUpdate(agreementId, updateAgreementDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AgreementApi - object-oriented interface
 */
export class AgreementApi extends BaseAPI {
    /**
     * 
     * @summary Read an agreement
     * @param {number} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public agreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).agreementControllerRead(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all agreements
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {AgreementPageOptionsOrderBy} [orderBy] 
     * @param {number} [objectId] Filter results on Object
     * @param {number} [id] Filter results on AgreementId
     * @param {string} [name] 
     * @param {boolean} [active] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public agreementControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).agreementControllerReadCollection(page, limit, order, orderBy, objectId, id, name, active, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all agreements on Company
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {AgreementPageOptionsOrderBy} [orderBy] 
     * @param {number} [objectId] Filter results on Object
     * @param {number} [id] Filter results on AgreementId
     * @param {string} [name] 
     * @param {boolean} [active] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public agreementControllerReadCollectionForCompany(page: number, limit: number, order?: Order, orderBy?: AgreementPageOptionsOrderBy, objectId?: number, id?: number, name?: string, active?: boolean, search?: string, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).agreementControllerReadCollectionForCompany(page, limit, order, orderBy, objectId, id, name, active, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an agreement
     * @param {number} agreementId 
     * @param {UpdateAgreementDto} updateAgreementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public agreementControllerUpdate(agreementId: number, updateAgreementDto: UpdateAgreementDto, options?: RawAxiosRequestConfig) {
        return AgreementApiFp(this.configuration).agreementControllerUpdate(agreementId, updateAgreementDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ApartmentApi - axios parameter creator
 */
export const ApartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentCreate: async (apartmentId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('addressControllerApartmentCreate', 'apartmentId', apartmentId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerApartmentCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/apartment/{apartmentId}/addresses`
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentDelete: async (apartmentId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('addressControllerApartmentDelete', 'apartmentId', apartmentId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerApartmentDelete', 'addressId', addressId)
            const localVarPath = `/apartment/{apartmentId}/addresses/{addressId}`
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentReadCollection: async (apartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('addressControllerApartmentReadCollection', 'apartmentId', apartmentId)
            const localVarPath = `/apartment/{apartmentId}/addresses`
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentUpdate: async (apartmentId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('addressControllerApartmentUpdate', 'apartmentId', apartmentId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerApartmentUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerApartmentUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/apartment/{apartmentId}/addresses/{addressId}`
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ApartmentApi - functional programming interface
 */
export const ApartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ApartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerApartmentCreate(apartmentId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerApartmentCreate(apartmentId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApartmentApi.addressControllerApartmentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerApartmentDelete(apartmentId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerApartmentDelete(apartmentId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApartmentApi.addressControllerApartmentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerApartmentReadCollection(apartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerApartmentReadCollection(apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApartmentApi.addressControllerApartmentReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerApartmentUpdate(apartmentId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerApartmentUpdate(apartmentId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ApartmentApi.addressControllerApartmentUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ApartmentApi - factory interface
 */
export const ApartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ApartmentApiFp(configuration)
    return {
        /**
         * Create an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentCreate(apartmentId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerApartmentCreate(apartmentId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentDelete(apartmentId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerApartmentDelete(apartmentId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentReadCollection(apartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerApartmentReadCollection(apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for Apartment
         * @summary 
         * @param {string} apartmentId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerApartmentUpdate(apartmentId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerApartmentUpdate(apartmentId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ApartmentApi - object-oriented interface
 */
export class ApartmentApi extends BaseAPI {
    /**
     * Create an Address for Apartment
     * @summary 
     * @param {string} apartmentId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerApartmentCreate(apartmentId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return ApartmentApiFp(this.configuration).addressControllerApartmentCreate(apartmentId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for Apartment
     * @summary 
     * @param {string} apartmentId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerApartmentDelete(apartmentId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return ApartmentApiFp(this.configuration).addressControllerApartmentDelete(apartmentId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for Apartment
     * @summary 
     * @param {string} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerApartmentReadCollection(apartmentId: string, options?: RawAxiosRequestConfig) {
        return ApartmentApiFp(this.configuration).addressControllerApartmentReadCollection(apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for Apartment
     * @summary 
     * @param {string} apartmentId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerApartmentUpdate(apartmentId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return ApartmentApiFp(this.configuration).addressControllerApartmentUpdate(apartmentId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArticleApi - axios parameter creator
 */
export const ArticleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleAgreements: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles/article-models/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleCompanies: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles/article-models/companies`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleConstructionSites: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles/article-models/construction-sites`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleObjectChildren: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleArticleModelsControllerReadArticleObjectChildren', 'objectId', objectId)
            const localVarPath = `/articles/article-models/objects/{objectId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleObjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles/article-models/objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleProjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/articles/article-models/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an Article
         * @param {CreateArticleDto} createArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerCreate: async (createArticleDto: CreateArticleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createArticleDto' is not null or undefined
            assertParamExists('articleControllerCreate', 'createArticleDto', createArticleDto)
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerDelete: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleControllerDelete', 'articleId', articleId)
            const localVarPath = `/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerRead: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleControllerRead', 'articleId', articleId)
            const localVarPath = `/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Articles
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('articleControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('articleControllerReadCollection', 'limit', limit)
            const localVarPath = `/articles`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (articleModel !== undefined) {
                localVarQueryParameter['ArticleModel'] = articleModel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all files for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadFiles: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleControllerReadFiles', 'articleId', articleId)
            const localVarPath = `/articles/{articleId}/files`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all images for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadImages: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleControllerReadImages', 'articleId', articleId)
            const localVarPath = `/articles/{articleId}/images`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an Article
         * @param {string} articleId 
         * @param {UpdateArticleDto} updateArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerUpdate: async (articleId: string, updateArticleDto: UpdateArticleDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleControllerUpdate', 'articleId', articleId)
            // verify required parameter 'updateArticleDto' is not null or undefined
            assertParamExists('articleControllerUpdate', 'updateArticleDto', updateArticleDto)
            const localVarPath = `/articles/{articleId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateArticleDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an ArticleModel
         * @param {string} articleId 
         * @param {CreateArticleModelDto} createArticleModelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerCreate: async (articleId: string, createArticleModelDto: CreateArticleModelDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleModelControllerCreate', 'articleId', articleId)
            // verify required parameter 'createArticleModelDto' is not null or undefined
            assertParamExists('articleModelControllerCreate', 'createArticleModelDto', createArticleModelDto)
            const localVarPath = `/articles/{articleId}/models`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleModelDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an ArticleModel
         * @param {string} articleId 
         * @param {string} articleModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerDelete: async (articleId: string, articleModelId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleModelControllerDelete', 'articleId', articleId)
            // verify required parameter 'articleModelId' is not null or undefined
            assertParamExists('articleModelControllerDelete', 'articleModelId', articleModelId)
            const localVarPath = `/articles/{articleId}/models/{articleModelId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"articleModelId"}}`, encodeURIComponent(String(articleModelId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all ArticleModels of Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerReadCollection: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleModelControllerReadCollection', 'articleId', articleId)
            const localVarPath = `/articles/{articleId}/models`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCount: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCount', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/files/count`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCreate: async (articleId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCreate', 'articleId', articleId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/files`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesDelete: async (articleId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesDelete', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/article/{articleId}/files/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesReadCollection: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesReadCollection', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/files`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSort: async (articleId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSort', 'articleId', articleId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/article/{articleId}/files/sort`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSwap: async (articleId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/article/{articleId}/files/swap/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesUpdate: async (articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/files/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCount: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCount', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/images/count`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCreate: async (articleId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCreate', 'articleId', articleId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/images`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesDelete: async (articleId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesDelete', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/article/{articleId}/images/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesReadCollection: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesReadCollection', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/images`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSort: async (articleId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSort', 'articleId', articleId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/article/{articleId}/images/sort`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSwap: async (articleId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/article/{articleId}/images/swap/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesUpdate: async (articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/images/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleApi - functional programming interface
 */
export const ArticleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleAgreements(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleAgreements(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleAgreements']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleCompanies(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleCompanies(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleCompanies']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleConstructionSites(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleConstructionSites(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleConstructionSites']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleObjectChildren(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleObjectChildren(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleObjectChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleObjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleObjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleArticleModelsControllerReadArticleProjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelItemDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleArticleModelsControllerReadArticleProjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleArticleModelsControllerReadArticleProjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an Article
         * @param {CreateArticleDto} createArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerCreate(createArticleDto: CreateArticleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerCreate(createArticleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerDelete(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerDelete(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerRead(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerRead(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all Articles
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerReadCollection(page, limit, order, orderBy, articleModel, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all files for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerReadFiles(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerReadFiles(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerReadFiles']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all images for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerReadImages(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerReadImages(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerReadImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an Article
         * @param {string} articleId 
         * @param {UpdateArticleDto} updateArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleControllerUpdate(articleId: string, updateArticleDto: UpdateArticleDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleControllerUpdate(articleId, updateArticleDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an ArticleModel
         * @param {string} articleId 
         * @param {CreateArticleModelDto} createArticleModelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleModelControllerCreate(articleId: string, createArticleModelDto: CreateArticleModelDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleModelControllerCreate(articleId, createArticleModelDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleModelControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an ArticleModel
         * @param {string} articleId 
         * @param {string} articleModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleModelControllerDelete(articleId: string, articleModelId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleModelControllerDelete(articleId, articleModelId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleModelControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all ArticleModels of Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleModelControllerReadCollection(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleModelDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleModelControllerReadCollection(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.articleModelControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesCount(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesReadCollection(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleFilesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesCount(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesReadCollection(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleApi.fileUsageControllerArticleImagesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArticleApi - factory interface
 */
export const ArticleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticleApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleAgreements(options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleAgreements(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleCompanies(options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleCompanies(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleConstructionSites(options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleConstructionSites(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleObjectChildren(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleObjectChildren(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleObjects(options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleObjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleArticleModelsControllerReadArticleProjects(options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelItemDtoCollectionResponse> {
            return localVarFp.articleArticleModelsControllerReadArticleProjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an Article
         * @param {CreateArticleDto} createArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerCreate(createArticleDto: CreateArticleDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleDtoEntityResponse> {
            return localVarFp.articleControllerCreate(createArticleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerDelete(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleControllerDelete(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read an Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerRead(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleDtoEntityResponse> {
            return localVarFp.articleControllerRead(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all Articles
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleDtoPageResponse> {
            return localVarFp.articleControllerReadCollection(page, limit, order, orderBy, articleModel, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all files for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadFiles(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.articleControllerReadFiles(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all images for an article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerReadImages(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.articleControllerReadImages(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an Article
         * @param {string} articleId 
         * @param {UpdateArticleDto} updateArticleDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleControllerUpdate(articleId: string, updateArticleDto: UpdateArticleDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleDtoEntityResponse> {
            return localVarFp.articleControllerUpdate(articleId, updateArticleDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an ArticleModel
         * @param {string} articleId 
         * @param {CreateArticleModelDto} createArticleModelDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerCreate(articleId: string, createArticleModelDto: CreateArticleModelDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelDtoEntityResponse> {
            return localVarFp.articleModelControllerCreate(articleId, createArticleModelDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an ArticleModel
         * @param {string} articleId 
         * @param {string} articleModelId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerDelete(articleId: string, articleModelId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleModelControllerDelete(articleId, articleModelId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all ArticleModels of Article
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleModelControllerReadCollection(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleModelDtoCollectionResponse> {
            return localVarFp.articleModelControllerReadCollection(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesCount(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleFilesReadCollection(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesCount(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleImagesReadCollection(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleApi - object-oriented interface
 */
export class ArticleApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleAgreements(options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleAgreements(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleCompanies(options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleCompanies(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleConstructionSites(options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleConstructionSites(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleObjectChildren(objectId: number, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleObjectChildren(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleObjects(options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleObjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleArticleModelsControllerReadArticleProjects(options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleArticleModelsControllerReadArticleProjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an Article
     * @param {CreateArticleDto} createArticleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerCreate(createArticleDto: CreateArticleDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerCreate(createArticleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an Article
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerDelete(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerDelete(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read an Article
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerRead(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerRead(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all Articles
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ArticlePageOptionsOrderBy} [orderBy] 
     * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerReadCollection(page, limit, order, orderBy, articleModel, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all files for an article
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerReadFiles(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerReadFiles(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all images for an article
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerReadImages(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerReadImages(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an Article
     * @param {string} articleId 
     * @param {UpdateArticleDto} updateArticleDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleControllerUpdate(articleId: string, updateArticleDto: UpdateArticleDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleControllerUpdate(articleId, updateArticleDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an ArticleModel
     * @param {string} articleId 
     * @param {CreateArticleModelDto} createArticleModelDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleModelControllerCreate(articleId: string, createArticleModelDto: CreateArticleModelDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleModelControllerCreate(articleId, createArticleModelDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an ArticleModel
     * @param {string} articleId 
     * @param {string} articleModelId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleModelControllerDelete(articleId: string, articleModelId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleModelControllerDelete(articleId, articleModelId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all ArticleModels of Article
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleModelControllerReadCollection(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).articleModelControllerReadCollection(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesCount(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesReadCollection(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesCount(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesReadCollection(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleApiFp(this.configuration).fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ArticleUsageApi - axios parameter creator
 */
export const ArticleUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages for Company
         * @summary 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyReadCollectionForModel: async (companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyReadCollectionForModel', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages for Object
         * @summary 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectReadCollectionForModel: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectReadCollectionForModel', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages for ProjectApartment
         * @summary 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentReadCollectionForModel: async (projectApartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentReadCollectionForModel', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/article-usages/project-apartment/{projectApartmentId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewCreate: async (projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewDelete: async (projectApartmentId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewDelete', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new/{articleId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewReadCollection: async (projectApartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewReadCollection', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedCreate: async (projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedDelete: async (projectApartmentId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedDelete', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used/{articleId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedReadCollection: async (projectApartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedReadCollection', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages for Project
         * @summary 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectReadCollectionForModel: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectReadCollectionForModel', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/request-consent`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/request-consent/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/request-consent`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleUsageApi - functional programming interface
 */
export const ArticleUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticleUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonConfirmationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonConfirmationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonConfirmationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonPdfCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonPdfDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonPdfReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonProjectTextCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonProjectTextDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyAddonProjectTextReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages for Company
         * @summary 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyReadCollectionForModel(companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyReadCollectionForModel(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyReadCollectionForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages for Object
         * @summary 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectReadCollectionForModel(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectReadCollectionForModel(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectReadCollectionForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonConfirmationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonConfirmationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonConfirmationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonPdfCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonPdfDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonPdfReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonProjectTextCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonProjectTextDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectAddonProjectTextReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages for ProjectApartment
         * @summary 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentReadCollectionForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectApartmentTakeoverUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages for Project
         * @summary 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectReadCollectionForModel(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectReadCollectionForModel(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectReadCollectionForModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectRequestConsentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectRequestConsentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectRequestConsentReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ArticleUsageApi.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ArticleUsageApi - factory interface
 */
export const ArticleUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticleUsageApiFp(configuration)
    return {
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonPdfReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages for Company
         * @summary 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyReadCollectionForModel(companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyReadCollectionForModel(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages for Object
         * @summary 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectReadCollectionForModel(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectReadCollectionForModel(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonPdfReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages for ProjectApartment
         * @summary 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages for Project
         * @summary 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectReadCollectionForModel(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectReadCollectionForModel(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectRequestConsentReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleUsageApi - object-oriented interface
 */
export class ArticleUsageApi extends BaseAPI {
    /**
     * Add a article to \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonPdfReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages for Company
     * @summary 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyReadCollectionForModel(companyId: number, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyReadCollectionForModel(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages for Object
     * @summary 
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectReadCollectionForModel(objectId: number, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectReadCollectionForModel(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonPdfReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages for ProjectApartment
     * @summary 
     * @param {number} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId: number, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentReadCollectionForModel(projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages for Project
     * @summary 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectReadCollectionForModel(projectId: number, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectReadCollectionForModel(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectRequestConsentReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ArticleUsageApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * AuthApi - axios parameter creator
 */
export const AuthApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Assume the role of another user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerAssumeUser: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('authControllerAssumeUser', 'userId', userId)
            const localVarPath = `/auth/assume/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Login user
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin: async (loginDto: LoginDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'loginDto' is not null or undefined
            assertParamExists('authControllerLogin', 'loginDto', loginDto)
            const localVarPath = `/auth/login`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(loginDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Logout user
         * @param {AuthDestination} [destination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout: async (destination?: AuthDestination, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/auth/logout`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (destination !== undefined) {
                localVarQueryParameter['destination'] = destination;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AuthApi - functional programming interface
 */
export const AuthApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AuthApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Assume the role of another user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerAssumeUser(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerAssumeUser(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerAssumeUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Login user
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseLoginDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogin(loginDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLogin']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Logout user
         * @param {AuthDestination} [destination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async authControllerLogout(destination?: AuthDestination, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseLogoutDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.authControllerLogout(destination, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['AuthApi.authControllerLogout']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * AuthApi - factory interface
 */
export const AuthApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AuthApiFp(configuration)
    return {
        /**
         * 
         * @summary Assume the role of another user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerAssumeUser(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.authControllerAssumeUser(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Login user
         * @param {LoginDto} loginDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseLoginDto> {
            return localVarFp.authControllerLogin(loginDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Logout user
         * @param {AuthDestination} [destination] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        authControllerLogout(destination?: AuthDestination, options?: RawAxiosRequestConfig): AxiosPromise<ResponseLogoutDto> {
            return localVarFp.authControllerLogout(destination, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AuthApi - object-oriented interface
 */
export class AuthApi extends BaseAPI {
    /**
     * 
     * @summary Assume the role of another user
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authControllerAssumeUser(userId: number, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerAssumeUser(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Login user
     * @param {LoginDto} loginDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authControllerLogin(loginDto: LoginDto, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogin(loginDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Logout user
     * @param {AuthDestination} [destination] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public authControllerLogout(destination?: AuthDestination, options?: RawAxiosRequestConfig) {
        return AuthApiFp(this.configuration).authControllerLogout(destination, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistApi - axios parameter creator
 */
export const ChecklistApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerDelete: async (checklistId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistControllerDelete', 'checklistId', checklistId)
            const localVarPath = `/checklists/{checklistId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all checklists
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistPageOptionsOrderBy} [orderBy] 
         * @param {number} [fieldId] Filter results on Field
         * @param {number} [projectId] Filter results on Project
         * @param {number} [objectId] Filter results on Object
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: ChecklistPageOptionsOrderBy, fieldId?: number, projectId?: number, objectId?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistControllerReadCollection', 'limit', limit)
            const localVarPath = `/checklists`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (fieldId !== undefined) {
                localVarQueryParameter['FieldId'] = fieldId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['ObjectId'] = objectId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read one checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerReadOne: async (checklistId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistControllerReadOne', 'checklistId', checklistId)
            const localVarPath = `/checklists/{checklistId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a checklist
         * @param {number} checklistId 
         * @param {UpdateChecklistDto} updateChecklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerUpdate: async (checklistId: number, updateChecklistDto: UpdateChecklistDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistControllerUpdate', 'checklistId', checklistId)
            // verify required parameter 'updateChecklistDto' is not null or undefined
            assertParamExists('checklistControllerUpdate', 'updateChecklistDto', updateChecklistDto)
            const localVarPath = `/checklists/{checklistId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistApi - functional programming interface
 */
export const ChecklistApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistControllerDelete(checklistId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistControllerDelete(checklistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistApi.checklistControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all checklists
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistPageOptionsOrderBy} [orderBy] 
         * @param {number} [fieldId] Filter results on Field
         * @param {number} [projectId] Filter results on Project
         * @param {number} [objectId] Filter results on Object
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistPageOptionsOrderBy, fieldId?: number, projectId?: number, objectId?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistControllerReadCollection(page, limit, order, orderBy, fieldId, projectId, objectId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistApi.checklistControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read one checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistControllerReadOne(checklistId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistControllerReadOne(checklistId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistApi.checklistControllerReadOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a checklist
         * @param {number} checklistId 
         * @param {UpdateChecklistDto} updateChecklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistControllerUpdate(checklistId: number, updateChecklistDto: UpdateChecklistDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistControllerUpdate(checklistId, updateChecklistDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistApi.checklistControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistApi - factory interface
 */
export const ChecklistApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerDelete(checklistId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistControllerDelete(checklistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all checklists
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistPageOptionsOrderBy} [orderBy] 
         * @param {number} [fieldId] Filter results on Field
         * @param {number} [projectId] Filter results on Project
         * @param {number} [objectId] Filter results on Object
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistPageOptionsOrderBy, fieldId?: number, projectId?: number, objectId?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistDtoPageResponse> {
            return localVarFp.checklistControllerReadCollection(page, limit, order, orderBy, fieldId, projectId, objectId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read one checklist
         * @param {number} checklistId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerReadOne(checklistId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistDtoEntityResponse> {
            return localVarFp.checklistControllerReadOne(checklistId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a checklist
         * @param {number} checklistId 
         * @param {UpdateChecklistDto} updateChecklistDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistControllerUpdate(checklistId: number, updateChecklistDto: UpdateChecklistDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistDtoEntityResponse> {
            return localVarFp.checklistControllerUpdate(checklistId, updateChecklistDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistApi - object-oriented interface
 */
export class ChecklistApi extends BaseAPI {
    /**
     * 
     * @summary Delete a checklist
     * @param {number} checklistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistControllerDelete(checklistId: number, options?: RawAxiosRequestConfig) {
        return ChecklistApiFp(this.configuration).checklistControllerDelete(checklistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all checklists
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ChecklistPageOptionsOrderBy} [orderBy] 
     * @param {number} [fieldId] Filter results on Field
     * @param {number} [projectId] Filter results on Project
     * @param {number} [objectId] Filter results on Object
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistPageOptionsOrderBy, fieldId?: number, projectId?: number, objectId?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistApiFp(this.configuration).checklistControllerReadCollection(page, limit, order, orderBy, fieldId, projectId, objectId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read one checklist
     * @param {number} checklistId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistControllerReadOne(checklistId: number, options?: RawAxiosRequestConfig) {
        return ChecklistApiFp(this.configuration).checklistControllerReadOne(checklistId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a checklist
     * @param {number} checklistId 
     * @param {UpdateChecklistDto} updateChecklistDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistControllerUpdate(checklistId: number, updateChecklistDto: UpdateChecklistDto, options?: RawAxiosRequestConfig) {
        return ChecklistApiFp(this.configuration).checklistControllerUpdate(checklistId, updateChecklistDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistItemApi - axios parameter creator
 */
export const ChecklistItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerDelete: async (checklistId: number, checklistItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistItemControllerDelete', 'checklistId', checklistId)
            // verify required parameter 'checklistItemId' is not null or undefined
            assertParamExists('checklistItemControllerDelete', 'checklistItemId', checklistItemId)
            const localVarPath = `/checklists/{checklistId}/checklist-items/{checklistItemId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)))
                .replace(`{${"checklistItemId"}}`, encodeURIComponent(String(checklistItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ChecklistItems
         * @summary Read a collection of ChecklistItems
         * @param {number} checklistId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerReadCollection: async (checklistId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistItemControllerReadCollection', 'checklistId', checklistId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistItemControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistItemControllerReadCollection', 'limit', limit)
            const localVarPath = `/checklists/{checklistId}/checklist-items`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a single ChecklistItem
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerReadOne: async (checklistId: number, checklistItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistItemControllerReadOne', 'checklistId', checklistId)
            // verify required parameter 'checklistItemId' is not null or undefined
            assertParamExists('checklistItemControllerReadOne', 'checklistItemId', checklistItemId)
            const localVarPath = `/checklists/{checklistId}/checklist-items/{checklistItemId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)))
                .replace(`{${"checklistItemId"}}`, encodeURIComponent(String(checklistItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {UpdateChecklistItemDto} updateChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerUpdate: async (checklistId: number, checklistItemId: number, updateChecklistItemDto: UpdateChecklistItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistItemControllerUpdate', 'checklistId', checklistId)
            // verify required parameter 'checklistItemId' is not null or undefined
            assertParamExists('checklistItemControllerUpdate', 'checklistItemId', checklistItemId)
            // verify required parameter 'updateChecklistItemDto' is not null or undefined
            assertParamExists('checklistItemControllerUpdate', 'updateChecklistItemDto', updateChecklistItemDto)
            const localVarPath = `/checklists/{checklistId}/checklist-items/{checklistItemId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)))
                .replace(`{${"checklistItemId"}}`, encodeURIComponent(String(checklistItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistItemApi - functional programming interface
 */
export const ChecklistItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistItemControllerDelete(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistItemControllerDelete(checklistId, checklistItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistItemApi.checklistItemControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ChecklistItems
         * @summary Read a collection of ChecklistItems
         * @param {number} checklistId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistItemControllerReadCollection(checklistId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistItemDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistItemControllerReadCollection(checklistId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistItemApi.checklistItemControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a single ChecklistItem
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistItemControllerReadOne(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistItemDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistItemControllerReadOne(checklistId, checklistItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistItemApi.checklistItemControllerReadOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {UpdateChecklistItemDto} updateChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistItemControllerUpdate(checklistId: number, checklistItemId: number, updateChecklistItemDto: UpdateChecklistItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistItemDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistItemControllerUpdate(checklistId, checklistItemId, updateChecklistItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistItemApi.checklistItemControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistItemApi - factory interface
 */
export const ChecklistItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistItemApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerDelete(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistItemControllerDelete(checklistId, checklistItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ChecklistItems
         * @summary Read a collection of ChecklistItems
         * @param {number} checklistId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerReadCollection(checklistId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistItemDtoPageResponse> {
            return localVarFp.checklistItemControllerReadCollection(checklistId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a single ChecklistItem
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerReadOne(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistItemDtoEntityResponse> {
            return localVarFp.checklistItemControllerReadOne(checklistId, checklistItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a checklist item
         * @param {number} checklistId 
         * @param {number} checklistItemId 
         * @param {UpdateChecklistItemDto} updateChecklistItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistItemControllerUpdate(checklistId: number, checklistItemId: number, updateChecklistItemDto: UpdateChecklistItemDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistItemDtoEntityResponse> {
            return localVarFp.checklistItemControllerUpdate(checklistId, checklistItemId, updateChecklistItemDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistItemApi - object-oriented interface
 */
export class ChecklistItemApi extends BaseAPI {
    /**
     * 
     * @summary Delete a checklist item
     * @param {number} checklistId 
     * @param {number} checklistItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistItemControllerDelete(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig) {
        return ChecklistItemApiFp(this.configuration).checklistItemControllerDelete(checklistId, checklistItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ChecklistItems
     * @summary Read a collection of ChecklistItems
     * @param {number} checklistId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistItemControllerReadCollection(checklistId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistItemApiFp(this.configuration).checklistItemControllerReadCollection(checklistId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a single ChecklistItem
     * @param {number} checklistId 
     * @param {number} checklistItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistItemControllerReadOne(checklistId: number, checklistItemId: number, options?: RawAxiosRequestConfig) {
        return ChecklistItemApiFp(this.configuration).checklistItemControllerReadOne(checklistId, checklistItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a checklist item
     * @param {number} checklistId 
     * @param {number} checklistItemId 
     * @param {UpdateChecklistItemDto} updateChecklistItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistItemControllerUpdate(checklistId: number, checklistItemId: number, updateChecklistItemDto: UpdateChecklistItemDto, options?: RawAxiosRequestConfig) {
        return ChecklistItemApiFp(this.configuration).checklistItemControllerUpdate(checklistId, checklistItemId, updateChecklistItemDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistSectionApi - axios parameter creator
 */
export const ChecklistSectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete a ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerDelete: async (checklistId: number, checklistSectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistSectionControllerDelete', 'checklistId', checklistId)
            // verify required parameter 'checklistSectionId' is not null or undefined
            assertParamExists('checklistSectionControllerDelete', 'checklistSectionId', checklistSectionId)
            const localVarPath = `/checklist/{checklistId}/checklist-sections/{checklistSectionId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)))
                .replace(`{${"checklistSectionId"}}`, encodeURIComponent(String(checklistSectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all ChecklistSections
         * @param {number} checklistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {Order} [order] 
         * @param {ChecklistSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerReadCollection: async (checklistId: number, limit: number, page: number, order?: Order, orderBy?: ChecklistSectionPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistSectionControllerReadCollection', 'checklistId', checklistId)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistSectionControllerReadCollection', 'limit', limit)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistSectionControllerReadCollection', 'page', page)
            const localVarPath = `/checklist/{checklistId}/checklist-sections`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {UpdateChecklistSectionDto} updateChecklistSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerUpdate: async (checklistId: number, checklistSectionId: number, updateChecklistSectionDto: UpdateChecklistSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistId' is not null or undefined
            assertParamExists('checklistSectionControllerUpdate', 'checklistId', checklistId)
            // verify required parameter 'checklistSectionId' is not null or undefined
            assertParamExists('checklistSectionControllerUpdate', 'checklistSectionId', checklistSectionId)
            // verify required parameter 'updateChecklistSectionDto' is not null or undefined
            assertParamExists('checklistSectionControllerUpdate', 'updateChecklistSectionDto', updateChecklistSectionDto)
            const localVarPath = `/checklist/{checklistId}/checklist-sections/{checklistSectionId}`
                .replace(`{${"checklistId"}}`, encodeURIComponent(String(checklistId)))
                .replace(`{${"checklistSectionId"}}`, encodeURIComponent(String(checklistSectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistSectionApi - functional programming interface
 */
export const ChecklistSectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistSectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete a ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistSectionControllerDelete(checklistId: number, checklistSectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistSectionControllerDelete(checklistId, checklistSectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistSectionApi.checklistSectionControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all ChecklistSections
         * @param {number} checklistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {Order} [order] 
         * @param {ChecklistSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistSectionControllerReadCollection(checklistId: number, limit: number, page: number, order?: Order, orderBy?: ChecklistSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistSectionDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistSectionControllerReadCollection(checklistId, limit, page, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistSectionApi.checklistSectionControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {UpdateChecklistSectionDto} updateChecklistSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistSectionControllerUpdate(checklistId: number, checklistSectionId: number, updateChecklistSectionDto: UpdateChecklistSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistSectionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistSectionControllerUpdate(checklistId, checklistSectionId, updateChecklistSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistSectionApi.checklistSectionControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistSectionApi - factory interface
 */
export const ChecklistSectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistSectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete a ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerDelete(checklistId: number, checklistSectionId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistSectionControllerDelete(checklistId, checklistSectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all ChecklistSections
         * @param {number} checklistId 
         * @param {number} limit 
         * @param {number} page 
         * @param {Order} [order] 
         * @param {ChecklistSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerReadCollection(checklistId: number, limit: number, page: number, order?: Order, orderBy?: ChecklistSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistSectionDtoPageResponse> {
            return localVarFp.checklistSectionControllerReadCollection(checklistId, limit, page, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update ChecklistSection
         * @param {number} checklistId 
         * @param {number} checklistSectionId 
         * @param {UpdateChecklistSectionDto} updateChecklistSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistSectionControllerUpdate(checklistId: number, checklistSectionId: number, updateChecklistSectionDto: UpdateChecklistSectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistSectionDtoEntityResponse> {
            return localVarFp.checklistSectionControllerUpdate(checklistId, checklistSectionId, updateChecklistSectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistSectionApi - object-oriented interface
 */
export class ChecklistSectionApi extends BaseAPI {
    /**
     * 
     * @summary Delete a ChecklistSection
     * @param {number} checklistId 
     * @param {number} checklistSectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistSectionControllerDelete(checklistId: number, checklistSectionId: number, options?: RawAxiosRequestConfig) {
        return ChecklistSectionApiFp(this.configuration).checklistSectionControllerDelete(checklistId, checklistSectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all ChecklistSections
     * @param {number} checklistId 
     * @param {number} limit 
     * @param {number} page 
     * @param {Order} [order] 
     * @param {ChecklistSectionPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistSectionControllerReadCollection(checklistId: number, limit: number, page: number, order?: Order, orderBy?: ChecklistSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistSectionApiFp(this.configuration).checklistSectionControllerReadCollection(checklistId, limit, page, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update ChecklistSection
     * @param {number} checklistId 
     * @param {number} checklistSectionId 
     * @param {UpdateChecklistSectionDto} updateChecklistSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistSectionControllerUpdate(checklistId: number, checklistSectionId: number, updateChecklistSectionDto: UpdateChecklistSectionDto, options?: RawAxiosRequestConfig) {
        return ChecklistSectionApiFp(this.configuration).checklistSectionControllerUpdate(checklistId, checklistSectionId, updateChecklistSectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistTemplateApi - axios parameter creator
 */
export const ChecklistTemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Clone a ChecklistTemplate with children
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerClone: async (checklistTemplateId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateControllerClone', 'checklistTemplateId', checklistTemplateId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/clone`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a checklist template
         * @param {CreateChecklistTemplateDto} createChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerCreate: async (createChecklistTemplateDto: CreateChecklistTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createChecklistTemplateDto' is not null or undefined
            assertParamExists('checklistTemplateControllerCreate', 'createChecklistTemplateDto', createChecklistTemplateDto)
            const localVarPath = `/checklist-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChecklistTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerDelete: async (checklistTemplateId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateControllerDelete', 'checklistTemplateId', checklistTemplateId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all checklist templates
         * @summary Read all checklist templates
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplatePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: ChecklistTemplatePageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistTemplateControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistTemplateControllerReadCollection', 'limit', limit)
            const localVarPath = `/checklist-templates`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerReadOne: async (checklistTemplateId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateControllerReadOne', 'checklistTemplateId', checklistTemplateId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a checklist template
         * @param {number} checklistTemplateId 
         * @param {UpdateChecklistTemplateDto} updateChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerUpdate: async (checklistTemplateId: number, updateChecklistTemplateDto: UpdateChecklistTemplateDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateControllerUpdate', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'updateChecklistTemplateDto' is not null or undefined
            assertParamExists('checklistTemplateControllerUpdate', 'updateChecklistTemplateDto', updateChecklistTemplateDto)
            const localVarPath = `/checklist-templates/{checklistTemplateId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistTemplateDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistTemplateApi - functional programming interface
 */
export const ChecklistTemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistTemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Clone a ChecklistTemplate with children
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerClone(checklistTemplateId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseClonedChecklistTemplateDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerClone(checklistTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerClone']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a checklist template
         * @param {CreateChecklistTemplateDto} createChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerCreate(createChecklistTemplateDto: CreateChecklistTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerCreate(createChecklistTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerDelete(checklistTemplateId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerDelete(checklistTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all checklist templates
         * @summary Read all checklist templates
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplatePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistTemplatePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerReadCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerReadOne(checklistTemplateId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerReadOne(checklistTemplateId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerReadOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a checklist template
         * @param {number} checklistTemplateId 
         * @param {UpdateChecklistTemplateDto} updateChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateControllerUpdate(checklistTemplateId: number, updateChecklistTemplateDto: UpdateChecklistTemplateDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateControllerUpdate(checklistTemplateId, updateChecklistTemplateDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateApi.checklistTemplateControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistTemplateApi - factory interface
 */
export const ChecklistTemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistTemplateApiFp(configuration)
    return {
        /**
         * 
         * @summary Clone a ChecklistTemplate with children
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerClone(checklistTemplateId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseClonedChecklistTemplateDtoEntityResponse> {
            return localVarFp.checklistTemplateControllerClone(checklistTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a checklist template
         * @param {CreateChecklistTemplateDto} createChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerCreate(createChecklistTemplateDto: CreateChecklistTemplateDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateDtoEntityResponse> {
            return localVarFp.checklistTemplateControllerCreate(createChecklistTemplateDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerDelete(checklistTemplateId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistTemplateControllerDelete(checklistTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all checklist templates
         * @summary Read all checklist templates
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplatePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistTemplatePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateDtoPageResponse> {
            return localVarFp.checklistTemplateControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a checklist template
         * @param {number} checklistTemplateId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerReadOne(checklistTemplateId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateDtoEntityResponse> {
            return localVarFp.checklistTemplateControllerReadOne(checklistTemplateId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a checklist template
         * @param {number} checklistTemplateId 
         * @param {UpdateChecklistTemplateDto} updateChecklistTemplateDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateControllerUpdate(checklistTemplateId: number, updateChecklistTemplateDto: UpdateChecklistTemplateDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateDtoEntityResponse> {
            return localVarFp.checklistTemplateControllerUpdate(checklistTemplateId, updateChecklistTemplateDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistTemplateApi - object-oriented interface
 */
export class ChecklistTemplateApi extends BaseAPI {
    /**
     * 
     * @summary Clone a ChecklistTemplate with children
     * @param {number} checklistTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerClone(checklistTemplateId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerClone(checklistTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a checklist template
     * @param {CreateChecklistTemplateDto} createChecklistTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerCreate(createChecklistTemplateDto: CreateChecklistTemplateDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerCreate(createChecklistTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a checklist template
     * @param {number} checklistTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerDelete(checklistTemplateId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerDelete(checklistTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all checklist templates
     * @summary Read all checklist templates
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ChecklistTemplatePageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: ChecklistTemplatePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a checklist template
     * @param {number} checklistTemplateId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerReadOne(checklistTemplateId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerReadOne(checklistTemplateId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a checklist template
     * @param {number} checklistTemplateId 
     * @param {UpdateChecklistTemplateDto} updateChecklistTemplateDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateControllerUpdate(checklistTemplateId: number, updateChecklistTemplateDto: UpdateChecklistTemplateDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateApiFp(this.configuration).checklistTemplateControllerUpdate(checklistTemplateId, updateChecklistTemplateDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistTemplateItemApi - axios parameter creator
 */
export const ChecklistTemplateItemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateItemDto} createChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerCreate: async (checklistTemplateId: number, createChecklistTemplateItemDto: CreateChecklistTemplateItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerCreate', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'createChecklistTemplateItemDto' is not null or undefined
            assertParamExists('checklistTemplateItemControllerCreate', 'createChecklistTemplateItemDto', createChecklistTemplateItemDto)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-item`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChecklistTemplateItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerDelete: async (checklistTemplateId: number, checklistTemplateItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerDelete', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateItemId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerDelete', 'checklistTemplateItemId', checklistTemplateItemId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-item/{checklistTemplateItemId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateItemId"}}`, encodeURIComponent(String(checklistTemplateItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read collection of ChecklistTemplateItems
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerReadCollection: async (checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerReadCollection', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistTemplateItemControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistTemplateItemControllerReadCollection', 'limit', limit)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-item`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read one ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerReadOne: async (checklistTemplateId: number, checklistTemplateItemId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerReadOne', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateItemId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerReadOne', 'checklistTemplateItemId', checklistTemplateItemId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-item/{checklistTemplateItemId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateItemId"}}`, encodeURIComponent(String(checklistTemplateItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {UpdateChecklistTemplateItemDto} updateChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerUpdate: async (checklistTemplateId: number, checklistTemplateItemId: number, updateChecklistTemplateItemDto: UpdateChecklistTemplateItemDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerUpdate', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateItemId' is not null or undefined
            assertParamExists('checklistTemplateItemControllerUpdate', 'checklistTemplateItemId', checklistTemplateItemId)
            // verify required parameter 'updateChecklistTemplateItemDto' is not null or undefined
            assertParamExists('checklistTemplateItemControllerUpdate', 'updateChecklistTemplateItemDto', updateChecklistTemplateItemDto)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-item/{checklistTemplateItemId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateItemId"}}`, encodeURIComponent(String(checklistTemplateItemId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistTemplateItemDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistTemplateItemApi - functional programming interface
 */
export const ChecklistTemplateItemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistTemplateItemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateItemDto} createChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateItemControllerCreate(checklistTemplateId: number, createChecklistTemplateItemDto: CreateChecklistTemplateItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateItemControllerCreate(checklistTemplateId, createChecklistTemplateItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateItemApi.checklistTemplateItemControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateItemControllerDelete(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateItemControllerDelete(checklistTemplateId, checklistTemplateItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateItemApi.checklistTemplateItemControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read collection of ChecklistTemplateItems
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateItemControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateItemDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateItemControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateItemApi.checklistTemplateItemControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read one ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateItemControllerReadOne(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateItemControllerReadOne(checklistTemplateId, checklistTemplateItemId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateItemApi.checklistTemplateItemControllerReadOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {UpdateChecklistTemplateItemDto} updateChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateItemControllerUpdate(checklistTemplateId: number, checklistTemplateItemId: number, updateChecklistTemplateItemDto: UpdateChecklistTemplateItemDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateItemControllerUpdate(checklistTemplateId, checklistTemplateItemId, updateChecklistTemplateItemDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateItemApi.checklistTemplateItemControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistTemplateItemApi - factory interface
 */
export const ChecklistTemplateItemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistTemplateItemApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateItemDto} createChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerCreate(checklistTemplateId: number, createChecklistTemplateItemDto: CreateChecklistTemplateItemDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse> {
            return localVarFp.checklistTemplateItemControllerCreate(checklistTemplateId, createChecklistTemplateItemDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerDelete(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistTemplateItemControllerDelete(checklistTemplateId, checklistTemplateItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read collection of ChecklistTemplateItems
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateItemDtoPageResponse> {
            return localVarFp.checklistTemplateItemControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read one ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerReadOne(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse> {
            return localVarFp.checklistTemplateItemControllerReadOne(checklistTemplateId, checklistTemplateItemId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a ChecklistTemplateItem
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateItemId 
         * @param {UpdateChecklistTemplateItemDto} updateChecklistTemplateItemDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateItemControllerUpdate(checklistTemplateId: number, checklistTemplateItemId: number, updateChecklistTemplateItemDto: UpdateChecklistTemplateItemDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateItemDtoEntityResponse> {
            return localVarFp.checklistTemplateItemControllerUpdate(checklistTemplateId, checklistTemplateItemId, updateChecklistTemplateItemDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistTemplateItemApi - object-oriented interface
 */
export class ChecklistTemplateItemApi extends BaseAPI {
    /**
     * 
     * @summary Create a ChecklistTemplateItem
     * @param {number} checklistTemplateId 
     * @param {CreateChecklistTemplateItemDto} createChecklistTemplateItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateItemControllerCreate(checklistTemplateId: number, createChecklistTemplateItemDto: CreateChecklistTemplateItemDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateItemApiFp(this.configuration).checklistTemplateItemControllerCreate(checklistTemplateId, createChecklistTemplateItemDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a ChecklistTemplateItem
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateItemControllerDelete(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateItemApiFp(this.configuration).checklistTemplateItemControllerDelete(checklistTemplateId, checklistTemplateItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read collection of ChecklistTemplateItems
     * @param {number} checklistTemplateId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateItemControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateItemApiFp(this.configuration).checklistTemplateItemControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read one ChecklistTemplateItem
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateItemId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateItemControllerReadOne(checklistTemplateId: number, checklistTemplateItemId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateItemApiFp(this.configuration).checklistTemplateItemControllerReadOne(checklistTemplateId, checklistTemplateItemId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a ChecklistTemplateItem
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateItemId 
     * @param {UpdateChecklistTemplateItemDto} updateChecklistTemplateItemDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateItemControllerUpdate(checklistTemplateId: number, checklistTemplateItemId: number, updateChecklistTemplateItemDto: UpdateChecklistTemplateItemDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateItemApiFp(this.configuration).checklistTemplateItemControllerUpdate(checklistTemplateId, checklistTemplateItemId, updateChecklistTemplateItemDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ChecklistTemplateSectionApi - axios parameter creator
 */
export const ChecklistTemplateSectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateSectionDto} createChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerCreate: async (checklistTemplateId: number, createChecklistTemplateSectionDto: CreateChecklistTemplateSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerCreate', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'createChecklistTemplateSectionDto' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerCreate', 'createChecklistTemplateSectionDto', createChecklistTemplateSectionDto)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-section`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createChecklistTemplateSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerDelete: async (checklistTemplateId: number, checklistTemplateSectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerDelete', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateSectionId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerDelete', 'checklistTemplateSectionId', checklistTemplateSectionId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-section/{checklistTemplateSectionId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateSectionId"}}`, encodeURIComponent(String(checklistTemplateSectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all ChecklistTemplateSections
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplateSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerReadCollection: async (checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: ChecklistTemplateSectionPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerReadCollection', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerReadCollection', 'limit', limit)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-section`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read one ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerReadOne: async (checklistTemplateId: number, checklistTemplateSectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerReadOne', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateSectionId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerReadOne', 'checklistTemplateSectionId', checklistTemplateSectionId)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-section/{checklistTemplateSectionId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateSectionId"}}`, encodeURIComponent(String(checklistTemplateSectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {UpdateChecklistTemplateSectionDto} updateChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerUpdate: async (checklistTemplateId: number, checklistTemplateSectionId: number, updateChecklistTemplateSectionDto: UpdateChecklistTemplateSectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'checklistTemplateId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerUpdate', 'checklistTemplateId', checklistTemplateId)
            // verify required parameter 'checklistTemplateSectionId' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerUpdate', 'checklistTemplateSectionId', checklistTemplateSectionId)
            // verify required parameter 'updateChecklistTemplateSectionDto' is not null or undefined
            assertParamExists('checklistTemplateSectionControllerUpdate', 'updateChecklistTemplateSectionDto', updateChecklistTemplateSectionDto)
            const localVarPath = `/checklist-templates/{checklistTemplateId}/checklist-templates-section/{checklistTemplateSectionId}`
                .replace(`{${"checklistTemplateId"}}`, encodeURIComponent(String(checklistTemplateId)))
                .replace(`{${"checklistTemplateSectionId"}}`, encodeURIComponent(String(checklistTemplateSectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateChecklistTemplateSectionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ChecklistTemplateSectionApi - functional programming interface
 */
export const ChecklistTemplateSectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ChecklistTemplateSectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateSectionDto} createChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateSectionControllerCreate(checklistTemplateId: number, createChecklistTemplateSectionDto: CreateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateSectionControllerCreate(checklistTemplateId, createChecklistTemplateSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateSectionApi.checklistTemplateSectionControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateSectionControllerDelete(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateSectionControllerDelete(checklistTemplateId, checklistTemplateSectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateSectionApi.checklistTemplateSectionControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all ChecklistTemplateSections
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplateSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateSectionControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: ChecklistTemplateSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateSectionDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateSectionControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateSectionApi.checklistTemplateSectionControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read one ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateSectionControllerReadOne(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateSectionControllerReadOne(checklistTemplateId, checklistTemplateSectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateSectionApi.checklistTemplateSectionControllerReadOne']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {UpdateChecklistTemplateSectionDto} updateChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async checklistTemplateSectionControllerUpdate(checklistTemplateId: number, checklistTemplateSectionId: number, updateChecklistTemplateSectionDto: UpdateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.checklistTemplateSectionControllerUpdate(checklistTemplateId, checklistTemplateSectionId, updateChecklistTemplateSectionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ChecklistTemplateSectionApi.checklistTemplateSectionControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ChecklistTemplateSectionApi - factory interface
 */
export const ChecklistTemplateSectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ChecklistTemplateSectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {CreateChecklistTemplateSectionDto} createChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerCreate(checklistTemplateId: number, createChecklistTemplateSectionDto: CreateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse> {
            return localVarFp.checklistTemplateSectionControllerCreate(checklistTemplateId, createChecklistTemplateSectionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerDelete(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.checklistTemplateSectionControllerDelete(checklistTemplateId, checklistTemplateSectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all ChecklistTemplateSections
         * @param {number} checklistTemplateId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ChecklistTemplateSectionPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: ChecklistTemplateSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateSectionDtoPageResponse> {
            return localVarFp.checklistTemplateSectionControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read one ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerReadOne(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse> {
            return localVarFp.checklistTemplateSectionControllerReadOne(checklistTemplateId, checklistTemplateSectionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a ChecklistTemplateSection
         * @param {number} checklistTemplateId 
         * @param {number} checklistTemplateSectionId 
         * @param {UpdateChecklistTemplateSectionDto} updateChecklistTemplateSectionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        checklistTemplateSectionControllerUpdate(checklistTemplateId: number, checklistTemplateSectionId: number, updateChecklistTemplateSectionDto: UpdateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseChecklistTemplateSectionDtoEntityResponse> {
            return localVarFp.checklistTemplateSectionControllerUpdate(checklistTemplateId, checklistTemplateSectionId, updateChecklistTemplateSectionDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ChecklistTemplateSectionApi - object-oriented interface
 */
export class ChecklistTemplateSectionApi extends BaseAPI {
    /**
     * 
     * @summary Create a ChecklistTemplateSection
     * @param {number} checklistTemplateId 
     * @param {CreateChecklistTemplateSectionDto} createChecklistTemplateSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateSectionControllerCreate(checklistTemplateId: number, createChecklistTemplateSectionDto: CreateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateSectionApiFp(this.configuration).checklistTemplateSectionControllerCreate(checklistTemplateId, createChecklistTemplateSectionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a ChecklistTemplateSection
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateSectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateSectionControllerDelete(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateSectionApiFp(this.configuration).checklistTemplateSectionControllerDelete(checklistTemplateId, checklistTemplateSectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all ChecklistTemplateSections
     * @param {number} checklistTemplateId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ChecklistTemplateSectionPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateSectionControllerReadCollection(checklistTemplateId: number, page: number, limit: number, order?: Order, orderBy?: ChecklistTemplateSectionPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateSectionApiFp(this.configuration).checklistTemplateSectionControllerReadCollection(checklistTemplateId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read one ChecklistTemplateSection
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateSectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateSectionControllerReadOne(checklistTemplateId: number, checklistTemplateSectionId: number, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateSectionApiFp(this.configuration).checklistTemplateSectionControllerReadOne(checklistTemplateId, checklistTemplateSectionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a ChecklistTemplateSection
     * @param {number} checklistTemplateId 
     * @param {number} checklistTemplateSectionId 
     * @param {UpdateChecklistTemplateSectionDto} updateChecklistTemplateSectionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public checklistTemplateSectionControllerUpdate(checklistTemplateId: number, checklistTemplateSectionId: number, updateChecklistTemplateSectionDto: UpdateChecklistTemplateSectionDto, options?: RawAxiosRequestConfig) {
        return ChecklistTemplateSectionApiFp(this.configuration).checklistTemplateSectionControllerUpdate(checklistTemplateId, checklistTemplateSectionId, updateChecklistTemplateSectionDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CompanyApi - axios parameter creator
 */
export const CompanyApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyCreate: async (companyId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addressControllerCompanyCreate', 'companyId', companyId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerCompanyCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/company/{companyId}/addresses`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyDelete: async (companyId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addressControllerCompanyDelete', 'companyId', companyId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerCompanyDelete', 'addressId', addressId)
            const localVarPath = `/company/{companyId}/addresses/{addressId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addressControllerCompanyReadCollection', 'companyId', companyId)
            const localVarPath = `/company/{companyId}/addresses`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyUpdate: async (companyId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('addressControllerCompanyUpdate', 'companyId', companyId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerCompanyUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerCompanyUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/company/{companyId}/addresses/{addressId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonConfirmationReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-confirmation`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonPdfReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-pdf`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyAddonProjectTextReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/addon-project-text`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipNewReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-new`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-ownership-used`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-commercial-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate: async (companyId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate', 'companyId', companyId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete: async (companyId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete', 'companyId', companyId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return/{articleId}`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection: async (companyId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection', 'companyId', companyId)
            const localVarPath = `/article-usages/company/{companyId}/takeover-tenancy-private-return`
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get companies user or company token can administer
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyControllerCanAdminister: async (name?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/company/can-administer`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CompanyApi - functional programming interface
 */
export const CompanyApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CompanyApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCompanyCreate(companyId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCompanyCreate(companyId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.addressControllerCompanyCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCompanyDelete(companyId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCompanyDelete(companyId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.addressControllerCompanyDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCompanyReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCompanyReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.addressControllerCompanyReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCompanyUpdate(companyId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCompanyUpdate(companyId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.addressControllerCompanyUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonConfirmationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonConfirmationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonConfirmationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonPdfCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonPdfDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonPdfReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonPdfReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonProjectTextCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonProjectTextDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyAddonProjectTextReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get companies user or company token can administer
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyControllerCanAdminister(name?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyIDNDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyControllerCanAdminister(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CompanyApi.companyControllerCanAdminister']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CompanyApi - factory interface
 */
export const CompanyApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CompanyApiFp(configuration)
    return {
        /**
         * Create an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyCreate(companyId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerCompanyCreate(companyId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyDelete(companyId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerCompanyDelete(companyId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerCompanyReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCompanyUpdate(companyId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerCompanyUpdate(companyId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonPdfReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
         * @summary 
         * @param {string} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get companies user or company token can administer
         * @param {string} [name] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyControllerCanAdminister(name?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyIDNDtoCollectionResponse> {
            return localVarFp.companyControllerCanAdminister(name, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CompanyApi - object-oriented interface
 */
export class CompanyApi extends BaseAPI {
    /**
     * Create an Address for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCompanyCreate(companyId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).addressControllerCompanyCreate(companyId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCompanyDelete(companyId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).addressControllerCompanyDelete(companyId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCompanyReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).addressControllerCompanyReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCompanyUpdate(companyId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).addressControllerCompanyUpdate(companyId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonConfirmation\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonConfirmationReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonConfirmationReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonPdfCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonPdfDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonPdf\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonPdfReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonPdfReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonProjectText\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyAddonProjectTextReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyAddonProjectTextReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipNewReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverOwnershipUsedReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyCommercialReturnReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnCreate(companyId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnDelete(companyId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Company
     * @summary 
     * @param {string} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).articleUsageControllerCompanyTakeoverTenancyPrivateReturnReadCollection(companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get companies user or company token can administer
     * @param {string} [name] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyControllerCanAdminister(name?: string, options?: RawAxiosRequestConfig) {
        return CompanyApiFp(this.configuration).companyControllerCanAdminister(name, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ConsentApi - axios parameter creator
 */
export const ConsentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Consent Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateConsentCompanyConsentDto} createConsentCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyConsentControllerCreate: async (companyConsentId: string, companyId: number, createConsentCompanyConsentDto: CreateConsentCompanyConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyConsentControllerCreate', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyConsentControllerCreate', 'companyId', companyId)
            // verify required parameter 'createConsentCompanyConsentDto' is not null or undefined
            assertParamExists('companyConsentCompanyConsentControllerCreate', 'createConsentCompanyConsentDto', createConsentCompanyConsentDto)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/company-consent-company-consents`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createConsentCompanyConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyConsentControllerDelete: async (companyConsentId: string, companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyConsentControllerDelete', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyConsentControllerDelete', 'companyId', companyId)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/company-consent-company-consents`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateCompanyConsentCompanyContactDto} createCompanyConsentCompanyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerCreate: async (companyConsentId: string, companyId: number, createCompanyConsentCompanyContactDto: CreateCompanyConsentCompanyContactDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerCreate', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerCreate', 'companyId', companyId)
            // verify required parameter 'createCompanyConsentCompanyContactDto' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerCreate', 'createCompanyConsentCompanyContactDto', createCompanyConsentCompanyContactDto)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/company-consent-company-contacts`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyConsentCompanyContactDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerDelete: async (companyConsentId: string, companyId: number, userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerDelete', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerDelete', 'companyId', companyId)
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerDelete', 'userId', userId)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/company-consent-company-contacts/{userId}`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)))
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Contacts of a Consent
         * @param {number} page 
         * @param {number} limit 
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerReadCollection: async (page: number, limit: number, companyConsentId: string, companyId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerReadCollection', 'limit', limit)
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerReadCollection', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyContactControllerReadCollection', 'companyId', companyId)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/company-consent-company-contacts`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Check if a ConsentCompany is approved
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerApproved: async (companyConsentId: string, companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerApproved', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerApproved', 'companyId', companyId)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}/approved`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a ConsentCompany
         * @param {string} companyConsentId 
         * @param {CreateCompanyConsentCompanyDto} createCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerCreate: async (companyConsentId: string, createCompanyConsentCompanyDto: CreateCompanyConsentCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerCreate', 'companyConsentId', companyConsentId)
            // verify required parameter 'createCompanyConsentCompanyDto' is not null or undefined
            assertParamExists('companyConsentCompanyControllerCreate', 'createCompanyConsentCompanyDto', createCompanyConsentCompanyDto)
            const localVarPath = `/company-consents/{companyConsentId}/companies`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyConsentCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Consent Company
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerDelete: async (companyConsentId: string, companyId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerDelete', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerDelete', 'companyId', companyId)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all ConsentCompanies of a Consent
         * @param {string} companyConsentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerReadCollection: async (companyConsentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerReadCollection', 'companyConsentId', companyConsentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('companyConsentCompanyControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('companyConsentCompanyControllerReadCollection', 'limit', limit)
            const localVarPath = `/company-consents/{companyConsentId}/companies`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a ConsentCompany
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {UpdateCompanyConsentCompanyDto} updateCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerUpdate: async (companyConsentId: string, companyId: number, updateCompanyConsentCompanyDto: UpdateCompanyConsentCompanyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerUpdate', 'companyConsentId', companyConsentId)
            // verify required parameter 'companyId' is not null or undefined
            assertParamExists('companyConsentCompanyControllerUpdate', 'companyId', companyId)
            // verify required parameter 'updateCompanyConsentCompanyDto' is not null or undefined
            assertParamExists('companyConsentCompanyControllerUpdate', 'updateCompanyConsentCompanyDto', updateCompanyConsentCompanyDto)
            const localVarPath = `/company-consents/{companyConsentId}/companies/{companyId}`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)))
                .replace(`{${"companyId"}}`, encodeURIComponent(String(companyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCompanyConsentCompanyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * If receiving company has no admins, at least one ConsentContact must be included
         * @summary Create a Consent
         * @param {CreateCompanyConsentDto} createCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerCreate: async (createCompanyConsentDto: CreateCompanyConsentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCompanyConsentDto' is not null or undefined
            assertParamExists('companyConsentControllerCreate', 'createCompanyConsentDto', createCompanyConsentDto)
            const localVarPath = `/company-consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCompanyConsentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerDelete: async (companyConsentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentControllerDelete', 'companyConsentId', companyConsentId)
            const localVarPath = `/company-consents/{companyConsentId}`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerRead: async (companyConsentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'companyConsentId' is not null or undefined
            assertParamExists('companyConsentControllerRead', 'companyConsentId', companyConsentId)
            const localVarPath = `/company-consents/{companyConsentId}`
                .replace(`{${"companyConsentId"}}`, encodeURIComponent(String(companyConsentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Consents of request user
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('companyConsentControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('companyConsentControllerReadCollection', 'limit', limit)
            const localVarPath = `/company-consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all Consents of Request User that should be consented to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerReadMissingUserConsent: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/company-consents/missing-user-consents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ConsentApi - functional programming interface
 */
export const ConsentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ConsentApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a Consent Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateConsentCompanyConsentDto} createConsentCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyConsentControllerCreate(companyConsentId: string, companyId: number, createConsentCompanyConsentDto: CreateConsentCompanyConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyConsentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyConsentControllerCreate(companyConsentId, companyId, createConsentCompanyConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyConsentControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyConsentControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyConsentControllerDelete(companyConsentId, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyConsentControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateCompanyConsentCompanyContactDto} createCompanyConsentCompanyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyContactControllerCreate(companyConsentId: string, companyId: number, createCompanyConsentCompanyContactDto: CreateCompanyConsentCompanyContactDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyContactDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyContactControllerCreate(companyConsentId, companyId, createCompanyConsentCompanyContactDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyContactControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyContactControllerDelete(companyConsentId: string, companyId: number, userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyContactControllerDelete(companyConsentId, companyId, userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyContactControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all Contacts of a Consent
         * @param {number} page 
         * @param {number} limit 
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyContactControllerReadCollection(page: number, limit: number, companyConsentId: string, companyId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyContactDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyContactControllerReadCollection(page, limit, companyConsentId, companyId, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyContactControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Check if a ConsentCompany is approved
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyControllerApproved(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ApprovedResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyControllerApproved(companyConsentId, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyControllerApproved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a ConsentCompany
         * @param {string} companyConsentId 
         * @param {CreateCompanyConsentCompanyDto} createCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyControllerCreate(companyConsentId: string, createCompanyConsentCompanyDto: CreateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyControllerCreate(companyConsentId, createCompanyConsentCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Consent Company
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyControllerDelete(companyConsentId, companyId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all ConsentCompanies of a Consent
         * @param {string} companyConsentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyControllerReadCollection(companyConsentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyControllerReadCollection(companyConsentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a ConsentCompany
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {UpdateCompanyConsentCompanyDto} updateCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentCompanyControllerUpdate(companyConsentId: string, companyId: number, updateCompanyConsentCompanyDto: UpdateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCompanyDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentCompanyControllerUpdate(companyConsentId, companyId, updateCompanyConsentCompanyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentCompanyControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * If receiving company has no admins, at least one ConsentContact must be included
         * @summary Create a Consent
         * @param {CreateCompanyConsentDto} createCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentControllerCreate(createCompanyConsentDto: CreateCompanyConsentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentControllerCreate(createCompanyConsentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentControllerDelete(companyConsentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentControllerDelete(companyConsentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentControllerRead(companyConsentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentControllerRead(companyConsentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all Consents of request user
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentCollectionItemDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentControllerReadCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all Consents of Request User that should be consented to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async companyConsentControllerReadMissingUserConsent(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCompanyConsentIDNDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.companyConsentControllerReadMissingUserConsent(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ConsentApi.companyConsentControllerReadMissingUserConsent']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ConsentApi - factory interface
 */
export const ConsentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ConsentApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a Consent Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateConsentCompanyConsentDto} createConsentCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyConsentControllerCreate(companyConsentId: string, companyId: number, createConsentCompanyConsentDto: CreateConsentCompanyConsentDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyConsentDtoEntityResponse> {
            return localVarFp.companyConsentCompanyConsentControllerCreate(companyConsentId, companyId, createConsentCompanyConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyConsentControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.companyConsentCompanyConsentControllerDelete(companyConsentId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {CreateCompanyConsentCompanyContactDto} createCompanyConsentCompanyContactDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerCreate(companyConsentId: string, companyId: number, createCompanyConsentCompanyContactDto: CreateCompanyConsentCompanyContactDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyContactDtoEntityResponse> {
            return localVarFp.companyConsentCompanyContactControllerCreate(companyConsentId, companyId, createCompanyConsentCompanyContactDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Consent Contact
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerDelete(companyConsentId: string, companyId: number, userId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.companyConsentCompanyContactControllerDelete(companyConsentId, companyId, userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all Contacts of a Consent
         * @param {number} page 
         * @param {number} limit 
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyContactControllerReadCollection(page: number, limit: number, companyConsentId: string, companyId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyContactDtoPageResponse> {
            return localVarFp.companyConsentCompanyContactControllerReadCollection(page, limit, companyConsentId, companyId, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Check if a ConsentCompany is approved
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerApproved(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<ApprovedResponseDto> {
            return localVarFp.companyConsentCompanyControllerApproved(companyConsentId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a ConsentCompany
         * @param {string} companyConsentId 
         * @param {CreateCompanyConsentCompanyDto} createCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerCreate(companyConsentId: string, createCompanyConsentCompanyDto: CreateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyDtoEntityResponse> {
            return localVarFp.companyConsentCompanyControllerCreate(companyConsentId, createCompanyConsentCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Consent Company
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.companyConsentCompanyControllerDelete(companyConsentId, companyId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all ConsentCompanies of a Consent
         * @param {string} companyConsentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerReadCollection(companyConsentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyDtoPageResponse> {
            return localVarFp.companyConsentCompanyControllerReadCollection(companyConsentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a ConsentCompany
         * @param {string} companyConsentId 
         * @param {number} companyId 
         * @param {UpdateCompanyConsentCompanyDto} updateCompanyConsentCompanyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentCompanyControllerUpdate(companyConsentId: string, companyId: number, updateCompanyConsentCompanyDto: UpdateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCompanyDtoEntityResponse> {
            return localVarFp.companyConsentCompanyControllerUpdate(companyConsentId, companyId, updateCompanyConsentCompanyDto, options).then((request) => request(axios, basePath));
        },
        /**
         * If receiving company has no admins, at least one ConsentContact must be included
         * @summary Create a Consent
         * @param {CreateCompanyConsentDto} createCompanyConsentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerCreate(createCompanyConsentDto: CreateCompanyConsentDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentDtoEntityResponse> {
            return localVarFp.companyConsentControllerCreate(createCompanyConsentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerDelete(companyConsentId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.companyConsentControllerDelete(companyConsentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a Consent
         * @param {string} companyConsentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerRead(companyConsentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentDtoEntityResponse> {
            return localVarFp.companyConsentControllerRead(companyConsentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all Consents of request user
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentCollectionItemDtoPageResponse> {
            return localVarFp.companyConsentControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all Consents of Request User that should be consented to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        companyConsentControllerReadMissingUserConsent(options?: RawAxiosRequestConfig): AxiosPromise<ResponseCompanyConsentIDNDtoCollectionResponse> {
            return localVarFp.companyConsentControllerReadMissingUserConsent(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ConsentApi - object-oriented interface
 */
export class ConsentApi extends BaseAPI {
    /**
     * 
     * @summary Create a Consent Consent
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {CreateConsentCompanyConsentDto} createConsentCompanyConsentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyConsentControllerCreate(companyConsentId: string, companyId: number, createConsentCompanyConsentDto: CreateConsentCompanyConsentDto, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyConsentControllerCreate(companyConsentId, companyId, createConsentCompanyConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Consent
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyConsentControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyConsentControllerDelete(companyConsentId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a Consent Contact
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {CreateCompanyConsentCompanyContactDto} createCompanyConsentCompanyContactDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyContactControllerCreate(companyConsentId: string, companyId: number, createCompanyConsentCompanyContactDto: CreateCompanyConsentCompanyContactDto, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyContactControllerCreate(companyConsentId, companyId, createCompanyConsentCompanyContactDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Consent Contact
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyContactControllerDelete(companyConsentId: string, companyId: number, userId: number, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyContactControllerDelete(companyConsentId, companyId, userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all Contacts of a Consent
     * @param {number} page 
     * @param {number} limit 
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyContactControllerReadCollection(page: number, limit: number, companyConsentId: string, companyId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyContactControllerReadCollection(page, limit, companyConsentId, companyId, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Check if a ConsentCompany is approved
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyControllerApproved(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyControllerApproved(companyConsentId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a ConsentCompany
     * @param {string} companyConsentId 
     * @param {CreateCompanyConsentCompanyDto} createCompanyConsentCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyControllerCreate(companyConsentId: string, createCompanyConsentCompanyDto: CreateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyControllerCreate(companyConsentId, createCompanyConsentCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Consent Company
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyControllerDelete(companyConsentId: string, companyId: number, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyControllerDelete(companyConsentId, companyId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all ConsentCompanies of a Consent
     * @param {string} companyConsentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyControllerReadCollection(companyConsentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyControllerReadCollection(companyConsentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a ConsentCompany
     * @param {string} companyConsentId 
     * @param {number} companyId 
     * @param {UpdateCompanyConsentCompanyDto} updateCompanyConsentCompanyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentCompanyControllerUpdate(companyConsentId: string, companyId: number, updateCompanyConsentCompanyDto: UpdateCompanyConsentCompanyDto, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentCompanyControllerUpdate(companyConsentId, companyId, updateCompanyConsentCompanyDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * If receiving company has no admins, at least one ConsentContact must be included
     * @summary Create a Consent
     * @param {CreateCompanyConsentDto} createCompanyConsentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentControllerCreate(createCompanyConsentDto: CreateCompanyConsentDto, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentControllerCreate(createCompanyConsentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Consent
     * @param {string} companyConsentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentControllerDelete(companyConsentId: string, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentControllerDelete(companyConsentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a Consent
     * @param {string} companyConsentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentControllerRead(companyConsentId: string, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentControllerRead(companyConsentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all Consents of request user
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all Consents of Request User that should be consented to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public companyConsentControllerReadMissingUserConsent(options?: RawAxiosRequestConfig) {
        return ConsentApiFp(this.configuration).companyConsentControllerReadMissingUserConsent(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ContractorAddonApi - axios parameter creator
 */
export const ContractorAddonApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonCreate: async (contractorAddonId: string, createModelTraitDto: CreateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorAddonId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonCreate', 'contractorAddonId', contractorAddonId)
            // verify required parameter 'createModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonCreate', 'createModelTraitDto', createModelTraitDto)
            const localVarPath = `/contractor-addon/{contractorAddonId}/model-traits`
                .replace(`{${"contractorAddonId"}}`, encodeURIComponent(String(contractorAddonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonDelete: async (contractorAddonId: string, modelTraitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorAddonId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonDelete', 'contractorAddonId', contractorAddonId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonDelete', 'modelTraitId', modelTraitId)
            const localVarPath = `/contractor-addon/{contractorAddonId}/model-traits/{modelTraitId}`
                .replace(`{${"contractorAddonId"}}`, encodeURIComponent(String(contractorAddonId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all traits on ContractorAddon by modelId
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadCollection: async (contractorAddonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorAddonId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadCollection', 'contractorAddonId', contractorAddonId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadCollection', 'limit', limit)
            const localVarPath = `/contractor-addon/{contractorAddonId}/model-traits`
                .replace(`{${"contractorAddonId"}}`, encodeURIComponent(String(contractorAddonId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadCollectionOnModel: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadCollectionOnModel', 'name', name)
            const localVarPath = `/contractor-addon/model-traits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadNameCollection: async (name: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadNameCollection', 'name', name)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonReadNameCollection', 'value', value)
            const localVarPath = `/contractor-addon/model-traits/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonUpdate: async (contractorAddonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'contractorAddonId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonUpdate', 'contractorAddonId', contractorAddonId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonUpdate', 'modelTraitId', modelTraitId)
            // verify required parameter 'updateModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerContractorAddonUpdate', 'updateModelTraitDto', updateModelTraitDto)
            const localVarPath = `/contractor-addon/{contractorAddonId}/model-traits/{modelTraitId}`
                .replace(`{${"contractorAddonId"}}`, encodeURIComponent(String(contractorAddonId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ContractorAddonApi - functional programming interface
 */
export const ContractorAddonApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ContractorAddonApiAxiosParamCreator(configuration)
    return {
        /**
         * Create a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonCreate(contractorAddonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonCreate(contractorAddonId, createModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonDelete(contractorAddonId: string, modelTraitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonDelete(contractorAddonId, modelTraitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all traits on ContractorAddon by modelId
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonReadCollection(contractorAddonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonReadCollection(contractorAddonId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonReadCollectionOnModel(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonReadCollectionOnModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonReadNameCollection(name, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonReadNameCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerContractorAddonUpdate(contractorAddonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerContractorAddonUpdate(contractorAddonId, modelTraitId, updateModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ContractorAddonApi.modelTraitControllerContractorAddonUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ContractorAddonApi - factory interface
 */
export const ContractorAddonApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ContractorAddonApiFp(configuration)
    return {
        /**
         * Create a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonCreate(contractorAddonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerContractorAddonCreate(contractorAddonId, createModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonDelete(contractorAddonId: string, modelTraitId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.modelTraitControllerContractorAddonDelete(contractorAddonId, modelTraitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all traits on ContractorAddon by modelId
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadCollection(contractorAddonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoPageResponse> {
            return localVarFp.modelTraitControllerContractorAddonReadCollection(contractorAddonId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerContractorAddonReadCollectionOnModel(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for ContractorAddon
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerContractorAddonReadNameCollection(name, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ModelTrait for ContractorAddon
         * @summary 
         * @param {string} contractorAddonId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerContractorAddonUpdate(contractorAddonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerContractorAddonUpdate(contractorAddonId, modelTraitId, updateModelTraitDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ContractorAddonApi - object-oriented interface
 */
export class ContractorAddonApi extends BaseAPI {
    /**
     * Create a ModelTrait for ContractorAddon
     * @summary 
     * @param {string} contractorAddonId 
     * @param {CreateModelTraitDto} createModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonCreate(contractorAddonId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonCreate(contractorAddonId, createModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ModelTrait for ContractorAddon
     * @summary 
     * @param {string} contractorAddonId 
     * @param {number} modelTraitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonDelete(contractorAddonId: string, modelTraitId: number, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonDelete(contractorAddonId, modelTraitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all traits on ContractorAddon by modelId
     * @summary 
     * @param {string} contractorAddonId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonReadCollection(contractorAddonId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonReadCollection(contractorAddonId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for ContractorAddon filtered by name
     * @summary 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonReadCollectionOnModel(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for ContractorAddon
     * @summary 
     * @param {string} name 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonReadNameCollection(name, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ModelTrait for ContractorAddon
     * @summary 
     * @param {string} contractorAddonId 
     * @param {number} modelTraitId 
     * @param {UpdateModelTraitDto} updateModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerContractorAddonUpdate(contractorAddonId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ContractorAddonApiFp(this.configuration).modelTraitControllerContractorAddonUpdate(contractorAddonId, modelTraitId, updateModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CrmUserApi - axios parameter creator
 */
export const CrmUserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserCreate: async (crmUserId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('addressControllerCrmUserCreate', 'crmUserId', crmUserId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerCrmUserCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/crmUser/{crmUserId}/addresses`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserDelete: async (crmUserId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('addressControllerCrmUserDelete', 'crmUserId', crmUserId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerCrmUserDelete', 'addressId', addressId)
            const localVarPath = `/crmUser/{crmUserId}/addresses/{addressId}`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserReadCollection: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('addressControllerCrmUserReadCollection', 'crmUserId', crmUserId)
            const localVarPath = `/crmUser/{crmUserId}/addresses`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserUpdate: async (crmUserId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('addressControllerCrmUserUpdate', 'crmUserId', crmUserId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerCrmUserUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerCrmUserUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/crmUser/{crmUserId}/addresses/{addressId}`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Attach a CRMUser to a User with same email
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerAttachCrmUserToUser: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerAttachCrmUserToUser', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}/attach`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a CRMUser
         * @param {CreateCrmUserDto} createCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerCreate: async (createCrmUserDto: CreateCrmUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createCrmUserDto' is not null or undefined
            assertParamExists('crmUserControllerCreate', 'createCrmUserDto', createCrmUserDto)
            const localVarPath = `/crm-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createCrmUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a CrmUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerDelete: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerDelete', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Detach a CRMUser from User
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerDetachCrmUserFromUser: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerDetachCrmUserFromUser', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}/detach`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerRead: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerRead', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {CrmUserPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {number | null} [projectId] Filter results on ProjectId. Designed for future use
         * @param {number | null} [companyId] Filter results on CompanyId.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: CrmUserPageOptionsOrderBy, objectId?: number | null, projectId?: number | null, companyId?: number | null, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('crmUserControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('crmUserControllerReadCollection', 'limit', limit)
            const localVarPath = `/crm-users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['ObjectId'] = objectId;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Returns UserInvites from a given CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadUserInvite: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerReadUserInvite', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}/user-invites`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a User with same email as CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadUserWithEqualEmail: async (crmUserId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerReadUserWithEqualEmail', 'crmUserId', crmUserId)
            const localVarPath = `/crm-users/{crmUserId}/user`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an CrmUser
         * @param {string} crmUserId 
         * @param {UpdateCrmUserDto} updateCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerUpdate: async (crmUserId: string, updateCrmUserDto: UpdateCrmUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'crmUserId' is not null or undefined
            assertParamExists('crmUserControllerUpdate', 'crmUserId', crmUserId)
            // verify required parameter 'updateCrmUserDto' is not null or undefined
            assertParamExists('crmUserControllerUpdate', 'updateCrmUserDto', updateCrmUserDto)
            const localVarPath = `/crm-users/{crmUserId}`
                .replace(`{${"crmUserId"}}`, encodeURIComponent(String(crmUserId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateCrmUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CrmUserApi - functional programming interface
 */
export const CrmUserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CrmUserApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCrmUserCreate(crmUserId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCrmUserCreate(crmUserId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.addressControllerCrmUserCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCrmUserDelete(crmUserId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCrmUserDelete(crmUserId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.addressControllerCrmUserDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCrmUserReadCollection(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCrmUserReadCollection(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.addressControllerCrmUserReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerCrmUserUpdate(crmUserId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerCrmUserUpdate(crmUserId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.addressControllerCrmUserUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Attach a CRMUser to a User with same email
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerAttachCrmUserToUser(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerAttachCrmUserToUser(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerAttachCrmUserToUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a CRMUser
         * @param {CreateCrmUserDto} createCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerCreate(createCrmUserDto: CreateCrmUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerCreate(createCrmUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a CrmUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerDelete(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerDelete(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Detach a CRMUser from User
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerDetachCrmUserFromUser(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerDetachCrmUserFromUser(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerDetachCrmUserFromUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerRead(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerRead(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {CrmUserPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {number | null} [projectId] Filter results on ProjectId. Designed for future use
         * @param {number | null} [companyId] Filter results on CompanyId.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: CrmUserPageOptionsOrderBy, objectId?: number | null, projectId?: number | null, companyId?: number | null, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerReadCollection(page, limit, order, orderBy, objectId, projectId, companyId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Returns UserInvites from a given CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerReadUserInvite(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserInviteDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerReadUserInvite(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerReadUserInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a User with same email as CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerReadUserWithEqualEmail(crmUserId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerReadUserWithEqualEmail(crmUserId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerReadUserWithEqualEmail']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an CrmUser
         * @param {string} crmUserId 
         * @param {UpdateCrmUserDto} updateCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async crmUserControllerUpdate(crmUserId: string, updateCrmUserDto: UpdateCrmUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCrmUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.crmUserControllerUpdate(crmUserId, updateCrmUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CrmUserApi.crmUserControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CrmUserApi - factory interface
 */
export const CrmUserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CrmUserApiFp(configuration)
    return {
        /**
         * Create an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserCreate(crmUserId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerCrmUserCreate(crmUserId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserDelete(crmUserId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerCrmUserDelete(crmUserId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserReadCollection(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerCrmUserReadCollection(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for CrmUser
         * @summary 
         * @param {string} crmUserId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerCrmUserUpdate(crmUserId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerCrmUserUpdate(crmUserId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Attach a CRMUser to a User with same email
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerAttachCrmUserToUser(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoEntityResponse> {
            return localVarFp.crmUserControllerAttachCrmUserToUser(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a CRMUser
         * @param {CreateCrmUserDto} createCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerCreate(createCrmUserDto: CreateCrmUserDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoEntityResponse> {
            return localVarFp.crmUserControllerCreate(createCrmUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a CrmUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerDelete(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.crmUserControllerDelete(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Detach a CRMUser from User
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerDetachCrmUserFromUser(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.crmUserControllerDetachCrmUserFromUser(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerRead(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoEntityResponse> {
            return localVarFp.crmUserControllerRead(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {CrmUserPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {number | null} [projectId] Filter results on ProjectId. Designed for future use
         * @param {number | null} [companyId] Filter results on CompanyId.
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: CrmUserPageOptionsOrderBy, objectId?: number | null, projectId?: number | null, companyId?: number | null, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoPageResponse> {
            return localVarFp.crmUserControllerReadCollection(page, limit, order, orderBy, objectId, projectId, companyId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Returns UserInvites from a given CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadUserInvite(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserInviteDtoEntityResponse> {
            return localVarFp.crmUserControllerReadUserInvite(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a User with same email as CRMUser
         * @param {string} crmUserId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerReadUserWithEqualEmail(crmUserId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoEntityResponse> {
            return localVarFp.crmUserControllerReadUserWithEqualEmail(crmUserId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an CrmUser
         * @param {string} crmUserId 
         * @param {UpdateCrmUserDto} updateCrmUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        crmUserControllerUpdate(crmUserId: string, updateCrmUserDto: UpdateCrmUserDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCrmUserDtoEntityResponse> {
            return localVarFp.crmUserControllerUpdate(crmUserId, updateCrmUserDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CrmUserApi - object-oriented interface
 */
export class CrmUserApi extends BaseAPI {
    /**
     * Create an Address for CrmUser
     * @summary 
     * @param {string} crmUserId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCrmUserCreate(crmUserId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).addressControllerCrmUserCreate(crmUserId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for CrmUser
     * @summary 
     * @param {string} crmUserId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCrmUserDelete(crmUserId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).addressControllerCrmUserDelete(crmUserId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for CrmUser
     * @summary 
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCrmUserReadCollection(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).addressControllerCrmUserReadCollection(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for CrmUser
     * @summary 
     * @param {string} crmUserId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerCrmUserUpdate(crmUserId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).addressControllerCrmUserUpdate(crmUserId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Attach a CRMUser to a User with same email
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerAttachCrmUserToUser(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerAttachCrmUserToUser(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a CRMUser
     * @param {CreateCrmUserDto} createCrmUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerCreate(createCrmUserDto: CreateCrmUserDto, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerCreate(createCrmUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a CrmUser
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerDelete(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerDelete(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Detach a CRMUser from User
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerDetachCrmUserFromUser(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerDetachCrmUserFromUser(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a CRMUser
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerRead(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerRead(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {CrmUserPageOptionsOrderBy} [orderBy] 
     * @param {number | null} [objectId] Filter results on ObjectId
     * @param {number | null} [projectId] Filter results on ProjectId. Designed for future use
     * @param {number | null} [companyId] Filter results on CompanyId.
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: CrmUserPageOptionsOrderBy, objectId?: number | null, projectId?: number | null, companyId?: number | null, search?: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerReadCollection(page, limit, order, orderBy, objectId, projectId, companyId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Returns UserInvites from a given CRMUser
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerReadUserInvite(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerReadUserInvite(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a User with same email as CRMUser
     * @param {string} crmUserId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerReadUserWithEqualEmail(crmUserId: string, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerReadUserWithEqualEmail(crmUserId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an CrmUser
     * @param {string} crmUserId 
     * @param {UpdateCrmUserDto} updateCrmUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public crmUserControllerUpdate(crmUserId: string, updateCrmUserDto: UpdateCrmUserDto, options?: RawAxiosRequestConfig) {
        return CrmUserApiFp(this.configuration).crmUserControllerUpdate(crmUserId, updateCrmUserDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * CryptoApi - axios parameter creator
 */
export const CryptoApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cryptoControllerHash: async (body: object, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'body' is not null or undefined
            assertParamExists('cryptoControllerHash', 'body', body)
            const localVarPath = `/crypto/hash`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CryptoApi - functional programming interface
 */
export const CryptoApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CryptoApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async cryptoControllerHash(body: object, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHashDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.cryptoControllerHash(body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CryptoApi.cryptoControllerHash']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CryptoApi - factory interface
 */
export const CryptoApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CryptoApiFp(configuration)
    return {
        /**
         * 
         * @param {object} body 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        cryptoControllerHash(body: object, options?: RawAxiosRequestConfig): AxiosPromise<ResponseHashDtoEntityResponse> {
            return localVarFp.cryptoControllerHash(body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CryptoApi - object-oriented interface
 */
export class CryptoApi extends BaseAPI {
    /**
     * 
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public cryptoControllerHash(body: object, options?: RawAxiosRequestConfig) {
        return CryptoApiFp(this.configuration).cryptoControllerHash(body, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FieldApi - axios parameter creator
 */
export const FieldApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {CreateFieldDto} createFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerCreate: async (createFieldDto: CreateFieldDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFieldDto' is not null or undefined
            assertParamExists('fieldControllerCreate', 'createFieldDto', createFieldDto)
            const localVarPath = `/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFieldDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerDelete: async (fieldId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('fieldControllerDelete', 'fieldId', fieldId)
            const localVarPath = `/fields/{fieldId}`
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerRead: async (fieldId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('fieldControllerRead', 'fieldId', fieldId)
            const localVarPath = `/fields/{fieldId}`
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {FieldPageOptionsOrderBy} [orderBy] 
         * @param {number} [companyId] Filter results on CompanyId
         * @param {number} [status] Filter results on status
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: FieldPageOptionsOrderBy, companyId?: number, status?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('fieldControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('fieldControllerReadCollection', 'limit', limit)
            const localVarPath = `/fields`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (companyId !== undefined) {
                localVarQueryParameter['CompanyId'] = companyId;
            }

            if (status !== undefined) {
                localVarQueryParameter['status'] = status;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {UpdateFieldDto} updateFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerUpdate: async (fieldId: number, updateFieldDto: UpdateFieldDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('fieldControllerUpdate', 'fieldId', fieldId)
            // verify required parameter 'updateFieldDto' is not null or undefined
            assertParamExists('fieldControllerUpdate', 'updateFieldDto', updateFieldDto)
            const localVarPath = `/fields/{fieldId}`
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFieldDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FieldApi - functional programming interface
 */
export const FieldApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FieldApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {CreateFieldDto} createFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldControllerCreate(createFieldDto: CreateFieldDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFieldDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fieldControllerCreate(createFieldDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FieldApi.fieldControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldControllerDelete(fieldId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fieldControllerDelete(fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FieldApi.fieldControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldControllerRead(fieldId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFieldDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fieldControllerRead(fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FieldApi.fieldControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {FieldPageOptionsOrderBy} [orderBy] 
         * @param {number} [companyId] Filter results on CompanyId
         * @param {number} [status] Filter results on status
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: FieldPageOptionsOrderBy, companyId?: number, status?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFieldDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fieldControllerReadCollection(page, limit, order, orderBy, companyId, status, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FieldApi.fieldControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {UpdateFieldDto} updateFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fieldControllerUpdate(fieldId: number, updateFieldDto: UpdateFieldDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFieldDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fieldControllerUpdate(fieldId, updateFieldDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FieldApi.fieldControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FieldApi - factory interface
 */
export const FieldApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FieldApiFp(configuration)
    return {
        /**
         * 
         * @param {CreateFieldDto} createFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerCreate(createFieldDto: CreateFieldDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFieldDtoEntityResponse> {
            return localVarFp.fieldControllerCreate(createFieldDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerDelete(fieldId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fieldControllerDelete(fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerRead(fieldId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFieldDtoEntityResponse> {
            return localVarFp.fieldControllerRead(fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {FieldPageOptionsOrderBy} [orderBy] 
         * @param {number} [companyId] Filter results on CompanyId
         * @param {number} [status] Filter results on status
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: FieldPageOptionsOrderBy, companyId?: number, status?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFieldDtoPageResponse> {
            return localVarFp.fieldControllerReadCollection(page, limit, order, orderBy, companyId, status, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} fieldId 
         * @param {UpdateFieldDto} updateFieldDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fieldControllerUpdate(fieldId: number, updateFieldDto: UpdateFieldDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFieldDtoEntityResponse> {
            return localVarFp.fieldControllerUpdate(fieldId, updateFieldDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FieldApi - object-oriented interface
 */
export class FieldApi extends BaseAPI {
    /**
     * 
     * @param {CreateFieldDto} createFieldDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fieldControllerCreate(createFieldDto: CreateFieldDto, options?: RawAxiosRequestConfig) {
        return FieldApiFp(this.configuration).fieldControllerCreate(createFieldDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fieldId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fieldControllerDelete(fieldId: number, options?: RawAxiosRequestConfig) {
        return FieldApiFp(this.configuration).fieldControllerDelete(fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fieldId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fieldControllerRead(fieldId: number, options?: RawAxiosRequestConfig) {
        return FieldApiFp(this.configuration).fieldControllerRead(fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {FieldPageOptionsOrderBy} [orderBy] 
     * @param {number} [companyId] Filter results on CompanyId
     * @param {number} [status] Filter results on status
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fieldControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: FieldPageOptionsOrderBy, companyId?: number, status?: number, search?: string, options?: RawAxiosRequestConfig) {
        return FieldApiFp(this.configuration).fieldControllerReadCollection(page, limit, order, orderBy, companyId, status, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} fieldId 
     * @param {UpdateFieldDto} updateFieldDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fieldControllerUpdate(fieldId: number, updateFieldDto: UpdateFieldDto, options?: RawAxiosRequestConfig) {
        return FieldApiFp(this.configuration).fieldControllerUpdate(fieldId, updateFieldDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileApi - axios parameter creator
 */
export const FileApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Post a file policy
         * @param {CreateFileSigningPolicyDto} createFileSigningPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerSign: async (createFileSigningPolicyDto: CreateFileSigningPolicyDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFileSigningPolicyDto' is not null or undefined
            assertParamExists('fileControllerSign', 'createFileSigningPolicyDto', createFileSigningPolicyDto)
            const localVarPath = `/files/upload/sign`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileSigningPolicyDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileApi - functional programming interface
 */
export const FileApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Post a file policy
         * @param {CreateFileSigningPolicyDto} createFileSigningPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileControllerSign(createFileSigningPolicyDto: CreateFileSigningPolicyDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileSigningPolicyDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileControllerSign(createFileSigningPolicyDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileApi.fileControllerSign']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileApi - factory interface
 */
export const FileApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileApiFp(configuration)
    return {
        /**
         * 
         * @summary Post a file policy
         * @param {CreateFileSigningPolicyDto} createFileSigningPolicyDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileControllerSign(createFileSigningPolicyDto: CreateFileSigningPolicyDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileSigningPolicyDtoEntityResponse> {
            return localVarFp.fileControllerSign(createFileSigningPolicyDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileApi - object-oriented interface
 */
export class FileApi extends BaseAPI {
    /**
     * 
     * @summary Post a file policy
     * @param {CreateFileSigningPolicyDto} createFileSigningPolicyDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileControllerSign(createFileSigningPolicyDto: CreateFileSigningPolicyDto, options?: RawAxiosRequestConfig) {
        return FileApiFp(this.configuration).fileControllerSign(createFileSigningPolicyDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FileUsageApi - axios parameter creator
 */
export const FileUsageApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCount: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCount', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/files/count`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCreate: async (articleId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCreate', 'articleId', articleId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/files`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesDelete: async (articleId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesDelete', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/article/{articleId}/files/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesReadCollection: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesReadCollection', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/files`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSort: async (articleId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSort', 'articleId', articleId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/article/{articleId}/files/sort`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSwap: async (articleId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/article/{articleId}/files/swap/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesUpdate: async (articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleFilesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/files/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCount: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCount', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/images/count`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCreate: async (articleId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCreate', 'articleId', articleId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/images`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesDelete: async (articleId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesDelete', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/article/{articleId}/images/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesReadCollection: async (articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesReadCollection', 'articleId', articleId)
            const localVarPath = `/file-usages/article/{articleId}/images`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSort: async (articleId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSort', 'articleId', articleId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/article/{articleId}/images/sort`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSwap: async (articleId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/article/{articleId}/images/swap/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesUpdate: async (articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'articleId', articleId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerArticleImagesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/article/{articleId}/images/{fileId}`
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCount: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCount', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/count`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCreate: async (unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCreate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesDelete: async (unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesDelete', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesReadCollection: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesReadCollection', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSort: async (unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSort', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/sort`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSwap: async (unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/swap/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesUpdate: async (unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FileUsageApi - functional programming interface
 */
export const FileUsageApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FileUsageApiAxiosParamCreator(configuration)
    return {
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesCount(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesReadCollection(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleFilesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesCount(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesReadCollection(articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerArticleImagesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionLogosUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FileUsageApi.fileUsageControllerUnwantedIncidentFilesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FileUsageApi - factory interface
 */
export const FileUsageApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FileUsageApiFp(configuration)
    return {
        /**
         * Count all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesCount(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleFilesReadCollection(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Files\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesCount(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleImagesReadCollection(articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Images\" for Article
         * @summary 
         * @param {string} articleId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FileUsageApi - object-oriented interface
 */
export class FileUsageApi extends BaseAPI {
    /**
     * Count all FileUsages in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesCount(articleId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesCount(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesCreate(articleId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesDelete(articleId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesReadCollection(articleId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesReadCollection(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesSort(articleId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesSwap(articleId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Files\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleFilesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleFilesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesCount(articleId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesCount(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesCreate(articleId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesCreate(articleId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesDelete(articleId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesDelete(articleId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesReadCollection(articleId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesReadCollection(articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesSort(articleId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesSort(articleId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesSwap(articleId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesSwap(articleId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Images\" for Article
     * @summary 
     * @param {string} articleId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerArticleImagesUpdate(articleId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerArticleImagesUpdate(articleId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return FileUsageApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FilterApi - axios parameter creator
 */
export const FilterApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadObjectFilterCollection: async (page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadObjectFilterCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadObjectFilterCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/filter/object`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadProjectFilterCollection: async (page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadProjectFilterCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadProjectFilterCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/filter/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FilterApi - functional programming interface
 */
export const FilterApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FilterApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterApi.unwantedIncidentFilterControllerReadObjectFilterCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FilterApi.unwantedIncidentFilterControllerReadProjectFilterCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FilterApi - factory interface
 */
export const FilterApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FilterApiFp(configuration)
    return {
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterDtoPageResponse> {
            return localVarFp.unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterDtoPageResponse> {
            return localVarFp.unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FilterApi - object-oriented interface
 */
export class FilterApi extends BaseAPI {
    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return FilterApiFp(this.configuration).unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return FilterApiFp(this.configuration).unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * FolderApi - axios parameter creator
 */
export const FolderApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerCreate: async (createFolderDto: CreateFolderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createFolderDto' is not null or undefined
            assertParamExists('folderControllerCreate', 'createFolderDto', createFolderDto)
            const localVarPath = `/folders`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFolderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerDelete: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerDelete', 'folderId', folderId)
            const localVarPath = `/folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Generate PDF report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {ObjectFieldReportPdfDto} objectFieldReportPdfDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerGenerateReportPdfForField: async (objectId: number, objectFieldId: number, objectFieldReportPdfDto: ObjectFieldReportPdfDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('folderControllerGenerateReportPdfForField', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('folderControllerGenerateReportPdfForField', 'objectFieldId', objectFieldId)
            // verify required parameter 'objectFieldReportPdfDto' is not null or undefined
            assertParamExists('folderControllerGenerateReportPdfForField', 'objectFieldReportPdfDto', objectFieldReportPdfDto)
            const localVarPath = `/folders/object/{objectId}/object-field/{objectFieldId}/report/pdf`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(objectFieldReportPdfDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a folder field with a catalog
         * @param {string} folderId 
         * @param {PostFolderFieldMappingDto} postFolderFieldMappingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerPostFieldMapping: async (folderId: string, postFolderFieldMappingDto: PostFolderFieldMappingDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerPostFieldMapping', 'folderId', folderId)
            // verify required parameter 'postFolderFieldMappingDto' is not null or undefined
            assertParamExists('folderControllerPostFieldMapping', 'postFolderFieldMappingDto', postFolderFieldMappingDto)
            const localVarPath = `/folders/{folderId}/field-mapping`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(postFolderFieldMappingDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a folder
         * @param {string} folderId 
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerRead: async (folderId: string, orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerRead', 'folderId', folderId)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('folderControllerRead', 'orderBy', orderBy)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('folderControllerRead', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('folderControllerRead', 'limit', limit)
            const localVarPath = `/folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a paginated collection of a folders children
         * @param {string} folderId 
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadChildren: async (folderId: string, orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerReadChildren', 'folderId', folderId)
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('folderControllerReadChildren', 'orderBy', orderBy)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('folderControllerReadChildren', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('folderControllerReadChildren', 'limit', limit)
            const localVarPath = `/folders/{folderId}/children`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read one folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadFolder: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerReadFolder', 'folderId', folderId)
            const localVarPath = `/folders/{folderId}/field-mapping`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadHome: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/folders/home`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a folder info
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadInfo: async (folderId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerReadInfo', 'folderId', folderId)
            const localVarPath = `/folders/{folderId}/info`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadReportForField: async (objectId: number, objectFieldId: number, from?: string, to?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('folderControllerReadReportForField', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('folderControllerReadReportForField', 'objectFieldId', objectFieldId)
            const localVarPath = `/folders/object/{objectId}/object-field/{objectFieldId}/report`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a paginated collection of shared folder and files
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadShared: async (orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('folderControllerReadShared', 'orderBy', orderBy)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('folderControllerReadShared', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('folderControllerReadShared', 'limit', limit)
            const localVarPath = `/folders/shared`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a paginated collection of uploaded files
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadUpload: async (orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'orderBy' is not null or undefined
            assertParamExists('folderControllerReadUpload', 'orderBy', orderBy)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('folderControllerReadUpload', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('folderControllerReadUpload', 'limit', limit)
            const localVarPath = `/folders/upload`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a folder
         * @param {string} folderId 
         * @param {UpdateFolderDto} updateFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerUpdate: async (folderId: string, updateFolderDto: UpdateFolderDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'folderId' is not null or undefined
            assertParamExists('folderControllerUpdate', 'folderId', folderId)
            // verify required parameter 'updateFolderDto' is not null or undefined
            assertParamExists('folderControllerUpdate', 'updateFolderDto', updateFolderDto)
            const localVarPath = `/folders/{folderId}`
                .replace(`{${"folderId"}}`, encodeURIComponent(String(folderId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFolderDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * FolderApi - functional programming interface
 */
export const FolderApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = FolderApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerCreate(createFolderDto: CreateFolderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerCreate(createFolderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerDelete(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerDelete(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Generate PDF report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {ObjectFieldReportPdfDto} objectFieldReportPdfDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerGenerateReportPdfForField(objectId: number, objectFieldId: number, objectFieldReportPdfDto: ObjectFieldReportPdfDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerGenerateReportPdfForField(objectId, objectFieldId, objectFieldReportPdfDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerGenerateReportPdfForField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a folder field with a catalog
         * @param {string} folderId 
         * @param {PostFolderFieldMappingDto} postFolderFieldMappingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerPostFieldMapping(folderId: string, postFolderFieldMappingDto: PostFolderFieldMappingDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderFieldMappingDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerPostFieldMapping(folderId, postFolderFieldMappingDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerPostFieldMapping']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a folder
         * @param {string} folderId 
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerRead(folderId: string, orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerRead(folderId, orderBy, page, limit, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a paginated collection of a folders children
         * @param {string} folderId 
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadChildren(folderId: string, orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderItemDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadChildren(folderId, orderBy, page, limit, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read one folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadFolder(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderFieldMappingDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadFolder(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadFolder']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadHome(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadHome(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadHome']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a folder info
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadInfo(folderId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderInfoDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadInfo(folderId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadReportForField(objectId: number, objectFieldId: number, from?: string, to?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectObjectFieldReportDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadReportForField(objectId, objectFieldId, from, to, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadReportForField']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a paginated collection of shared folder and files
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadShared(orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadShared(orderBy, page, limit, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadShared']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a paginated collection of uploaded files
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerReadUpload(orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerReadUpload(orderBy, page, limit, order, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerReadUpload']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a folder
         * @param {string} folderId 
         * @param {UpdateFolderDto} updateFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async folderControllerUpdate(folderId: string, updateFolderDto: UpdateFolderDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFolderDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.folderControllerUpdate(folderId, updateFolderDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['FolderApi.folderControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * FolderApi - factory interface
 */
export const FolderApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = FolderApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a folder
         * @param {CreateFolderDto} createFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerCreate(createFolderDto: CreateFolderDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderDtoEntityResponse> {
            return localVarFp.folderControllerCreate(createFolderDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerDelete(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.folderControllerDelete(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Generate PDF report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {ObjectFieldReportPdfDto} objectFieldReportPdfDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerGenerateReportPdfForField(objectId: number, objectFieldId: number, objectFieldReportPdfDto: ObjectFieldReportPdfDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.folderControllerGenerateReportPdfForField(objectId, objectFieldId, objectFieldReportPdfDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a folder field with a catalog
         * @param {string} folderId 
         * @param {PostFolderFieldMappingDto} postFolderFieldMappingDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerPostFieldMapping(folderId: string, postFolderFieldMappingDto: PostFolderFieldMappingDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderFieldMappingDtoEntityResponse> {
            return localVarFp.folderControllerPostFieldMapping(folderId, postFolderFieldMappingDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a folder
         * @param {string} folderId 
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerRead(folderId: string, orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderDtoPageResponse> {
            return localVarFp.folderControllerRead(folderId, orderBy, page, limit, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a paginated collection of a folders children
         * @param {string} folderId 
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadChildren(folderId: string, orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderItemDtoPageResponse> {
            return localVarFp.folderControllerReadChildren(folderId, orderBy, page, limit, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read one folder
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadFolder(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderFieldMappingDtoEntityResponse> {
            return localVarFp.folderControllerReadFolder(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadHome(options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderDtoCollectionResponse> {
            return localVarFp.folderControllerReadHome(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a folder info
         * @param {string} folderId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadInfo(folderId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderInfoDtoEntityResponse> {
            return localVarFp.folderControllerReadInfo(folderId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a report for objectField
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {string} [from] 
         * @param {string} [to] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadReportForField(objectId: number, objectFieldId: number, from?: string, to?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectObjectFieldReportDtoCollectionResponse> {
            return localVarFp.folderControllerReadReportForField(objectId, objectFieldId, from, to, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a paginated collection of shared folder and files
         * @param {FolderItemPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadShared(orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderDtoPageResponse> {
            return localVarFp.folderControllerReadShared(orderBy, page, limit, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a paginated collection of uploaded files
         * @param {FolderPageOptionsOrderBy} orderBy 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerReadUpload(orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileDtoPageResponse> {
            return localVarFp.folderControllerReadUpload(orderBy, page, limit, order, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a folder
         * @param {string} folderId 
         * @param {UpdateFolderDto} updateFolderDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        folderControllerUpdate(folderId: string, updateFolderDto: UpdateFolderDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFolderDtoEntityResponse> {
            return localVarFp.folderControllerUpdate(folderId, updateFolderDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * FolderApi - object-oriented interface
 */
export class FolderApi extends BaseAPI {
    /**
     * 
     * @summary Create a folder
     * @param {CreateFolderDto} createFolderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerCreate(createFolderDto: CreateFolderDto, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerCreate(createFolderDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerDelete(folderId: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerDelete(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Generate PDF report for objectField
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {ObjectFieldReportPdfDto} objectFieldReportPdfDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerGenerateReportPdfForField(objectId: number, objectFieldId: number, objectFieldReportPdfDto: ObjectFieldReportPdfDto, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerGenerateReportPdfForField(objectId, objectFieldId, objectFieldReportPdfDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a folder field with a catalog
     * @param {string} folderId 
     * @param {PostFolderFieldMappingDto} postFolderFieldMappingDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerPostFieldMapping(folderId: string, postFolderFieldMappingDto: PostFolderFieldMappingDto, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerPostFieldMapping(folderId, postFolderFieldMappingDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a folder
     * @param {string} folderId 
     * @param {FolderItemPageOptionsOrderBy} orderBy 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerRead(folderId: string, orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerRead(folderId, orderBy, page, limit, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a paginated collection of a folders children
     * @param {string} folderId 
     * @param {FolderPageOptionsOrderBy} orderBy 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadChildren(folderId: string, orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadChildren(folderId, orderBy, page, limit, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read one folder
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadFolder(folderId: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadFolder(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadHome(options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadHome(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a folder info
     * @param {string} folderId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadInfo(folderId: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadInfo(folderId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a report for objectField
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {string} [from] 
     * @param {string} [to] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadReportForField(objectId: number, objectFieldId: number, from?: string, to?: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadReportForField(objectId, objectFieldId, from, to, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a paginated collection of shared folder and files
     * @param {FolderItemPageOptionsOrderBy} orderBy 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadShared(orderBy: FolderItemPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadShared(orderBy, page, limit, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a paginated collection of uploaded files
     * @param {FolderPageOptionsOrderBy} orderBy 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerReadUpload(orderBy: FolderPageOptionsOrderBy, page: number, limit: number, order?: Order, search?: string, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerReadUpload(orderBy, page, limit, order, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a folder
     * @param {string} folderId 
     * @param {UpdateFolderDto} updateFolderDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public folderControllerUpdate(folderId: string, updateFolderDto: UpdateFolderDto, options?: RawAxiosRequestConfig) {
        return FolderApiFp(this.configuration).folderControllerUpdate(folderId, updateFolderDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * HelpURLApi - axios parameter creator
 */
export const HelpURLApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a Help URL
         * @param {CreateHelpUrlDto} createHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerCreate: async (createHelpUrlDto: CreateHelpUrlDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createHelpUrlDto' is not null or undefined
            assertParamExists('helpUrlControllerCreate', 'createHelpUrlDto', createHelpUrlDto)
            const localVarPath = `/help-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createHelpUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a HelpUrl
         * @param {string} helpUrlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerDelete: async (helpUrlId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'helpUrlId' is not null or undefined
            assertParamExists('helpUrlControllerDelete', 'helpUrlId', helpUrlId)
            const localVarPath = `/help-urls/{helpUrlId}`
                .replace(`{${"helpUrlId"}}`, encodeURIComponent(String(helpUrlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the collection of Help URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerReadCollection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/help-urls`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the collection of Help URLs filtered by language
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerReadCollectionByLanguage: async (language: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'language' is not null or undefined
            assertParamExists('helpUrlControllerReadCollectionByLanguage', 'language', language)
            const localVarPath = `/help-urls/{language}`
                .replace(`{${"language"}}`, encodeURIComponent(String(language)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a Help URL
         * @param {string} helpUrlId 
         * @param {UpdateHelpUrlDto} updateHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerUpdate: async (helpUrlId: string, updateHelpUrlDto: UpdateHelpUrlDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'helpUrlId' is not null or undefined
            assertParamExists('helpUrlControllerUpdate', 'helpUrlId', helpUrlId)
            // verify required parameter 'updateHelpUrlDto' is not null or undefined
            assertParamExists('helpUrlControllerUpdate', 'updateHelpUrlDto', updateHelpUrlDto)
            const localVarPath = `/help-urls/{helpUrlId}`
                .replace(`{${"helpUrlId"}}`, encodeURIComponent(String(helpUrlId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateHelpUrlDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * HelpURLApi - functional programming interface
 */
export const HelpURLApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = HelpURLApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a Help URL
         * @param {CreateHelpUrlDto} createHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helpUrlControllerCreate(createHelpUrlDto: CreateHelpUrlDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHelpUrlDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helpUrlControllerCreate(createHelpUrlDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpURLApi.helpUrlControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a HelpUrl
         * @param {string} helpUrlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helpUrlControllerDelete(helpUrlId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helpUrlControllerDelete(helpUrlId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpURLApi.helpUrlControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the collection of Help URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helpUrlControllerReadCollection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHelpUrlDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helpUrlControllerReadCollection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpURLApi.helpUrlControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the collection of Help URLs filtered by language
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helpUrlControllerReadCollectionByLanguage(language: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHelpUrlDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helpUrlControllerReadCollectionByLanguage(language, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpURLApi.helpUrlControllerReadCollectionByLanguage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a Help URL
         * @param {string} helpUrlId 
         * @param {UpdateHelpUrlDto} updateHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async helpUrlControllerUpdate(helpUrlId: string, updateHelpUrlDto: UpdateHelpUrlDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseHelpUrlDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.helpUrlControllerUpdate(helpUrlId, updateHelpUrlDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['HelpURLApi.helpUrlControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * HelpURLApi - factory interface
 */
export const HelpURLApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = HelpURLApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a Help URL
         * @param {CreateHelpUrlDto} createHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerCreate(createHelpUrlDto: CreateHelpUrlDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseHelpUrlDtoEntityResponse> {
            return localVarFp.helpUrlControllerCreate(createHelpUrlDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a HelpUrl
         * @param {string} helpUrlId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerDelete(helpUrlId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.helpUrlControllerDelete(helpUrlId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the collection of Help URLs
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerReadCollection(options?: RawAxiosRequestConfig): AxiosPromise<ResponseHelpUrlDtoCollectionResponse> {
            return localVarFp.helpUrlControllerReadCollection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the collection of Help URLs filtered by language
         * @param {string} language 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerReadCollectionByLanguage(language: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseHelpUrlDtoCollectionResponse> {
            return localVarFp.helpUrlControllerReadCollectionByLanguage(language, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a Help URL
         * @param {string} helpUrlId 
         * @param {UpdateHelpUrlDto} updateHelpUrlDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        helpUrlControllerUpdate(helpUrlId: string, updateHelpUrlDto: UpdateHelpUrlDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseHelpUrlDtoEntityResponse> {
            return localVarFp.helpUrlControllerUpdate(helpUrlId, updateHelpUrlDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * HelpURLApi - object-oriented interface
 */
export class HelpURLApi extends BaseAPI {
    /**
     * 
     * @summary Create a Help URL
     * @param {CreateHelpUrlDto} createHelpUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public helpUrlControllerCreate(createHelpUrlDto: CreateHelpUrlDto, options?: RawAxiosRequestConfig) {
        return HelpURLApiFp(this.configuration).helpUrlControllerCreate(createHelpUrlDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a HelpUrl
     * @param {string} helpUrlId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public helpUrlControllerDelete(helpUrlId: string, options?: RawAxiosRequestConfig) {
        return HelpURLApiFp(this.configuration).helpUrlControllerDelete(helpUrlId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the collection of Help URLs
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public helpUrlControllerReadCollection(options?: RawAxiosRequestConfig) {
        return HelpURLApiFp(this.configuration).helpUrlControllerReadCollection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the collection of Help URLs filtered by language
     * @param {string} language 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public helpUrlControllerReadCollectionByLanguage(language: string, options?: RawAxiosRequestConfig) {
        return HelpURLApiFp(this.configuration).helpUrlControllerReadCollectionByLanguage(language, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a Help URL
     * @param {string} helpUrlId 
     * @param {UpdateHelpUrlDto} updateHelpUrlDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public helpUrlControllerUpdate(helpUrlId: string, updateHelpUrlDto: UpdateHelpUrlDto, options?: RawAxiosRequestConfig) {
        return HelpURLApiFp(this.configuration).helpUrlControllerUpdate(helpUrlId, updateHelpUrlDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * InspectionApi - axios parameter creator
 */
export const InspectionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Delete an Inspection
         * @param {number} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionControllerDelete: async (inspectionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'inspectionId' is not null or undefined
            assertParamExists('inspectionControllerDelete', 'inspectionId', inspectionId)
            const localVarPath = `/inspections/{inspectionId}`
                .replace(`{${"inspectionId"}}`, encodeURIComponent(String(inspectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InspectionApi - functional programming interface
 */
export const InspectionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InspectionApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Delete an Inspection
         * @param {number} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async inspectionControllerDelete(inspectionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.inspectionControllerDelete(inspectionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InspectionApi.inspectionControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InspectionApi - factory interface
 */
export const InspectionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InspectionApiFp(configuration)
    return {
        /**
         * 
         * @summary Delete an Inspection
         * @param {number} inspectionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        inspectionControllerDelete(inspectionId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.inspectionControllerDelete(inspectionId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InspectionApi - object-oriented interface
 */
export class InspectionApi extends BaseAPI {
    /**
     * 
     * @summary Delete an Inspection
     * @param {number} inspectionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public inspectionControllerDelete(inspectionId: number, options?: RawAxiosRequestConfig) {
        return InspectionApiFp(this.configuration).inspectionControllerDelete(inspectionId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * NotificationApi - axios parameter creator
 */
export const NotificationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Register a user and it´s device in Pusher Beam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerGenerateToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/notifications/generate-token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all UserNotifications
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UserNotificationPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationControllerReadCollectionForUser: async (page: number, limit: number, order?: Order, orderBy?: UserNotificationPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('userNotificationControllerReadCollectionForUser', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('userNotificationControllerReadCollectionForUser', 'limit', limit)
            const localVarPath = `/profiles/notifications`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a UserNotification
         * @param {string} userNotificationId 
         * @param {UpdateUserNotificationDto} updateUserNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationControllerUpdate: async (userNotificationId: string, updateUserNotificationDto: UpdateUserNotificationDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userNotificationId' is not null or undefined
            assertParamExists('userNotificationControllerUpdate', 'userNotificationId', userNotificationId)
            // verify required parameter 'updateUserNotificationDto' is not null or undefined
            assertParamExists('userNotificationControllerUpdate', 'updateUserNotificationDto', updateUserNotificationDto)
            const localVarPath = `/profiles/notifications/{userNotificationId}`
                .replace(`{${"userNotificationId"}}`, encodeURIComponent(String(userNotificationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserNotificationDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * NotificationApi - functional programming interface
 */
export const NotificationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = NotificationApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Register a user and it´s device in Pusher Beam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async notificationControllerGenerateToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNotificationTokenDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.notificationControllerGenerateToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.notificationControllerGenerateToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all UserNotifications
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UserNotificationPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationControllerReadCollectionForUser(page: number, limit: number, order?: Order, orderBy?: UserNotificationPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserNotificationDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationControllerReadCollectionForUser(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.userNotificationControllerReadCollectionForUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a UserNotification
         * @param {string} userNotificationId 
         * @param {UpdateUserNotificationDto} updateUserNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userNotificationControllerUpdate(userNotificationId: string, updateUserNotificationDto: UpdateUserNotificationDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserNotificationDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userNotificationControllerUpdate(userNotificationId, updateUserNotificationDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['NotificationApi.userNotificationControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * NotificationApi - factory interface
 */
export const NotificationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = NotificationApiFp(configuration)
    return {
        /**
         * 
         * @summary Register a user and it´s device in Pusher Beam
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        notificationControllerGenerateToken(options?: RawAxiosRequestConfig): AxiosPromise<ResponseNotificationTokenDtoEntityResponse> {
            return localVarFp.notificationControllerGenerateToken(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all UserNotifications
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UserNotificationPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationControllerReadCollectionForUser(page: number, limit: number, order?: Order, orderBy?: UserNotificationPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserNotificationDtoPageResponse> {
            return localVarFp.userNotificationControllerReadCollectionForUser(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a UserNotification
         * @param {string} userNotificationId 
         * @param {UpdateUserNotificationDto} updateUserNotificationDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userNotificationControllerUpdate(userNotificationId: string, updateUserNotificationDto: UpdateUserNotificationDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserNotificationDtoEntityResponse> {
            return localVarFp.userNotificationControllerUpdate(userNotificationId, updateUserNotificationDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * NotificationApi - object-oriented interface
 */
export class NotificationApi extends BaseAPI {
    /**
     * 
     * @summary Register a user and it´s device in Pusher Beam
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public notificationControllerGenerateToken(options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).notificationControllerGenerateToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all UserNotifications
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {UserNotificationPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userNotificationControllerReadCollectionForUser(page: number, limit: number, order?: Order, orderBy?: UserNotificationPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).userNotificationControllerReadCollectionForUser(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a UserNotification
     * @param {string} userNotificationId 
     * @param {UpdateUserNotificationDto} updateUserNotificationDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userNotificationControllerUpdate(userNotificationId: string, updateUserNotificationDto: UpdateUserNotificationDto, options?: RawAxiosRequestConfig) {
        return NotificationApiFp(this.configuration).userNotificationControllerUpdate(userNotificationId, updateUserNotificationDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectApi - axios parameter creator
 */
export const ObjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectCreate: async (objectId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('addressControllerObjectCreate', 'objectId', objectId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerObjectCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/object/{objectId}/addresses`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectDelete: async (objectId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('addressControllerObjectDelete', 'objectId', objectId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerObjectDelete', 'addressId', addressId)
            const localVarPath = `/object/{objectId}/addresses/{addressId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('addressControllerObjectReadCollection', 'objectId', objectId)
            const localVarPath = `/object/{objectId}/addresses`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectUpdate: async (objectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('addressControllerObjectUpdate', 'objectId', objectId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerObjectUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerObjectUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/object/{objectId}/addresses/{addressId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipNewReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-new`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverOwnershipUsedReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-ownership-used`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-commercial-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate: async (objectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate', 'objectId', objectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete: async (objectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete', 'objectId', objectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return/{articleId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection: async (objectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection', 'objectId', objectId)
            const localVarPath = `/article-usages/object/{objectId}/takeover-tenancy-private-return`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectCreate: async (objectId: string, createModelTraitDto: CreateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('modelTraitControllerObjectCreate', 'objectId', objectId)
            // verify required parameter 'createModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerObjectCreate', 'createModelTraitDto', createModelTraitDto)
            const localVarPath = `/object/{objectId}/model-traits`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectDelete: async (objectId: string, modelTraitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('modelTraitControllerObjectDelete', 'objectId', objectId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerObjectDelete', 'modelTraitId', modelTraitId)
            const localVarPath = `/object/{objectId}/model-traits/{modelTraitId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all traits on Object by modelId
         * @summary 
         * @param {string} objectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadCollection: async (objectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadCollection', 'objectId', objectId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadCollection', 'limit', limit)
            const localVarPath = `/object/{objectId}/model-traits`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Object filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadCollectionOnModel: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadCollectionOnModel', 'name', name)
            const localVarPath = `/object/model-traits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Object
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadNameCollection: async (name: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadNameCollection', 'name', name)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('modelTraitControllerObjectReadNameCollection', 'value', value)
            const localVarPath = `/object/model-traits/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectUpdate: async (objectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('modelTraitControllerObjectUpdate', 'objectId', objectId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerObjectUpdate', 'modelTraitId', modelTraitId)
            // verify required parameter 'updateModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerObjectUpdate', 'updateModelTraitDto', updateModelTraitDto)
            const localVarPath = `/object/{objectId}/model-traits/{modelTraitId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthObjectControllerReadProjectUnwantedIncidentInfo: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('nonAuthObjectControllerReadProjectUnwantedIncidentInfo', 'objectId', objectId)
            const localVarPath = `/non-auth/objects/{objectId}/unwanted-incident-info`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists children of object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadObjectChildren: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectControllerReadObjectChildren', 'objectId', objectId)
            const localVarPath = `/objects/{objectId}/children`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all involved users on a Project
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadObjectInvolved: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectControllerReadObjectInvolved', 'objectId', objectId)
            const localVarPath = `/objects/{objectId}/involved`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Lists all top objects user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadTopObjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads a list of involved users
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectInvolvedControllerRead: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectInvolvedControllerRead', 'objectId', objectId)
            const localVarPath = `/objects/{objectId}/involved/users`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a summary for Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectSummaryControllerSummary: async (objectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectSummaryControllerSummary', 'objectId', objectId)
            const localVarPath = `/objects/{objectId}/summaries`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectApi - functional programming interface
 */
export const ObjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerObjectCreate(objectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerObjectCreate(objectId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.addressControllerObjectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerObjectDelete(objectId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerObjectDelete(objectId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.addressControllerObjectDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerObjectReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerObjectReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.addressControllerObjectReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerObjectUpdate(objectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerObjectUpdate(objectId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.addressControllerObjectUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectCreate(objectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectCreate(objectId, createModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectDelete(objectId: string, modelTraitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectDelete(objectId, modelTraitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all traits on Object by modelId
         * @summary 
         * @param {string} objectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectReadCollection(objectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectReadCollection(objectId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Object filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectReadCollectionOnModel(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectReadCollectionOnModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Object
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectReadNameCollection(name, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectReadNameCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerObjectUpdate(objectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerObjectUpdate(objectId, modelTraitId, updateModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.modelTraitControllerObjectUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectUnwantedIncidentInfoDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.nonAuthObjectControllerReadProjectUnwantedIncidentInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lists children of object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectControllerReadObjectChildren(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectParentIdnDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectControllerReadObjectChildren(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.objectControllerReadObjectChildren']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lists all involved users on a Project
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectControllerReadObjectInvolved(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectInvolvedDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectControllerReadObjectInvolved(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.objectControllerReadObjectInvolved']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Lists all top objects user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectControllerReadTopObjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectIDNDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectControllerReadTopObjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.objectControllerReadTopObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reads a list of involved users
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectInvolvedControllerRead(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectInvolvedUserDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectInvolvedControllerRead(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.objectInvolvedControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a summary for Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectSummaryControllerSummary(objectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectSummaryDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectSummaryControllerSummary(objectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectApi.objectSummaryControllerSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectApi - factory interface
 */
export const ObjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectApiFp(configuration)
    return {
        /**
         * Create an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectCreate(objectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerObjectCreate(objectId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectDelete(objectId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerObjectDelete(objectId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerObjectReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerObjectUpdate(objectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerObjectUpdate(objectId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
         * @summary 
         * @param {string} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectCreate(objectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerObjectCreate(objectId, createModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectDelete(objectId: string, modelTraitId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.modelTraitControllerObjectDelete(objectId, modelTraitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all traits on Object by modelId
         * @summary 
         * @param {string} objectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadCollection(objectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoPageResponse> {
            return localVarFp.modelTraitControllerObjectReadCollection(objectId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Object filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerObjectReadCollectionOnModel(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Object
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerObjectReadNameCollection(name, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ModelTrait for Object
         * @summary 
         * @param {string} objectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerObjectUpdate(objectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerObjectUpdate(objectId, modelTraitId, updateModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectUnwantedIncidentInfoDtoEntityResponse> {
            return localVarFp.nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists children of object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadObjectChildren(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectParentIdnDtoCollectionResponse> {
            return localVarFp.objectControllerReadObjectChildren(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists all involved users on a Project
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadObjectInvolved(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectInvolvedDtoCollectionResponse> {
            return localVarFp.objectControllerReadObjectInvolved(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Lists all top objects user has access to
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectControllerReadTopObjects(options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectIDNDtoCollectionResponse> {
            return localVarFp.objectControllerReadTopObjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads a list of involved users
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectInvolvedControllerRead(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectInvolvedUserDtoCollectionResponse> {
            return localVarFp.objectInvolvedControllerRead(objectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a summary for Object
         * @param {number} objectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectSummaryControllerSummary(objectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectSummaryDtoEntityResponse> {
            return localVarFp.objectSummaryControllerSummary(objectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectApi - object-oriented interface
 */
export class ObjectApi extends BaseAPI {
    /**
     * Create an Address for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerObjectCreate(objectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).addressControllerObjectCreate(objectId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerObjectDelete(objectId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).addressControllerObjectDelete(objectId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerObjectReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).addressControllerObjectReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerObjectUpdate(objectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).addressControllerObjectUpdate(objectId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipNewReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverOwnershipUsedReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercial\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyCommercialReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyCommercialReturnReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivate\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnCreate(objectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnDelete(objectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverTenancyPrivateReturn\" for Object
     * @summary 
     * @param {string} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).articleUsageControllerObjectTakeoverTenancyPrivateReturnReadCollection(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a ModelTrait for Object
     * @summary 
     * @param {string} objectId 
     * @param {CreateModelTraitDto} createModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectCreate(objectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectCreate(objectId, createModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ModelTrait for Object
     * @summary 
     * @param {string} objectId 
     * @param {number} modelTraitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectDelete(objectId: string, modelTraitId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectDelete(objectId, modelTraitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all traits on Object by modelId
     * @summary 
     * @param {string} objectId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectReadCollection(objectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectReadCollection(objectId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Object filtered by name
     * @summary 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectReadCollectionOnModel(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Object
     * @summary 
     * @param {string} name 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectReadNameCollection(name, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ModelTrait for Object
     * @summary 
     * @param {string} objectId 
     * @param {number} modelTraitId 
     * @param {UpdateModelTraitDto} updateModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerObjectUpdate(objectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).modelTraitControllerObjectUpdate(objectId, modelTraitId, updateModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).nonAuthObjectControllerReadProjectUnwantedIncidentInfo(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists children of object
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectControllerReadObjectChildren(objectId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).objectControllerReadObjectChildren(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists all involved users on a Project
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectControllerReadObjectInvolved(objectId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).objectControllerReadObjectInvolved(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Lists all top objects user has access to
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectControllerReadTopObjects(options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).objectControllerReadTopObjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads a list of involved users
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectInvolvedControllerRead(objectId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).objectInvolvedControllerRead(objectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a summary for Object
     * @param {number} objectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectSummaryControllerSummary(objectId: number, options?: RawAxiosRequestConfig) {
        return ObjectApiFp(this.configuration).objectSummaryControllerSummary(objectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectFieldApi - axios parameter creator
 */
export const ObjectFieldApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Get one objectField based on ObjectId
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldControllerRead: async (objectId: number, objectFieldId: number, agreementId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectFieldControllerRead', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('objectFieldControllerRead', 'objectFieldId', objectFieldId)
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('objectFieldControllerRead', 'agreementId', agreementId)
            const localVarPath = `/object-fields/{objectId}/{objectFieldId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (agreementId !== undefined) {
                localVarQueryParameter['agreementId'] = agreementId;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectFieldApi - functional programming interface
 */
export const ObjectFieldApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectFieldApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Get one objectField based on ObjectId
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectFieldControllerRead(objectId: number, objectFieldId: number, agreementId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectFieldDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectFieldControllerRead(objectId, objectFieldId, agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectFieldApi.objectFieldControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectFieldApi - factory interface
 */
export const ObjectFieldApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectFieldApiFp(configuration)
    return {
        /**
         * 
         * @summary Get one objectField based on ObjectId
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldControllerRead(objectId: number, objectFieldId: number, agreementId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectFieldDtoEntityResponse> {
            return localVarFp.objectFieldControllerRead(objectId, objectFieldId, agreementId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectFieldApi - object-oriented interface
 */
export class ObjectFieldApi extends BaseAPI {
    /**
     * 
     * @summary Get one objectField based on ObjectId
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {number} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectFieldControllerRead(objectId: number, objectFieldId: number, agreementId: number, options?: RawAxiosRequestConfig) {
        return ObjectFieldApiFp(this.configuration).objectFieldControllerRead(objectId, objectFieldId, agreementId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ObjectFieldReportApi - axios parameter creator
 */
export const ObjectFieldReportApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create object field report
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {CreateObjectFieldReportDto} createObjectFieldReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerCreate: async (objectId: number, objectFieldId: number, createObjectFieldReportDto: CreateObjectFieldReportDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectFieldReportControllerCreate', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('objectFieldReportControllerCreate', 'objectFieldId', objectFieldId)
            // verify required parameter 'createObjectFieldReportDto' is not null or undefined
            assertParamExists('objectFieldReportControllerCreate', 'createObjectFieldReportDto', createObjectFieldReportDto)
            const localVarPath = `/objects/{objectId}/objectFields/{objectFieldId}/objectFieldReport`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createObjectFieldReportDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} objectFieldReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerDelete: async (objectId: number, objectFieldId: number, objectFieldReportId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectFieldReportControllerDelete', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('objectFieldReportControllerDelete', 'objectFieldId', objectFieldId)
            // verify required parameter 'objectFieldReportId' is not null or undefined
            assertParamExists('objectFieldReportControllerDelete', 'objectFieldReportId', objectFieldReportId)
            const localVarPath = `/objects/{objectId}/objectFields/{objectFieldId}/objectFieldReport/{objectFieldReportId}`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)))
                .replace(`{${"objectFieldReportId"}}`, encodeURIComponent(String(objectFieldReportId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Collection of ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ObjectFieldReportPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerReadCollection: async (objectId: number, objectFieldId: number, page: number, limit: number, order?: Order, orderBy?: ObjectFieldReportPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectId' is not null or undefined
            assertParamExists('objectFieldReportControllerReadCollection', 'objectId', objectId)
            // verify required parameter 'objectFieldId' is not null or undefined
            assertParamExists('objectFieldReportControllerReadCollection', 'objectFieldId', objectFieldId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('objectFieldReportControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('objectFieldReportControllerReadCollection', 'limit', limit)
            const localVarPath = `/objects/{objectId}/objectFields/{objectFieldId}/objectFieldReport`
                .replace(`{${"objectId"}}`, encodeURIComponent(String(objectId)))
                .replace(`{${"objectFieldId"}}`, encodeURIComponent(String(objectFieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ObjectFieldReportApi - functional programming interface
 */
export const ObjectFieldReportApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ObjectFieldReportApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create object field report
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {CreateObjectFieldReportDto} createObjectFieldReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectFieldReportControllerCreate(objectId: number, objectFieldId: number, createObjectFieldReportDto: CreateObjectFieldReportDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectFieldReportDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectFieldReportControllerCreate(objectId, objectFieldId, createObjectFieldReportDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectFieldReportApi.objectFieldReportControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} objectFieldReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectFieldReportControllerDelete(objectId: number, objectFieldId: number, objectFieldReportId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectFieldReportControllerDelete(objectId, objectFieldId, objectFieldReportId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectFieldReportApi.objectFieldReportControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Collection of ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ObjectFieldReportPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async objectFieldReportControllerReadCollection(objectId: number, objectFieldId: number, page: number, limit: number, order?: Order, orderBy?: ObjectFieldReportPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseObjectFieldReportDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.objectFieldReportControllerReadCollection(objectId, objectFieldId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ObjectFieldReportApi.objectFieldReportControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ObjectFieldReportApi - factory interface
 */
export const ObjectFieldReportApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ObjectFieldReportApiFp(configuration)
    return {
        /**
         * 
         * @summary Create object field report
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {CreateObjectFieldReportDto} createObjectFieldReportDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerCreate(objectId: number, objectFieldId: number, createObjectFieldReportDto: CreateObjectFieldReportDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectFieldReportDtoEntityResponse> {
            return localVarFp.objectFieldReportControllerCreate(objectId, objectFieldId, createObjectFieldReportDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} objectFieldReportId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerDelete(objectId: number, objectFieldId: number, objectFieldReportId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.objectFieldReportControllerDelete(objectId, objectFieldId, objectFieldReportId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Collection of ObjectFieldReport
         * @param {number} objectId 
         * @param {number} objectFieldId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ObjectFieldReportPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        objectFieldReportControllerReadCollection(objectId: number, objectFieldId: number, page: number, limit: number, order?: Order, orderBy?: ObjectFieldReportPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseObjectFieldReportDtoCollectionResponse> {
            return localVarFp.objectFieldReportControllerReadCollection(objectId, objectFieldId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ObjectFieldReportApi - object-oriented interface
 */
export class ObjectFieldReportApi extends BaseAPI {
    /**
     * 
     * @summary Create object field report
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {CreateObjectFieldReportDto} createObjectFieldReportDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectFieldReportControllerCreate(objectId: number, objectFieldId: number, createObjectFieldReportDto: CreateObjectFieldReportDto, options?: RawAxiosRequestConfig) {
        return ObjectFieldReportApiFp(this.configuration).objectFieldReportControllerCreate(objectId, objectFieldId, createObjectFieldReportDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a ObjectFieldReport
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {number} objectFieldReportId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectFieldReportControllerDelete(objectId: number, objectFieldId: number, objectFieldReportId: number, options?: RawAxiosRequestConfig) {
        return ObjectFieldReportApiFp(this.configuration).objectFieldReportControllerDelete(objectId, objectFieldId, objectFieldReportId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Collection of ObjectFieldReport
     * @param {number} objectId 
     * @param {number} objectFieldId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ObjectFieldReportPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public objectFieldReportControllerReadCollection(objectId: number, objectFieldId: number, page: number, limit: number, order?: Order, orderBy?: ObjectFieldReportPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ObjectFieldReportApiFp(this.configuration).objectFieldReportControllerReadCollection(objectId, objectFieldId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * PortalApi - axios parameter creator
 */
export const PortalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets a single agreement where the CRMUser is involved
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAgreementControllerRead: async (agreementId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('portalAgreementControllerRead', 'agreementId', agreementId)
            const localVarPath = `/portal/agreements/{agreementId}`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets all agreements where the CRMUser is involved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAgreementControllerReadCollection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portal/agreements`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerNeedToConsentForRequests: async (projectId: number, apartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalApartmentControllerNeedToConsentForRequests', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalApartmentControllerNeedToConsentForRequests', 'apartmentId', apartmentId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/need-to-consent-for-requests`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadApartment: async (projectId: number, apartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalApartmentControllerReadApartment', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalApartmentControllerReadApartment', 'apartmentId', apartmentId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadApartmentBannerImages: async (projectId: number, apartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalApartmentControllerReadApartmentBannerImages', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalApartmentControllerReadApartmentBannerImages', 'apartmentId', apartmentId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/banner-images`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadCompanyLogos: async (projectId: number, apartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalApartmentControllerReadCompanyLogos', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalApartmentControllerReadCompanyLogos', 'apartmentId', apartmentId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/company-logos`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasesPageOptionsOrderBy} [orderBy] 
         * @param {number} [apartmentId] Filter results based on ApartmentId
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCaseControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: PortalCasesPageOptionsOrderBy, apartmentId?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalCaseControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalCaseControllerReadCollection', 'limit', limit)
            const localVarPath = `/portal/cases`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (apartmentId !== undefined) {
                localVarQueryParameter['ApartmentId'] = apartmentId;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerReadMainObjects: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/portal/main-objects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a case as read
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerMarkCaseRead: async (projectId: number, apartmentId: number, caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseRead', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseRead', 'apartmentId', apartmentId)
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseRead', 'caseId', caseId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/cases/{caseId}/read`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Marks a case as unread
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerMarkCaseUnread: async (projectId: number, apartmentId: number, caseId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseUnread', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseUnread', 'apartmentId', apartmentId)
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerMarkCaseUnread', 'caseId', caseId)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/cases/{caseId}/unread`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerReadCollection: async (projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PortalCasePageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerReadCollection', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerReadCollection', 'apartmentId', apartmentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectApartmentCaseControllerReadCollection', 'limit', limit)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/cases`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {CreatePortalCaseLogDto} createPortalCaseLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseLogControllerCreate: async (projectId: number, apartmentId: number, caseId: number, createPortalCaseLogDto: CreatePortalCaseLogDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerCreate', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerCreate', 'apartmentId', apartmentId)
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerCreate', 'caseId', caseId)
            // verify required parameter 'createPortalCaseLogDto' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerCreate', 'createPortalCaseLogDto', createPortalCaseLogDto)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/cases/{caseId}/logs`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createPortalCaseLogDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCaseLogPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseLogControllerReadCollection: async (projectId: number, apartmentId: number, caseId: number, page: number, limit: number, order?: Order, orderBy?: PortalCaseLogPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerReadCollection', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerReadCollection', 'apartmentId', apartmentId)
            // verify required parameter 'caseId' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerReadCollection', 'caseId', caseId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectApartmentCaseLogControllerReadCollection', 'limit', limit)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/cases/{caseId}/logs`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)))
                .replace(`{${"caseId"}}`, encodeURIComponent(String(caseId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} agreementId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForAgreement: async (agreementId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'agreementId' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForAgreement', 'agreementId', agreementId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForAgreement', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForAgreement', 'limit', limit)
            const localVarPath = `/portal/agreement/{agreementId}/articles`
                .replace(`{${"agreementId"}}`, encodeURIComponent(String(agreementId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (articleModel !== undefined) {
                localVarQueryParameter['ArticleModel'] = articleModel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForApartment: async (projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForApartment', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForApartment', 'apartmentId', apartmentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForApartment', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForApartment', 'limit', limit)
            const localVarPath = `/portal/projects/{projectId}/apartments/{apartmentId}/articles`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (articleModel !== undefined) {
                localVarQueryParameter['ArticleModel'] = articleModel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {string} objectOwnershipId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForOwnership: async (objectOwnershipId: string, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'objectOwnershipId' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForOwnership', 'objectOwnershipId', objectOwnershipId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForOwnership', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForOwnership', 'limit', limit)
            const localVarPath = `/portal/ownership/{objectOwnershipId}/articles`
                .replace(`{${"objectOwnershipId"}}`, encodeURIComponent(String(objectOwnershipId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (articleModel !== undefined) {
                localVarQueryParameter['ArticleModel'] = articleModel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} tenancyId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForTenancy: async (tenancyId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenancyId' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForTenancy', 'tenancyId', tenancyId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForTenancy', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('portalProjectArticleControllerReadCollectionForTenancy', 'limit', limit)
            const localVarPath = `/portal/tenancy/{tenancyId}/articles`
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (articleModel !== undefined) {
                localVarQueryParameter['ArticleModel'] = articleModel;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PortalApi - functional programming interface
 */
export const PortalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PortalApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets a single agreement where the CRMUser is involved
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAgreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAgreementControllerRead(agreementId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalAgreementControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets all agreements where the CRMUser is involved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalAgreementControllerReadCollection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAgreementDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalAgreementControllerReadCollection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalAgreementControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalApartmentControllerNeedToConsentForRequests(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNeedToConsentForRequestsForApartmentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalApartmentControllerNeedToConsentForRequests(projectId, apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalApartmentControllerNeedToConsentForRequests']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalApartmentControllerReadApartment(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalApartmentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalApartmentControllerReadApartment(projectId, apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalApartmentControllerReadApartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalApartmentControllerReadApartmentBannerImages(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalApartmentControllerReadApartmentBannerImages(projectId, apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalApartmentControllerReadApartmentBannerImages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalApartmentControllerReadCompanyLogos(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalApartmentControllerReadCompanyLogos(projectId, apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalApartmentControllerReadCompanyLogos']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasesPageOptionsOrderBy} [orderBy] 
         * @param {number} [apartmentId] Filter results based on ApartmentId
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalCaseControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PortalCasesPageOptionsOrderBy, apartmentId?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalCaseDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalCaseControllerReadCollection(page, limit, order, orderBy, apartmentId, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalCaseControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalControllerReadMainObjects(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalMainObjectDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalControllerReadMainObjects(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalControllerReadMainObjects']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a case as read
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectApartmentCaseControllerMarkCaseRead(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectApartmentCaseControllerMarkCaseRead(projectId, apartmentId, caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectApartmentCaseControllerMarkCaseRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Marks a case as unread
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectApartmentCaseControllerMarkCaseUnread(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectApartmentCaseControllerMarkCaseUnread(projectId, apartmentId, caseId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectApartmentCaseControllerMarkCaseUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectApartmentCaseControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PortalCasePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalCaseDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectApartmentCaseControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectApartmentCaseControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {CreatePortalCaseLogDto} createPortalCaseLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectApartmentCaseLogControllerCreate(projectId: number, apartmentId: number, caseId: number, createPortalCaseLogDto: CreatePortalCaseLogDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalCaseLogDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectApartmentCaseLogControllerCreate(projectId, apartmentId, caseId, createPortalCaseLogDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectApartmentCaseLogControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCaseLogPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectApartmentCaseLogControllerReadCollection(projectId: number, apartmentId: number, caseId: number, page: number, limit: number, order?: Order, orderBy?: PortalCaseLogPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalCaseLogDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectApartmentCaseLogControllerReadCollection(projectId, apartmentId, caseId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectApartmentCaseLogControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} agreementId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectArticleControllerReadCollectionForAgreement(agreementId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalArticleDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectArticleControllerReadCollectionForAgreement(agreementId, page, limit, order, orderBy, articleModel, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectArticleControllerReadCollectionForAgreement']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectArticleControllerReadCollectionForApartment(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalArticleDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectArticleControllerReadCollectionForApartment(projectId, apartmentId, page, limit, order, orderBy, articleModel, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectArticleControllerReadCollectionForApartment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {string} objectOwnershipId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId: string, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalArticleDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId, page, limit, order, orderBy, articleModel, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectArticleControllerReadCollectionForOwnership']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} tenancyId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async portalProjectArticleControllerReadCollectionForTenancy(tenancyId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponsePortalArticleDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.portalProjectArticleControllerReadCollectionForTenancy(tenancyId, page, limit, order, orderBy, articleModel, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PortalApi.portalProjectArticleControllerReadCollectionForTenancy']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PortalApi - factory interface
 */
export const PortalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PortalApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets a single agreement where the CRMUser is involved
         * @param {number} agreementId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAgreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoEntityResponse> {
            return localVarFp.portalAgreementControllerRead(agreementId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets all agreements where the CRMUser is involved
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalAgreementControllerReadCollection(options?: RawAxiosRequestConfig): AxiosPromise<ResponseAgreementDtoCollectionResponse> {
            return localVarFp.portalAgreementControllerReadCollection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerNeedToConsentForRequests(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseNeedToConsentForRequestsForApartmentDtoEntityResponse> {
            return localVarFp.portalApartmentControllerNeedToConsentForRequests(projectId, apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadApartment(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalApartmentDtoEntityResponse> {
            return localVarFp.portalApartmentControllerReadApartment(projectId, apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadApartmentBannerImages(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalFileUsageDtoCollectionResponse> {
            return localVarFp.portalApartmentControllerReadApartmentBannerImages(projectId, apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalApartmentControllerReadCompanyLogos(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalFileUsageDtoCollectionResponse> {
            return localVarFp.portalApartmentControllerReadCompanyLogos(projectId, apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasesPageOptionsOrderBy} [orderBy] 
         * @param {number} [apartmentId] Filter results based on ApartmentId
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalCaseControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PortalCasesPageOptionsOrderBy, apartmentId?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalCaseDtoPageResponse> {
            return localVarFp.portalCaseControllerReadCollection(page, limit, order, orderBy, apartmentId, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalControllerReadMainObjects(options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalMainObjectDtoCollectionResponse> {
            return localVarFp.portalControllerReadMainObjects(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a case as read
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerMarkCaseRead(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.portalProjectApartmentCaseControllerMarkCaseRead(projectId, apartmentId, caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Marks a case as unread
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerMarkCaseUnread(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.portalProjectApartmentCaseControllerMarkCaseUnread(projectId, apartmentId, caseId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of cases
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCasePageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PortalCasePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalCaseDtoPageResponse> {
            return localVarFp.portalProjectApartmentCaseControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {CreatePortalCaseLogDto} createPortalCaseLogDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseLogControllerCreate(projectId: number, apartmentId: number, caseId: number, createPortalCaseLogDto: CreatePortalCaseLogDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalCaseLogDtoEntityResponse> {
            return localVarFp.portalProjectApartmentCaseLogControllerCreate(projectId, apartmentId, caseId, createPortalCaseLogDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} caseId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PortalCaseLogPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectApartmentCaseLogControllerReadCollection(projectId: number, apartmentId: number, caseId: number, page: number, limit: number, order?: Order, orderBy?: PortalCaseLogPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalCaseLogDtoPageResponse> {
            return localVarFp.portalProjectApartmentCaseLogControllerReadCollection(projectId, apartmentId, caseId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} agreementId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForAgreement(agreementId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalArticleDtoPageResponse> {
            return localVarFp.portalProjectArticleControllerReadCollectionForAgreement(agreementId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForApartment(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalArticleDtoPageResponse> {
            return localVarFp.portalProjectArticleControllerReadCollectionForApartment(projectId, apartmentId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {string} objectOwnershipId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId: string, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalArticleDtoPageResponse> {
            return localVarFp.portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a paginated collection of articles
         * @param {number} tenancyId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ArticlePageOptionsOrderBy} [orderBy] 
         * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        portalProjectArticleControllerReadCollectionForTenancy(tenancyId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponsePortalArticleDtoPageResponse> {
            return localVarFp.portalProjectArticleControllerReadCollectionForTenancy(tenancyId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PortalApi - object-oriented interface
 */
export class PortalApi extends BaseAPI {
    /**
     * 
     * @summary Gets a single agreement where the CRMUser is involved
     * @param {number} agreementId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalAgreementControllerRead(agreementId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalAgreementControllerRead(agreementId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets all agreements where the CRMUser is involved
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalAgreementControllerReadCollection(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalAgreementControllerReadCollection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalApartmentControllerNeedToConsentForRequests(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalApartmentControllerNeedToConsentForRequests(projectId, apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalApartmentControllerReadApartment(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalApartmentControllerReadApartment(projectId, apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalApartmentControllerReadApartmentBannerImages(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalApartmentControllerReadApartmentBannerImages(projectId, apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalApartmentControllerReadCompanyLogos(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalApartmentControllerReadCompanyLogos(projectId, apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of cases
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PortalCasesPageOptionsOrderBy} [orderBy] 
     * @param {number} [apartmentId] Filter results based on ApartmentId
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalCaseControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: PortalCasesPageOptionsOrderBy, apartmentId?: number, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalCaseControllerReadCollection(page, limit, order, orderBy, apartmentId, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalControllerReadMainObjects(options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalControllerReadMainObjects(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a case as read
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectApartmentCaseControllerMarkCaseRead(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectApartmentCaseControllerMarkCaseRead(projectId, apartmentId, caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Marks a case as unread
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} caseId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectApartmentCaseControllerMarkCaseUnread(projectId: number, apartmentId: number, caseId: number, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectApartmentCaseControllerMarkCaseUnread(projectId, apartmentId, caseId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of cases
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PortalCasePageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectApartmentCaseControllerReadCollection(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: PortalCasePageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectApartmentCaseControllerReadCollection(projectId, apartmentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} caseId 
     * @param {CreatePortalCaseLogDto} createPortalCaseLogDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectApartmentCaseLogControllerCreate(projectId: number, apartmentId: number, caseId: number, createPortalCaseLogDto: CreatePortalCaseLogDto, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectApartmentCaseLogControllerCreate(projectId, apartmentId, caseId, createPortalCaseLogDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} caseId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PortalCaseLogPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectApartmentCaseLogControllerReadCollection(projectId: number, apartmentId: number, caseId: number, page: number, limit: number, order?: Order, orderBy?: PortalCaseLogPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectApartmentCaseLogControllerReadCollection(projectId, apartmentId, caseId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of articles
     * @param {number} agreementId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ArticlePageOptionsOrderBy} [orderBy] 
     * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectArticleControllerReadCollectionForAgreement(agreementId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectArticleControllerReadCollectionForAgreement(agreementId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of articles
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ArticlePageOptionsOrderBy} [orderBy] 
     * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectArticleControllerReadCollectionForApartment(projectId: number, apartmentId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectArticleControllerReadCollectionForApartment(projectId, apartmentId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of articles
     * @param {string} objectOwnershipId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ArticlePageOptionsOrderBy} [orderBy] 
     * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId: string, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectArticleControllerReadCollectionForOwnership(objectOwnershipId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a paginated collection of articles
     * @param {number} tenancyId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ArticlePageOptionsOrderBy} [orderBy] 
     * @param {AllowedArticleModel} [articleModel] Filter results on ArticleModel
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public portalProjectArticleControllerReadCollectionForTenancy(tenancyId: number, page: number, limit: number, order?: Order, orderBy?: ArticlePageOptionsOrderBy, articleModel?: AllowedArticleModel, search?: string, options?: RawAxiosRequestConfig) {
        return PortalApiFp(this.configuration).portalProjectArticleControllerReadCollectionForTenancy(tenancyId, page, limit, order, orderBy, articleModel, search, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApi - axios parameter creator
 */
export const ProjectApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectCreate: async (projectId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addressControllerProjectCreate', 'projectId', projectId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerProjectCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/project/{projectId}/addresses`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectDelete: async (projectId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addressControllerProjectDelete', 'projectId', projectId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerProjectDelete', 'addressId', addressId)
            const localVarPath = `/project/{projectId}/addresses/{addressId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addressControllerProjectReadCollection', 'projectId', projectId)
            const localVarPath = `/project/{projectId}/addresses`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectUpdate: async (projectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('addressControllerProjectUpdate', 'projectId', projectId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerProjectUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerProjectUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/project/{projectId}/addresses/{addressId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonConfirmationReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-confirmation`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonPdfReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-pdf`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectAddonProjectTextReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/addon-project-text`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/request-consent`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/request-consent/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectRequestConsentReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/request-consent`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipNewReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-new`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedCreate: async (projectId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedCreate', 'projectId', projectId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedDelete: async (projectId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedDelete', 'projectId', projectId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used/{articleId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedReadCollection: async (projectId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('articleUsageControllerProjectTakeoverOwnershipUsedReadCollection', 'projectId', projectId)
            const localVarPath = `/article-usages/project/{projectId}/takeover-ownership-used`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectCreate: async (projectId: string, createModelTraitDto: CreateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('modelTraitControllerProjectCreate', 'projectId', projectId)
            // verify required parameter 'createModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerProjectCreate', 'createModelTraitDto', createModelTraitDto)
            const localVarPath = `/project/{projectId}/model-traits`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectDelete: async (projectId: string, modelTraitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('modelTraitControllerProjectDelete', 'projectId', projectId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerProjectDelete', 'modelTraitId', modelTraitId)
            const localVarPath = `/project/{projectId}/model-traits/{modelTraitId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all traits on Project by modelId
         * @summary 
         * @param {string} projectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadCollection: async (projectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadCollection', 'projectId', projectId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadCollection', 'limit', limit)
            const localVarPath = `/project/{projectId}/model-traits`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Project filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadCollectionOnModel: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadCollectionOnModel', 'name', name)
            const localVarPath = `/project/model-traits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for Project
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadNameCollection: async (name: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadNameCollection', 'name', name)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('modelTraitControllerProjectReadNameCollection', 'value', value)
            const localVarPath = `/project/model-traits/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectUpdate: async (projectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('modelTraitControllerProjectUpdate', 'projectId', projectId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerProjectUpdate', 'modelTraitId', modelTraitId)
            // verify required parameter 'updateModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerProjectUpdate', 'updateModelTraitDto', updateModelTraitDto)
            const localVarPath = `/project/{projectId}/model-traits/{modelTraitId}`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthProjectControllerReadUnwantedIncidentInfo: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('nonAuthProjectControllerReadUnwantedIncidentInfo', 'projectId', projectId)
            const localVarPath = `/non-auth/projects/{projectId}/unwanted-incident-info`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read ProjectApartments without associated ProjectApartmentTakeoverLocks
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectControllerReadApartmentsWithoutTakeoverLock: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectControllerReadApartmentsWithoutTakeoverLock', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/apartments/takeover/open`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Reads a list of a projects involved users
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectInvolvedControllerRead: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectInvolvedControllerRead', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/involved`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerReadContractorStatusReport: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectMomControllerReadContractorStatusReport', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/moms/reports/contractor-status`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerReadFieldsUsersCanContributeToCaseStatus: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectMomControllerReadFieldsUsersCanContributeToCaseStatus', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/moms/fields`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerSetContractorStatusComplete: async (projectId: number, fieldId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectMomControllerSetContractorStatusComplete', 'projectId', projectId)
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('projectMomControllerSetContractorStatusComplete', 'fieldId', fieldId)
            const localVarPath = `/projects/{projectId}/moms/fields/{fieldId}/complete`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerSetContractorStatusIncomplete: async (projectId: number, fieldId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectMomControllerSetContractorStatusIncomplete', 'projectId', projectId)
            // verify required parameter 'fieldId' is not null or undefined
            assertParamExists('projectMomControllerSetContractorStatusIncomplete', 'fieldId', fieldId)
            const localVarPath = `/projects/{projectId}/moms/fields/{fieldId}/incomplete`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"fieldId"}}`, encodeURIComponent(String(fieldId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Gets a summary for Project
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSummaryControllerSummary: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectSummaryControllerSummary', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/summaries`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApi - functional programming interface
 */
export const ProjectApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerProjectCreate(projectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerProjectCreate(projectId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.addressControllerProjectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerProjectDelete(projectId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerProjectDelete(projectId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.addressControllerProjectDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerProjectReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerProjectReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.addressControllerProjectReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerProjectUpdate(projectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerProjectUpdate(projectId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.addressControllerProjectUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonConfirmationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonConfirmationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonConfirmationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonPdfCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonPdfDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonPdfReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonPdfReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonProjectTextCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonProjectTextDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectAddonProjectTextReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectRequestConsentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectRequestConsentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectRequestConsentReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectRequestConsentReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectCreate(projectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectCreate(projectId, createModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectDelete(projectId: string, modelTraitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectDelete(projectId, modelTraitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all traits on Project by modelId
         * @summary 
         * @param {string} projectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectReadCollection(projectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectReadCollection(projectId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Project filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectReadCollectionOnModel(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectReadCollectionOnModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for Project
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectReadNameCollection(name, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectReadNameCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectUpdate(projectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectUpdate(projectId, modelTraitId, updateModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.modelTraitControllerProjectUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nonAuthProjectControllerReadUnwantedIncidentInfo(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectUnwantedIncidentInfoDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nonAuthProjectControllerReadUnwantedIncidentInfo(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.nonAuthProjectControllerReadUnwantedIncidentInfo']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read ProjectApartments without associated ProjectApartmentTakeoverLocks
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectControllerReadApartmentsWithoutTakeoverLock(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentCardDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectControllerReadApartmentsWithoutTakeoverLock(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectControllerReadApartmentsWithoutTakeoverLock']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Reads a list of a projects involved users
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectInvolvedControllerRead(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectInvolvedUserDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectInvolvedControllerRead(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectInvolvedControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectMomControllerReadContractorStatusReport(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseContractorStatusReportDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectMomControllerReadContractorStatusReport(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectMomControllerReadContractorStatusReport']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFieldIDNDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectMomControllerReadFieldsUsersCanContributeToCaseStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectMomControllerSetContractorStatusComplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseContractorSetStatusDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectMomControllerSetContractorStatusComplete(projectId, fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectMomControllerSetContractorStatusComplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectMomControllerSetContractorStatusIncomplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseContractorSetStatusDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectMomControllerSetContractorStatusIncomplete(projectId, fieldId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectMomControllerSetContractorStatusIncomplete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Gets a summary for Project
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectSummaryControllerSummary(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectSummaryDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectSummaryControllerSummary(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApi.projectSummaryControllerSummary']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApi - factory interface
 */
export const ProjectApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApiFp(configuration)
    return {
        /**
         * Create an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectCreate(projectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerProjectCreate(projectId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectDelete(projectId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerProjectDelete(projectId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerProjectReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerProjectUpdate(projectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerProjectUpdate(projectId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonConfirmation\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonPdf\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonPdfReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"AddonProjectText\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"RequestConsent\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectRequestConsentReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
         * @summary 
         * @param {string} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectCreate(projectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerProjectCreate(projectId, createModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectDelete(projectId: string, modelTraitId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.modelTraitControllerProjectDelete(projectId, modelTraitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all traits on Project by modelId
         * @summary 
         * @param {string} projectId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadCollection(projectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoPageResponse> {
            return localVarFp.modelTraitControllerProjectReadCollection(projectId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Project filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerProjectReadCollectionOnModel(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for Project
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerProjectReadNameCollection(name, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ModelTrait for Project
         * @summary 
         * @param {string} projectId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectUpdate(projectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerProjectUpdate(projectId, modelTraitId, updateModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthProjectControllerReadUnwantedIncidentInfo(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectUnwantedIncidentInfoDtoEntityResponse> {
            return localVarFp.nonAuthProjectControllerReadUnwantedIncidentInfo(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read ProjectApartments without associated ProjectApartmentTakeoverLocks
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectControllerReadApartmentsWithoutTakeoverLock(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentCardDtoCollectionResponse> {
            return localVarFp.projectControllerReadApartmentsWithoutTakeoverLock(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Reads a list of a projects involved users
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectInvolvedControllerRead(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectInvolvedUserDtoCollectionResponse> {
            return localVarFp.projectInvolvedControllerRead(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerReadContractorStatusReport(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseContractorStatusReportDtoEntityResponse> {
            return localVarFp.projectMomControllerReadContractorStatusReport(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFieldIDNDtoCollectionResponse> {
            return localVarFp.projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerSetContractorStatusComplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseContractorSetStatusDtoEntityResponse> {
            return localVarFp.projectMomControllerSetContractorStatusComplete(projectId, fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} fieldId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectMomControllerSetContractorStatusIncomplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseContractorSetStatusDtoEntityResponse> {
            return localVarFp.projectMomControllerSetContractorStatusIncomplete(projectId, fieldId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Gets a summary for Project
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectSummaryControllerSummary(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectSummaryDtoEntityResponse> {
            return localVarFp.projectSummaryControllerSummary(projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApi - object-oriented interface
 */
export class ProjectApi extends BaseAPI {
    /**
     * Create an Address for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerProjectCreate(projectId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).addressControllerProjectCreate(projectId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerProjectDelete(projectId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).addressControllerProjectDelete(projectId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerProjectReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).addressControllerProjectReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerProjectUpdate(projectId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).addressControllerProjectUpdate(projectId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonConfirmation\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonConfirmationReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonConfirmationReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonPdfCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonPdfDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonPdf\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonPdfReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonPdfReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"AddonProjectText\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectAddonProjectTextReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectAddonProjectTextReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectRequestConsentCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectRequestConsentDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"RequestConsent\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectRequestConsentReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectRequestConsentReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipNew\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipNewReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedCreate(projectId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedDelete(projectId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverOwnershipUsed\" for Project
     * @summary 
     * @param {string} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).articleUsageControllerProjectTakeoverOwnershipUsedReadCollection(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a ModelTrait for Project
     * @summary 
     * @param {string} projectId 
     * @param {CreateModelTraitDto} createModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectCreate(projectId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectCreate(projectId, createModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ModelTrait for Project
     * @summary 
     * @param {string} projectId 
     * @param {number} modelTraitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectDelete(projectId: string, modelTraitId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectDelete(projectId, modelTraitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all traits on Project by modelId
     * @summary 
     * @param {string} projectId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectReadCollection(projectId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectReadCollection(projectId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Project filtered by name
     * @summary 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectReadCollectionOnModel(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for Project
     * @summary 
     * @param {string} name 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectReadNameCollection(name, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ModelTrait for Project
     * @summary 
     * @param {string} projectId 
     * @param {number} modelTraitId 
     * @param {UpdateModelTraitDto} updateModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectUpdate(projectId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).modelTraitControllerProjectUpdate(projectId, modelTraitId, updateModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public nonAuthProjectControllerReadUnwantedIncidentInfo(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).nonAuthProjectControllerReadUnwantedIncidentInfo(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read ProjectApartments without associated ProjectApartmentTakeoverLocks
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectControllerReadApartmentsWithoutTakeoverLock(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectControllerReadApartmentsWithoutTakeoverLock(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Reads a list of a projects involved users
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectInvolvedControllerRead(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectInvolvedControllerRead(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectMomControllerReadContractorStatusReport(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectMomControllerReadContractorStatusReport(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectMomControllerReadFieldsUsersCanContributeToCaseStatus(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} fieldId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectMomControllerSetContractorStatusComplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectMomControllerSetContractorStatusComplete(projectId, fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} fieldId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectMomControllerSetContractorStatusIncomplete(projectId: number, fieldId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectMomControllerSetContractorStatusIncomplete(projectId, fieldId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Gets a summary for Project
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectSummaryControllerSummary(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApiFp(this.configuration).projectSummaryControllerSummary(projectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApartmentApi - axios parameter creator
 */
export const ProjectApartmentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewCreate: async (projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewDelete: async (projectApartmentId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewDelete', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new/{articleId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewReadCollection: async (projectApartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverNewReadCollection', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-new`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedCreate: async (projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createArticleUsageDto' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedCreate', 'createArticleUsageDto', createArticleUsageDto)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createArticleUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedDelete: async (projectApartmentId: string, articleId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedDelete', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedDelete', 'articleId', articleId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used/{articleId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedReadCollection: async (projectApartmentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('articleUsageControllerProjectApartmentTakeoverUsedReadCollection', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/article-usages/projectApartment/{projectApartmentId}/takeover-used`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Create a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentCreate: async (projectApartmentId: string, createModelTraitDto: CreateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentCreate', 'createModelTraitDto', createModelTraitDto)
            const localVarPath = `/project-apartment/{projectApartmentId}/model-traits`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentDelete: async (projectApartmentId: string, modelTraitId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentDelete', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentDelete', 'modelTraitId', modelTraitId)
            const localVarPath = `/project-apartment/{projectApartmentId}/model-traits/{modelTraitId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all traits on ProjectApartment by modelId
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadCollection: async (projectApartmentId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadCollection', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadCollection', 'limit', limit)
            const localVarPath = `/project-apartment/{projectApartmentId}/model-traits`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadCollectionOnModel: async (name: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadCollectionOnModel', 'name', name)
            const localVarPath = `/project-apartment/model-traits`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (name !== undefined) {
                localVarQueryParameter['name'] = name;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadNameCollection: async (name: string, value: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'name' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadNameCollection', 'name', name)
            // verify required parameter 'value' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentReadNameCollection', 'value', value)
            const localVarPath = `/project-apartment/model-traits/{name}`
                .replace(`{${"name"}}`, encodeURIComponent(String(name)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (value !== undefined) {
                localVarQueryParameter['value'] = value;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentUpdate: async (projectApartmentId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentUpdate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'modelTraitId' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentUpdate', 'modelTraitId', modelTraitId)
            // verify required parameter 'updateModelTraitDto' is not null or undefined
            assertParamExists('modelTraitControllerProjectApartmentUpdate', 'updateModelTraitDto', updateModelTraitDto)
            const localVarPath = `/project-apartment/{projectApartmentId}/model-traits/{modelTraitId}`
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)))
                .replace(`{${"modelTraitId"}}`, encodeURIComponent(String(modelTraitId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateModelTraitDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read ProjectApartments
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentControllerReadApartments: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentControllerReadApartments', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/apartments`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete ProjectApartmentTakeoverLocks associated to a ProjectApartment
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentControllerUnlockApartmentForTakeover: async (projectId: number, projectApartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentControllerUnlockApartmentForTakeover', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentControllerUnlockApartmentForTakeover', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/takeovers/locks`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApartmentApi - functional programming interface
 */
export const ProjectApartmentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApartmentApiAxiosParamCreator(configuration)
    return {
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverNewCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverNewDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverNewReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverUsedCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverUsedDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseArticleUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.articleUsageControllerProjectApartmentTakeoverUsedReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Create a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentCreate(projectApartmentId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentCreate(projectApartmentId, createModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentDelete(projectApartmentId: string, modelTraitId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentDelete(projectApartmentId, modelTraitId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all traits on ProjectApartment by modelId
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentReadCollection(projectApartmentId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentReadCollection(projectApartmentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentReadCollectionOnModel(name, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentReadCollectionOnModel']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentReadNameCollection(name, value, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentReadNameCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async modelTraitControllerProjectApartmentUpdate(projectApartmentId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseModelTraitDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.modelTraitControllerProjectApartmentUpdate(projectApartmentId, modelTraitId, updateModelTraitDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.modelTraitControllerProjectApartmentUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read ProjectApartments
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentControllerReadApartments(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentCardDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentControllerReadApartments(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.projectApartmentControllerReadApartments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete ProjectApartmentTakeoverLocks associated to a ProjectApartment
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentControllerUnlockApartmentForTakeover(projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentControllerUnlockApartmentForTakeover(projectId, projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentApi.projectApartmentControllerUnlockApartmentForTakeover']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApartmentApi - factory interface
 */
export const ProjectApartmentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApartmentApiFp(configuration)
    return {
        /**
         * Add a article to \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a article to \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateArticleUsageDto} createArticleUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoEntityResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {string} articleId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseArticleUsageDtoCollectionResponse> {
            return localVarFp.articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Create a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {CreateModelTraitDto} createModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentCreate(projectApartmentId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerProjectApartmentCreate(projectApartmentId, createModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentDelete(projectApartmentId: string, modelTraitId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.modelTraitControllerProjectApartmentDelete(projectApartmentId, modelTraitId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all traits on ProjectApartment by modelId
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadCollection(projectApartmentId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoPageResponse> {
            return localVarFp.modelTraitControllerProjectApartmentReadCollection(projectApartmentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment filtered by name
         * @summary 
         * @param {string} name 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerProjectApartmentReadCollectionOnModel(name, options).then((request) => request(axios, basePath));
        },
        /**
         * Read a collection of ModelTraits for ProjectApartment
         * @summary 
         * @param {string} name 
         * @param {string} value 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoCollectionResponse> {
            return localVarFp.modelTraitControllerProjectApartmentReadNameCollection(name, value, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a ModelTrait for ProjectApartment
         * @summary 
         * @param {string} projectApartmentId 
         * @param {number} modelTraitId 
         * @param {UpdateModelTraitDto} updateModelTraitDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        modelTraitControllerProjectApartmentUpdate(projectApartmentId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseModelTraitDtoEntityResponse> {
            return localVarFp.modelTraitControllerProjectApartmentUpdate(projectApartmentId, modelTraitId, updateModelTraitDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read ProjectApartments
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentControllerReadApartments(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentCardDtoCollectionResponse> {
            return localVarFp.projectApartmentControllerReadApartments(projectId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete ProjectApartmentTakeoverLocks associated to a ProjectApartment
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentControllerUnlockApartmentForTakeover(projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.projectApartmentControllerUnlockApartmentForTakeover(projectId, projectApartmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApartmentApi - object-oriented interface
 */
export class ProjectApartmentApi extends BaseAPI {
    /**
     * Add a article to \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewDelete(projectApartmentId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverNew\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverNewReadCollection(projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a article to \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {CreateArticleUsageDto} createArticleUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId: string, createArticleUsageDto: CreateArticleUsageDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedCreate(projectApartmentId, createArticleUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ArticleUsage in \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {string} articleId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId: string, articleId: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedDelete(projectApartmentId, articleId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ArticleUsages \"TakeoverUsed\" for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).articleUsageControllerProjectApartmentTakeoverUsedReadCollection(projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Create a ModelTrait for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {CreateModelTraitDto} createModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentCreate(projectApartmentId: string, createModelTraitDto: CreateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentCreate(projectApartmentId, createModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ModelTrait for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {number} modelTraitId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentDelete(projectApartmentId: string, modelTraitId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentDelete(projectApartmentId, modelTraitId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all traits on ProjectApartment by modelId
     * @summary 
     * @param {string} projectApartmentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {ModelTraitPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentReadCollection(projectApartmentId: string, page: number, limit: number, order?: Order, orderBy?: ModelTraitPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentReadCollection(projectApartmentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for ProjectApartment filtered by name
     * @summary 
     * @param {string} name 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentReadCollectionOnModel(name: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentReadCollectionOnModel(name, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read a collection of ModelTraits for ProjectApartment
     * @summary 
     * @param {string} name 
     * @param {string} value 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentReadNameCollection(name: string, value: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentReadNameCollection(name, value, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a ModelTrait for ProjectApartment
     * @summary 
     * @param {string} projectApartmentId 
     * @param {number} modelTraitId 
     * @param {UpdateModelTraitDto} updateModelTraitDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public modelTraitControllerProjectApartmentUpdate(projectApartmentId: string, modelTraitId: number, updateModelTraitDto: UpdateModelTraitDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).modelTraitControllerProjectApartmentUpdate(projectApartmentId, modelTraitId, updateModelTraitDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read ProjectApartments
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentControllerReadApartments(projectId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).projectApartmentControllerReadApartments(projectId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete ProjectApartmentTakeoverLocks associated to a ProjectApartment
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentControllerUnlockApartmentForTakeover(projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentApiFp(this.configuration).projectApartmentControllerUnlockApartmentForTakeover(projectId, projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApartmentClientApi - axios parameter creator
 */
export const ProjectApartmentClientApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Create a ProjectApartmentClient
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {CreateProjectApartmentClientDto} createProjectApartmentClientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerCreate: async (projectId: number, projectApartmentId: number, createProjectApartmentClientDto: CreateProjectApartmentClientDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentClientControllerCreate', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentClientControllerCreate', 'projectApartmentId', projectApartmentId)
            // verify required parameter 'createProjectApartmentClientDto' is not null or undefined
            assertParamExists('projectApartmentClientControllerCreate', 'createProjectApartmentClientDto', createProjectApartmentClientDto)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/clients`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectApartmentClientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a ProjectApartmentClient
         * @summary Delete a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerDelete: async (projectApartmentClientId: number, projectId: number, projectApartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentClientId' is not null or undefined
            assertParamExists('projectApartmentClientControllerDelete', 'projectApartmentClientId', projectApartmentClientId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentClientControllerDelete', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentClientControllerDelete', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/clients/{projectApartmentClientId}`
                .replace(`{${"projectApartmentClientId"}}`, encodeURIComponent(String(projectApartmentClientId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerRead: async (projectApartmentClientId: number, projectId: number, projectApartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentClientId' is not null or undefined
            assertParamExists('projectApartmentClientControllerRead', 'projectApartmentClientId', projectApartmentClientId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentClientControllerRead', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentClientControllerRead', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/clients/{projectApartmentClientId}`
                .replace(`{${"projectApartmentClientId"}}`, encodeURIComponent(String(projectApartmentClientId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all ProjectApartmentClients for ProjectApartment
         * @summary Read all ProjectApartmentClients for ProjectApartment
         * @param {number} page 
         * @param {number} limit 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerReadCollection: async (page: number, limit: number, projectId: number, projectApartmentId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('projectApartmentClientControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('projectApartmentClientControllerReadCollection', 'limit', limit)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentClientControllerReadCollection', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentClientControllerReadCollection', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/clients`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerUpdate: async (projectApartmentClientId: number, projectId: number, projectApartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectApartmentClientId' is not null or undefined
            assertParamExists('projectApartmentClientControllerUpdate', 'projectApartmentClientId', projectApartmentClientId)
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentClientControllerUpdate', 'projectId', projectId)
            // verify required parameter 'projectApartmentId' is not null or undefined
            assertParamExists('projectApartmentClientControllerUpdate', 'projectApartmentId', projectApartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{projectApartmentId}/clients/{projectApartmentClientId}`
                .replace(`{${"projectApartmentClientId"}}`, encodeURIComponent(String(projectApartmentClientId)))
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"projectApartmentId"}}`, encodeURIComponent(String(projectApartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApartmentClientApi - functional programming interface
 */
export const ProjectApartmentClientApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApartmentClientApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Create a ProjectApartmentClient
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {CreateProjectApartmentClientDto} createProjectApartmentClientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentClientControllerCreate(projectId: number, projectApartmentId: number, createProjectApartmentClientDto: CreateProjectApartmentClientDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentClientDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentClientControllerCreate(projectId, projectApartmentId, createProjectApartmentClientDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentClientApi.projectApartmentClientControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a ProjectApartmentClient
         * @summary Delete a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentClientControllerDelete(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentClientControllerDelete(projectApartmentClientId, projectId, projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentClientApi.projectApartmentClientControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentClientControllerRead(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentClientDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentClientControllerRead(projectApartmentClientId, projectId, projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentClientApi.projectApartmentClientControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all ProjectApartmentClients for ProjectApartment
         * @summary Read all ProjectApartmentClients for ProjectApartment
         * @param {number} page 
         * @param {number} limit 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentClientControllerReadCollection(page: number, limit: number, projectId: number, projectApartmentId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentClientDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentClientControllerReadCollection(page, limit, projectId, projectApartmentId, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentClientApi.projectApartmentClientControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentClientControllerUpdate(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentClientControllerUpdate(projectApartmentClientId, projectId, projectApartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentClientApi.projectApartmentClientControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApartmentClientApi - factory interface
 */
export const ProjectApartmentClientApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApartmentClientApiFp(configuration)
    return {
        /**
         * 
         * @summary Create a ProjectApartmentClient
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {CreateProjectApartmentClientDto} createProjectApartmentClientDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerCreate(projectId: number, projectApartmentId: number, createProjectApartmentClientDto: CreateProjectApartmentClientDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentClientDtoEntityResponse> {
            return localVarFp.projectApartmentClientControllerCreate(projectId, projectApartmentId, createProjectApartmentClientDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a ProjectApartmentClient
         * @summary Delete a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerDelete(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.projectApartmentClientControllerDelete(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerRead(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentClientDtoEntityResponse> {
            return localVarFp.projectApartmentClientControllerRead(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all ProjectApartmentClients for ProjectApartment
         * @summary Read all ProjectApartmentClients for ProjectApartment
         * @param {number} page 
         * @param {number} limit 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerReadCollection(page: number, limit: number, projectId: number, projectApartmentId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentClientDtoPageResponse> {
            return localVarFp.projectApartmentClientControllerReadCollection(page, limit, projectId, projectApartmentId, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update a ProjectApartmentClient
         * @param {number} projectApartmentClientId 
         * @param {number} projectId 
         * @param {number} projectApartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentClientControllerUpdate(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.projectApartmentClientControllerUpdate(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApartmentClientApi - object-oriented interface
 */
export class ProjectApartmentClientApi extends BaseAPI {
    /**
     * 
     * @summary Create a ProjectApartmentClient
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {CreateProjectApartmentClientDto} createProjectApartmentClientDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentClientControllerCreate(projectId: number, projectApartmentId: number, createProjectApartmentClientDto: CreateProjectApartmentClientDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentClientApiFp(this.configuration).projectApartmentClientControllerCreate(projectId, projectApartmentId, createProjectApartmentClientDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a ProjectApartmentClient
     * @summary Delete a ProjectApartmentClient
     * @param {number} projectApartmentClientId 
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentClientControllerDelete(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentClientApiFp(this.configuration).projectApartmentClientControllerDelete(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a ProjectApartmentClient
     * @param {number} projectApartmentClientId 
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentClientControllerRead(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentClientApiFp(this.configuration).projectApartmentClientControllerRead(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all ProjectApartmentClients for ProjectApartment
     * @summary Read all ProjectApartmentClients for ProjectApartment
     * @param {number} page 
     * @param {number} limit 
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentClientControllerReadCollection(page: number, limit: number, projectId: number, projectApartmentId: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return ProjectApartmentClientApiFp(this.configuration).projectApartmentClientControllerReadCollection(page, limit, projectId, projectApartmentId, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update a ProjectApartmentClient
     * @param {number} projectApartmentClientId 
     * @param {number} projectId 
     * @param {number} projectApartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentClientControllerUpdate(projectApartmentClientId: number, projectId: number, projectApartmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentClientApiFp(this.configuration).projectApartmentClientControllerUpdate(projectApartmentClientId, projectId, projectApartmentId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ProjectApartmentTakeoverApi - axios parameter creator
 */
export const ProjectApartmentTakeoverApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {CreateProjectApartmentTakeoverDto} createProjectApartmentTakeoverDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerCreate: async (projectId: number, apartmentId: number, createProjectApartmentTakeoverDto: CreateProjectApartmentTakeoverDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerCreate', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerCreate', 'apartmentId', apartmentId)
            // verify required parameter 'createProjectApartmentTakeoverDto' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerCreate', 'createProjectApartmentTakeoverDto', createProjectApartmentTakeoverDto)
            const localVarPath = `/projects/{projectId}/apartments/{apartmentId}/takeovers`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createProjectApartmentTakeoverDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerReadNewTakeoverData: async (projectId: number, apartmentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerReadNewTakeoverData', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerReadNewTakeoverData', 'apartmentId', apartmentId)
            const localVarPath = `/projects/{projectId}/apartments/{apartmentId}/takeovers/new`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>} projectApartmentTakeoverInvolvedUserRecipientDto 
         * @param {Array<any>} [projectApartmentTakeoverSupplierOption] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerReadRecipients: async (projectId: number, apartmentId: number, projectApartmentTakeoverInvolvedUserRecipientDto: Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>, projectApartmentTakeoverSupplierOption?: Array<any>, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerReadRecipients', 'projectId', projectId)
            // verify required parameter 'apartmentId' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerReadRecipients', 'apartmentId', apartmentId)
            // verify required parameter 'projectApartmentTakeoverInvolvedUserRecipientDto' is not null or undefined
            assertParamExists('projectApartmentTakeoverControllerReadRecipients', 'projectApartmentTakeoverInvolvedUserRecipientDto', projectApartmentTakeoverInvolvedUserRecipientDto)
            const localVarPath = `/projects/{projectId}/apartments/{apartmentId}/takeovers/recipients`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)))
                .replace(`{${"apartmentId"}}`, encodeURIComponent(String(apartmentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (projectApartmentTakeoverSupplierOption) {
                localVarQueryParameter['projectApartmentTakeoverSupplierOption'] = projectApartmentTakeoverSupplierOption;
            }

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(projectApartmentTakeoverInvolvedUserRecipientDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProjectApartmentTakeoverApi - functional programming interface
 */
export const ProjectApartmentTakeoverApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProjectApartmentTakeoverApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {CreateProjectApartmentTakeoverDto} createProjectApartmentTakeoverDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentTakeoverControllerCreate(projectId: number, apartmentId: number, createProjectApartmentTakeoverDto: CreateProjectApartmentTakeoverDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentTakeoverDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentTakeoverControllerCreate(projectId, apartmentId, createProjectApartmentTakeoverDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentTakeoverApi.projectApartmentTakeoverControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentTakeoverControllerReadNewTakeoverData(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNewProjectApartmentTakeoverDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentTakeoverControllerReadNewTakeoverData(projectId, apartmentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentTakeoverApi.projectApartmentTakeoverControllerReadNewTakeoverData']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>} projectApartmentTakeoverInvolvedUserRecipientDto 
         * @param {Array<any>} [projectApartmentTakeoverSupplierOption] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async projectApartmentTakeoverControllerReadRecipients(projectId: number, apartmentId: number, projectApartmentTakeoverInvolvedUserRecipientDto: Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>, projectApartmentTakeoverSupplierOption?: Array<any>, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseProjectApartmentTakeoverDestinationDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.projectApartmentTakeoverControllerReadRecipients(projectId, apartmentId, projectApartmentTakeoverInvolvedUserRecipientDto, projectApartmentTakeoverSupplierOption, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProjectApartmentTakeoverApi.projectApartmentTakeoverControllerReadRecipients']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProjectApartmentTakeoverApi - factory interface
 */
export const ProjectApartmentTakeoverApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProjectApartmentTakeoverApiFp(configuration)
    return {
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {CreateProjectApartmentTakeoverDto} createProjectApartmentTakeoverDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerCreate(projectId: number, apartmentId: number, createProjectApartmentTakeoverDto: CreateProjectApartmentTakeoverDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentTakeoverDtoEntityResponse> {
            return localVarFp.projectApartmentTakeoverControllerCreate(projectId, apartmentId, createProjectApartmentTakeoverDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerReadNewTakeoverData(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseNewProjectApartmentTakeoverDtoEntityResponse> {
            return localVarFp.projectApartmentTakeoverControllerReadNewTakeoverData(projectId, apartmentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} projectId 
         * @param {number} apartmentId 
         * @param {Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>} projectApartmentTakeoverInvolvedUserRecipientDto 
         * @param {Array<any>} [projectApartmentTakeoverSupplierOption] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        projectApartmentTakeoverControllerReadRecipients(projectId: number, apartmentId: number, projectApartmentTakeoverInvolvedUserRecipientDto: Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>, projectApartmentTakeoverSupplierOption?: Array<any>, options?: RawAxiosRequestConfig): AxiosPromise<ResponseProjectApartmentTakeoverDestinationDtoCollectionResponse> {
            return localVarFp.projectApartmentTakeoverControllerReadRecipients(projectId, apartmentId, projectApartmentTakeoverInvolvedUserRecipientDto, projectApartmentTakeoverSupplierOption, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProjectApartmentTakeoverApi - object-oriented interface
 */
export class ProjectApartmentTakeoverApi extends BaseAPI {
    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {CreateProjectApartmentTakeoverDto} createProjectApartmentTakeoverDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentTakeoverControllerCreate(projectId: number, apartmentId: number, createProjectApartmentTakeoverDto: CreateProjectApartmentTakeoverDto, options?: RawAxiosRequestConfig) {
        return ProjectApartmentTakeoverApiFp(this.configuration).projectApartmentTakeoverControllerCreate(projectId, apartmentId, createProjectApartmentTakeoverDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentTakeoverControllerReadNewTakeoverData(projectId: number, apartmentId: number, options?: RawAxiosRequestConfig) {
        return ProjectApartmentTakeoverApiFp(this.configuration).projectApartmentTakeoverControllerReadNewTakeoverData(projectId, apartmentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} projectId 
     * @param {number} apartmentId 
     * @param {Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>} projectApartmentTakeoverInvolvedUserRecipientDto 
     * @param {Array<any>} [projectApartmentTakeoverSupplierOption] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public projectApartmentTakeoverControllerReadRecipients(projectId: number, apartmentId: number, projectApartmentTakeoverInvolvedUserRecipientDto: Array<ProjectApartmentTakeoverInvolvedUserRecipientDto>, projectApartmentTakeoverSupplierOption?: Array<any>, options?: RawAxiosRequestConfig) {
        return ProjectApartmentTakeoverApiFp(this.configuration).projectApartmentTakeoverControllerReadRecipients(projectId, apartmentId, projectApartmentTakeoverInvolvedUserRecipientDto, projectApartmentTakeoverSupplierOption, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * ReportingApi - axios parameter creator
 */
export const ReportingApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentReportingControllerReadProjectCollection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unwanted-incidents/reporting/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportingApi - functional programming interface
 */
export const ReportingApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportingApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentReportingProjectDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentReportingControllerReadProjectCollection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportingApi.unwantedIncidentReportingControllerReadProjectCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportingApi - factory interface
 */
export const ReportingApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportingApiFp(configuration)
    return {
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentReportingProjectDtoCollectionResponse> {
            return localVarFp.unwantedIncidentReportingControllerReadProjectCollection(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportingApi - object-oriented interface
 */
export class ReportingApi extends BaseAPI {
    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig) {
        return ReportingApiFp(this.configuration).unwantedIncidentReportingControllerReadProjectCollection(options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SidebarApi - axios parameter creator
 */
export const SidebarApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Pin a sidebar item
         * @param {CreateSidebarItemPinnedDto} createSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerCreateSidebarItemPinned: async (createSidebarItemPinnedDto: CreateSidebarItemPinnedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createSidebarItemPinnedDto' is not null or undefined
            assertParamExists('sidebarControllerCreateSidebarItemPinned', 'createSidebarItemPinnedDto', createSidebarItemPinnedDto)
            const localVarPath = `/sidebars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createSidebarItemPinnedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerDelete: async (sidebarItemPinnedId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sidebarItemPinnedId' is not null or undefined
            assertParamExists('sidebarControllerDelete', 'sidebarItemPinnedId', sidebarItemPinnedId)
            const localVarPath = `/sidebars/{sidebarItemPinnedId}`
                .replace(`{${"sidebarItemPinnedId"}}`, encodeURIComponent(String(sidebarItemPinnedId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get the collection of SidebarItemPinned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerReadCollection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/sidebars`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {UpdateSidebarItemPinnedDto} updateSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerUpdate: async (sidebarItemPinnedId: string, updateSidebarItemPinnedDto: UpdateSidebarItemPinnedDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'sidebarItemPinnedId' is not null or undefined
            assertParamExists('sidebarControllerUpdate', 'sidebarItemPinnedId', sidebarItemPinnedId)
            // verify required parameter 'updateSidebarItemPinnedDto' is not null or undefined
            assertParamExists('sidebarControllerUpdate', 'updateSidebarItemPinnedDto', updateSidebarItemPinnedDto)
            const localVarPath = `/sidebars/{sidebarItemPinnedId}`
                .replace(`{${"sidebarItemPinnedId"}}`, encodeURIComponent(String(sidebarItemPinnedId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateSidebarItemPinnedDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SidebarApi - functional programming interface
 */
export const SidebarApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SidebarApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Pin a sidebar item
         * @param {CreateSidebarItemPinnedDto} createSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto: CreateSidebarItemPinnedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSidebarItemPinnedDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SidebarApi.sidebarControllerCreateSidebarItemPinned']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sidebarControllerDelete(sidebarItemPinnedId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sidebarControllerDelete(sidebarItemPinnedId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SidebarApi.sidebarControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get the collection of SidebarItemPinned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sidebarControllerReadCollection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSidebarItemPinnedDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sidebarControllerReadCollection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SidebarApi.sidebarControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {UpdateSidebarItemPinnedDto} updateSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sidebarControllerUpdate(sidebarItemPinnedId: string, updateSidebarItemPinnedDto: UpdateSidebarItemPinnedDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseSidebarItemPinnedDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sidebarControllerUpdate(sidebarItemPinnedId, updateSidebarItemPinnedDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SidebarApi.sidebarControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SidebarApi - factory interface
 */
export const SidebarApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SidebarApiFp(configuration)
    return {
        /**
         * 
         * @summary Pin a sidebar item
         * @param {CreateSidebarItemPinnedDto} createSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto: CreateSidebarItemPinnedDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSidebarItemPinnedDtoEntityResponse> {
            return localVarFp.sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerDelete(sidebarItemPinnedId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.sidebarControllerDelete(sidebarItemPinnedId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get the collection of SidebarItemPinned
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerReadCollection(options?: RawAxiosRequestConfig): AxiosPromise<ResponseSidebarItemPinnedDtoCollectionResponse> {
            return localVarFp.sidebarControllerReadCollection(options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an SidebarItemPinned
         * @param {string} sidebarItemPinnedId 
         * @param {UpdateSidebarItemPinnedDto} updateSidebarItemPinnedDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sidebarControllerUpdate(sidebarItemPinnedId: string, updateSidebarItemPinnedDto: UpdateSidebarItemPinnedDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseSidebarItemPinnedDtoEntityResponse> {
            return localVarFp.sidebarControllerUpdate(sidebarItemPinnedId, updateSidebarItemPinnedDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SidebarApi - object-oriented interface
 */
export class SidebarApi extends BaseAPI {
    /**
     * 
     * @summary Pin a sidebar item
     * @param {CreateSidebarItemPinnedDto} createSidebarItemPinnedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto: CreateSidebarItemPinnedDto, options?: RawAxiosRequestConfig) {
        return SidebarApiFp(this.configuration).sidebarControllerCreateSidebarItemPinned(createSidebarItemPinnedDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a SidebarItemPinned
     * @param {string} sidebarItemPinnedId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sidebarControllerDelete(sidebarItemPinnedId: string, options?: RawAxiosRequestConfig) {
        return SidebarApiFp(this.configuration).sidebarControllerDelete(sidebarItemPinnedId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get the collection of SidebarItemPinned
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sidebarControllerReadCollection(options?: RawAxiosRequestConfig) {
        return SidebarApiFp(this.configuration).sidebarControllerReadCollection(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an SidebarItemPinned
     * @param {string} sidebarItemPinnedId 
     * @param {UpdateSidebarItemPinnedDto} updateSidebarItemPinnedDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public sidebarControllerUpdate(sidebarItemPinnedId: string, updateSidebarItemPinnedDto: UpdateSidebarItemPinnedDto, options?: RawAxiosRequestConfig) {
        return SidebarApiFp(this.configuration).sidebarControllerUpdate(sidebarItemPinnedId, updateSidebarItemPinnedDto, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * SystemApi - axios parameter creator
 */
export const SystemApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Check status of metering point on ElHub
         * @param {string} meteringPointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerMeteringPointStatus: async (meteringPointId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'meteringPointId' is not null or undefined
            assertParamExists('systemControllerMeteringPointStatus', 'meteringPointId', meteringPointId)
            const localVarPath = `/system/el-hub/metering-point-status/{meteringPointId}`
                .replace(`{${"meteringPointId"}}`, encodeURIComponent(String(meteringPointId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadCountries: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/countries`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Will fallback to last CPI value found and then adjust starting point to one year before.
         * @summary Calculate the yearly CPI increase for a country
         * @param {SystemControllerReadCpiYearlyAdjustmentCountryEnum} country 
         * @param {number} year 
         * @param {number} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadCpiYearlyAdjustment: async (country: SystemControllerReadCpiYearlyAdjustmentCountryEnum, year: number, month: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'country' is not null or undefined
            assertParamExists('systemControllerReadCpiYearlyAdjustment', 'country', country)
            // verify required parameter 'year' is not null or undefined
            assertParamExists('systemControllerReadCpiYearlyAdjustment', 'year', year)
            // verify required parameter 'month' is not null or undefined
            assertParamExists('systemControllerReadCpiYearlyAdjustment', 'month', month)
            const localVarPath = `/system/cpi/yearly-adjustment`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (country !== undefined) {
                localVarQueryParameter['country'] = country;
            }

            if (year !== undefined) {
                localVarQueryParameter['year'] = year;
            }

            if (month !== undefined) {
                localVarQueryParameter['month'] = month;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadTimezones: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/system/timezones`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SystemApi - functional programming interface
 */
export const SystemApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SystemApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Check status of metering point on ElHub
         * @param {string} meteringPointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemControllerMeteringPointStatus(meteringPointId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseMeteringPointStatusDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemControllerMeteringPointStatus(meteringPointId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemControllerMeteringPointStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemControllerReadCountries(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCountryDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemControllerReadCountries(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemControllerReadCountries']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Will fallback to last CPI value found and then adjust starting point to one year before.
         * @summary Calculate the yearly CPI increase for a country
         * @param {SystemControllerReadCpiYearlyAdjustmentCountryEnum} country 
         * @param {number} year 
         * @param {number} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemControllerReadCpiYearlyAdjustment(country: SystemControllerReadCpiYearlyAdjustmentCountryEnum, year: number, month: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseCpiYearlyAdjustmentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemControllerReadCpiYearlyAdjustment(country, year, month, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemControllerReadCpiYearlyAdjustment']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async systemControllerReadTimezones(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTimezoneDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.systemControllerReadTimezones(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['SystemApi.systemControllerReadTimezones']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * SystemApi - factory interface
 */
export const SystemApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SystemApiFp(configuration)
    return {
        /**
         * 
         * @summary Check status of metering point on ElHub
         * @param {string} meteringPointId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerMeteringPointStatus(meteringPointId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseMeteringPointStatusDtoEntityResponse> {
            return localVarFp.systemControllerMeteringPointStatus(meteringPointId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all countries
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadCountries(options?: RawAxiosRequestConfig): AxiosPromise<ResponseCountryDtoCollectionResponse> {
            return localVarFp.systemControllerReadCountries(options).then((request) => request(axios, basePath));
        },
        /**
         * Will fallback to last CPI value found and then adjust starting point to one year before.
         * @summary Calculate the yearly CPI increase for a country
         * @param {SystemControllerReadCpiYearlyAdjustmentCountryEnum} country 
         * @param {number} year 
         * @param {number} month 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadCpiYearlyAdjustment(country: SystemControllerReadCpiYearlyAdjustmentCountryEnum, year: number, month: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseCpiYearlyAdjustmentDtoEntityResponse> {
            return localVarFp.systemControllerReadCpiYearlyAdjustment(country, year, month, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all timezones
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        systemControllerReadTimezones(options?: RawAxiosRequestConfig): AxiosPromise<ResponseTimezoneDtoCollectionResponse> {
            return localVarFp.systemControllerReadTimezones(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SystemApi - object-oriented interface
 */
export class SystemApi extends BaseAPI {
    /**
     * 
     * @summary Check status of metering point on ElHub
     * @param {string} meteringPointId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public systemControllerMeteringPointStatus(meteringPointId: string, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemControllerMeteringPointStatus(meteringPointId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all countries
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public systemControllerReadCountries(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemControllerReadCountries(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Will fallback to last CPI value found and then adjust starting point to one year before.
     * @summary Calculate the yearly CPI increase for a country
     * @param {SystemControllerReadCpiYearlyAdjustmentCountryEnum} country 
     * @param {number} year 
     * @param {number} month 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public systemControllerReadCpiYearlyAdjustment(country: SystemControllerReadCpiYearlyAdjustmentCountryEnum, year: number, month: number, options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemControllerReadCpiYearlyAdjustment(country, year, month, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all timezones
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public systemControllerReadTimezones(options?: RawAxiosRequestConfig) {
        return SystemApiFp(this.configuration).systemControllerReadTimezones(options).then((request) => request(this.axios, this.basePath));
    }
}

export const SystemControllerReadCpiYearlyAdjustmentCountryEnum = {
    No: 'no',
} as const;
export type SystemControllerReadCpiYearlyAdjustmentCountryEnum = typeof SystemControllerReadCpiYearlyAdjustmentCountryEnum[keyof typeof SystemControllerReadCpiYearlyAdjustmentCountryEnum];


/**
 * TakeoverSupplierOptionApi - axios parameter creator
 */
export const TakeoverSupplierOptionApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionLogosUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/logos/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-form/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/right-of-withdrawal-information/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/count`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate: async (takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete: async (takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection: async (takeoverSupplierOptionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort: async (takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/sort`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap: async (takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/swap/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate: async (takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'takeoverSupplierOptionId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'takeoverSupplierOptionId', takeoverSupplierOptionId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/takeover-supplier-option/{takeoverSupplierOptionId}/terms-of-service/{fileId}`
                .replace(`{${"takeoverSupplierOptionId"}}`, encodeURIComponent(String(takeoverSupplierOptionId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all TakeoverSupplierOptions on given projectId
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeoverSupplierOptionControllerReadTakeoverSupplierOptions: async (projectId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'projectId' is not null or undefined
            assertParamExists('takeoverSupplierOptionControllerReadTakeoverSupplierOptions', 'projectId', projectId)
            const localVarPath = `/projects/{projectId}/takeover-supplier-options`
                .replace(`{${"projectId"}}`, encodeURIComponent(String(projectId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TakeoverSupplierOptionApi - functional programming interface
 */
export const TakeoverSupplierOptionApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TakeoverSupplierOptionApiAxiosParamCreator(configuration)
    return {
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionLogosUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all TakeoverSupplierOptions on given projectId
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseTakeoverSupplierOptionDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['TakeoverSupplierOptionApi.takeoverSupplierOptionControllerReadTakeoverSupplierOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * TakeoverSupplierOptionApi - factory interface
 */
export const TakeoverSupplierOptionApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TakeoverSupplierOptionApiFp(configuration)
    return {
        /**
         * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
         * @summary 
         * @param {string} takeoverSupplierOptionId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all TakeoverSupplierOptions on given projectId
         * @param {number} projectId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseTakeoverSupplierOptionDtoCollectionResponse> {
            return localVarFp.takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TakeoverSupplierOptionApi - object-oriented interface
 */
export class TakeoverSupplierOptionApi extends BaseAPI {
    /**
     * Count all FileUsages in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Logos\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionLogosUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"RightOfWithdrawalForm\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalFormUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"RightOfWithdrawalInformation\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionRightOfWithdrawalInformationUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Count all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceCount(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceCreate(takeoverSupplierOptionId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceDelete(takeoverSupplierOptionId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId: string, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceReadCollection(takeoverSupplierOptionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceSort(takeoverSupplierOptionId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceSwap(takeoverSupplierOptionId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"TermsOfService\" for TakeoverSupplierOption
     * @summary 
     * @param {string} takeoverSupplierOptionId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).fileUsageControllerTakeoverSupplierOptionTermsOfServiceUpdate(takeoverSupplierOptionId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all TakeoverSupplierOptions on given projectId
     * @param {number} projectId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId: number, options?: RawAxiosRequestConfig) {
        return TakeoverSupplierOptionApiFp(this.configuration).takeoverSupplierOptionControllerReadTakeoverSupplierOptions(projectId, options).then((request) => request(this.axios, this.basePath));
    }
}



/**
 * UnwantedIncidentApi - axios parameter creator
 */
export const UnwantedIncidentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCount: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCount', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/count`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCreate: async (unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCreate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'createFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesCreate', 'createFileUsageDto', createFileUsageDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesDelete: async (unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesDelete', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesDelete', 'fileId', fileId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (deleteFile !== undefined) {
                localVarQueryParameter['deleteFile'] = deleteFile;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesReadCollection: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesReadCollection', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSort: async (unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSort', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileUsageSortDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSort', 'fileUsageSortDto', fileUsageSortDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/sort`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(fileUsageSortDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSwap: async (unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'fileId', fileId)
            // verify required parameter 'swapFileDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesSwap', 'swapFileDto', swapFileDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/swap/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(swapFileDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesUpdate: async (unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'fileId' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'fileId', fileId)
            // verify required parameter 'updateFileUsageDto' is not null or undefined
            assertParamExists('fileUsageControllerUnwantedIncidentFilesUpdate', 'updateFileUsageDto', updateFileUsageDto)
            const localVarPath = `/file-usages/unwanted-incident/{unwantedIncidentId}/files/{fileId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"fileId"}}`, encodeURIComponent(String(fileId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateFileUsageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an unwanted incident without being authenticated
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthUnwantedIncidentControllerCreate: async (createUnwantedIncidentDto: CreateUnwantedIncidentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUnwantedIncidentDto' is not null or undefined
            assertParamExists('nonAuthUnwantedIncidentControllerCreate', 'createUnwantedIncidentDto', createUnwantedIncidentDto)
            const localVarPath = `/non-auth/unwanted-incidents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnwantedIncidentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an unwanted incident
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerCreate: async (createUnwantedIncidentDto: CreateUnwantedIncidentDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'createUnwantedIncidentDto' is not null or undefined
            assertParamExists('unwantedIncidentControllerCreate', 'createUnwantedIncidentDto', createUnwantedIncidentDto)
            const localVarPath = `/unwanted-incidents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnwantedIncidentDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerDelete: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentControllerDelete', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an unwanted incident
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerRead: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentControllerRead', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all unwanted incidents on projects the user is UnwantedIncidentManager on
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [projectId] Filter results on ProjectId
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {Array<UnwantedIncidentControllerReadCollectionTypesEnum>} [types] The types of unwanted incident you want to filer on. If provided will only show those types
         * @param {UnwantedIncidentType} [type] Use types instead
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentPageOptionsOrderBy, projectId?: number | null, objectId?: number | null, types?: Array<UnwantedIncidentControllerReadCollectionTypesEnum>, type?: UnwantedIncidentType, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentControllerReadCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (objectId !== undefined) {
                localVarQueryParameter['ObjectId'] = objectId;
            }

            if (types) {
                localVarQueryParameter['types'] = types;
            }

            if (type !== undefined) {
                localVarQueryParameter['type'] = type;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerUpdate: async (unwantedIncidentId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentControllerUpdate', 'unwantedIncidentId', unwantedIncidentId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)


            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadObjectFilterCollection: async (page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadObjectFilterCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadObjectFilterCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/filter/object`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadProjectFilterCollection: async (page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadProjectFilterCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentFilterControllerReadProjectFilterCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/filter/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an unwanted incident process action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {CreateUnwantedIncidentProcessActionDto} createUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerCreate: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, createUnwantedIncidentProcessActionDto: CreateUnwantedIncidentProcessActionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerCreate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerCreate', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'createUnwantedIncidentProcessActionDto' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerCreate', 'createUnwantedIncidentProcessActionDto', createUnwantedIncidentProcessActionDto)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}/actions`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnwantedIncidentProcessActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerDelete: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerDelete', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerDelete', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'unwantedIncidentProcessActionId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerDelete', 'unwantedIncidentProcessActionId', unwantedIncidentProcessActionId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}/actions/{unwantedIncidentProcessActionId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)))
                .replace(`{${"unwantedIncidentProcessActionId"}}`, encodeURIComponent(String(unwantedIncidentProcessActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerRead: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerRead', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerRead', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'unwantedIncidentProcessActionId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerRead', 'unwantedIncidentProcessActionId', unwantedIncidentProcessActionId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}/actions/{unwantedIncidentProcessActionId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)))
                .replace(`{${"unwantedIncidentProcessActionId"}}`, encodeURIComponent(String(unwantedIncidentProcessActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read all unwanted incident\'s process\' actions
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerReadCollection: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerReadCollection', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerReadCollection', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerReadCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}/actions`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {UpdateUnwantedIncidentProcessActionDto} updateUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerUpdate: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, updateUnwantedIncidentProcessActionDto: UpdateUnwantedIncidentProcessActionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerUpdate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerUpdate', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'unwantedIncidentProcessActionId' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerUpdate', 'unwantedIncidentProcessActionId', unwantedIncidentProcessActionId)
            // verify required parameter 'updateUnwantedIncidentProcessActionDto' is not null or undefined
            assertParamExists('unwantedIncidentProcessActionControllerUpdate', 'updateUnwantedIncidentProcessActionDto', updateUnwantedIncidentProcessActionDto)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}/actions/{unwantedIncidentProcessActionId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)))
                .replace(`{${"unwantedIncidentProcessActionId"}}`, encodeURIComponent(String(unwantedIncidentProcessActionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnwantedIncidentProcessActionDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {CreateUnwantedIncidentProcessDto} createUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerCreate: async (unwantedIncidentId: string, createUnwantedIncidentProcessDto: CreateUnwantedIncidentProcessDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerCreate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'createUnwantedIncidentProcessDto' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerCreate', 'createUnwantedIncidentProcessDto', createUnwantedIncidentProcessDto)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUnwantedIncidentProcessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerDelete: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerDelete', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerDelete', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerRead: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerRead', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerRead', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read an unwanted incident\'s processes
         * @param {string} unwantedIncidentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerReadCollection: async (unwantedIncidentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerReadCollection', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerReadCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {UpdateUnwantedIncidentProcessDto} updateUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerUpdate: async (unwantedIncidentId: string, unwantedIncidentProcessId: string, updateUnwantedIncidentProcessDto: UpdateUnwantedIncidentProcessDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'unwantedIncidentId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerUpdate', 'unwantedIncidentId', unwantedIncidentId)
            // verify required parameter 'unwantedIncidentProcessId' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerUpdate', 'unwantedIncidentProcessId', unwantedIncidentProcessId)
            // verify required parameter 'updateUnwantedIncidentProcessDto' is not null or undefined
            assertParamExists('unwantedIncidentProcessControllerUpdate', 'updateUnwantedIncidentProcessDto', updateUnwantedIncidentProcessDto)
            const localVarPath = `/unwanted-incidents/{unwantedIncidentId}/processes/{unwantedIncidentProcessId}`
                .replace(`{${"unwantedIncidentId"}}`, encodeURIComponent(String(unwantedIncidentId)))
                .replace(`{${"unwantedIncidentProcessId"}}`, encodeURIComponent(String(unwantedIncidentProcessId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUnwantedIncidentProcessDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentProjectPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProjectControllerReadCollection: async (page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentProjectPageOptionsOrderBy, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'page' is not null or undefined
            assertParamExists('unwantedIncidentProjectControllerReadCollection', 'page', page)
            // verify required parameter 'limit' is not null or undefined
            assertParamExists('unwantedIncidentProjectControllerReadCollection', 'limit', limit)
            const localVarPath = `/unwanted-incidents/projects`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (order !== undefined) {
                localVarQueryParameter['order'] = order;
            }

            if (orderBy !== undefined) {
                localVarQueryParameter['orderBy'] = orderBy;
            }

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} lng 
         * @param {number} lat 
         * @param {number} [distance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProjectControllerReadNearbyCollection: async (lng: number, lat: number, distance?: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'lng' is not null or undefined
            assertParamExists('unwantedIncidentProjectControllerReadNearbyCollection', 'lng', lng)
            // verify required parameter 'lat' is not null or undefined
            assertParamExists('unwantedIncidentProjectControllerReadNearbyCollection', 'lat', lat)
            const localVarPath = `/unwanted-incidents/projects/nearby`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (lng !== undefined) {
                localVarQueryParameter['lng'] = lng;
            }

            if (lat !== undefined) {
                localVarQueryParameter['lat'] = lat;
            }

            if (distance !== undefined) {
                localVarQueryParameter['distance'] = distance;
            }

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentReportingControllerReadProjectCollection: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/unwanted-incidents/reporting/project`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UnwantedIncidentApi - functional programming interface
 */
export const UnwantedIncidentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UnwantedIncidentApiAxiosParamCreator(configuration)
    return {
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageCountDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesCount']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FileUsageFileSortDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesSort']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesSwap']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseFileUsageDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.fileUsageControllerUnwantedIncidentFilesUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an unwanted incident without being authenticated
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.nonAuthUnwantedIncidentControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an unwanted incident
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentControllerCreate(createUnwantedIncidentDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentControllerDelete(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentControllerDelete(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read an unwanted incident
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentControllerRead(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentControllerRead(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all unwanted incidents on projects the user is UnwantedIncidentManager on
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [projectId] Filter results on ProjectId
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {Array<UnwantedIncidentControllerReadCollectionTypesEnum>} [types] The types of unwanted incident you want to filer on. If provided will only show those types
         * @param {UnwantedIncidentType} [type] Use types instead
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentPageOptionsOrderBy, projectId?: number | null, objectId?: number | null, types?: Array<UnwantedIncidentControllerReadCollectionTypesEnum>, type?: UnwantedIncidentType, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentControllerReadCollection(page, limit, order, orderBy, projectId, objectId, types, type, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentControllerUpdate(unwantedIncidentId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentControllerUpdate(unwantedIncidentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentFilterControllerReadObjectFilterCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentFilterControllerReadProjectFilterCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an unwanted incident process action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {CreateUnwantedIncidentProcessActionDto} createUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessActionControllerCreate(unwantedIncidentId: string, unwantedIncidentProcessId: string, createUnwantedIncidentProcessActionDto: CreateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessActionControllerCreate(unwantedIncidentId, unwantedIncidentProcessId, createUnwantedIncidentProcessActionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessActionControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessActionControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessActionControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessActionControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessActionControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessActionControllerRead(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessActionControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read all unwanted incident\'s process\' actions
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId: string, unwantedIncidentProcessId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessActionDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId, unwantedIncidentProcessId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessActionControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {UpdateUnwantedIncidentProcessActionDto} updateUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, updateUnwantedIncidentProcessActionDto: UpdateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, updateUnwantedIncidentProcessActionDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessActionControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {CreateUnwantedIncidentProcessDto} createUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessControllerCreate(unwantedIncidentId: string, createUnwantedIncidentProcessDto: CreateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessControllerCreate(unwantedIncidentId, createUnwantedIncidentProcessDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessControllerCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessControllerDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessControllerRead(unwantedIncidentId, unwantedIncidentProcessId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read an unwanted incident\'s processes
         * @param {string} unwantedIncidentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessControllerReadCollection(unwantedIncidentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessControllerReadCollection(unwantedIncidentId, page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {UpdateUnwantedIncidentProcessDto} updateUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProcessControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, updateUnwantedIncidentProcessDto: UpdateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProcessControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, updateUnwantedIncidentProcessDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProcessControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentProjectPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProjectControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentProjectPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentProjectDtoPageResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProjectControllerReadCollection(page, limit, order, orderBy, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProjectControllerReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} lng 
         * @param {number} lat 
         * @param {number} [distance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentProjectControllerReadNearbyCollection(lng: number, lat: number, distance?: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseNearbyUnwantedIncidentProjectDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentProjectControllerReadNearbyCollection(lng, lat, distance, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentProjectControllerReadNearbyCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUnwantedIncidentReportingProjectDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unwantedIncidentReportingControllerReadProjectCollection(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UnwantedIncidentApi.unwantedIncidentReportingControllerReadProjectCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UnwantedIncidentApi - factory interface
 */
export const UnwantedIncidentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UnwantedIncidentApiFp(configuration)
    return {
        /**
         * Count all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageCountDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Add a file to \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {CreateFileUsageDto} createFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete a File in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {boolean} [deleteFile] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all FileUsages \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoCollectionResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Sort all FileUsages in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {FileUsageSortDto} fileUsageSortDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig): AxiosPromise<FileUsageFileSortDtoCollectionResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Swap a File in FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {SwapFileDto} swapFileDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Update a FileUsage in \"Files\" for UnwantedIncident
         * @summary 
         * @param {string} unwantedIncidentId 
         * @param {number} fileId 
         * @param {UpdateFileUsageDto} updateFileUsageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseFileUsageDtoEntityResponse> {
            return localVarFp.fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an unwanted incident without being authenticated
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse> {
            return localVarFp.nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an unwanted incident
         * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse> {
            return localVarFp.unwantedIncidentControllerCreate(createUnwantedIncidentDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerDelete(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.unwantedIncidentControllerDelete(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read an unwanted incident
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerRead(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentDtoEntityResponse> {
            return localVarFp.unwantedIncidentControllerRead(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all unwanted incidents on projects the user is UnwantedIncidentManager on
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentPageOptionsOrderBy} [orderBy] 
         * @param {number | null} [projectId] Filter results on ProjectId
         * @param {number | null} [objectId] Filter results on ObjectId
         * @param {Array<UnwantedIncidentControllerReadCollectionTypesEnum>} [types] The types of unwanted incident you want to filer on. If provided will only show those types
         * @param {UnwantedIncidentType} [type] Use types instead
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentPageOptionsOrderBy, projectId?: number | null, objectId?: number | null, types?: Array<UnwantedIncidentControllerReadCollectionTypesEnum>, type?: UnwantedIncidentType, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentDtoPageResponse> {
            return localVarFp.unwantedIncidentControllerReadCollection(page, limit, order, orderBy, projectId, objectId, types, type, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} unwantedIncidentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentControllerUpdate(unwantedIncidentId: string, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unwantedIncidentControllerUpdate(unwantedIncidentId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterDtoPageResponse> {
            return localVarFp.unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<FilterDtoPageResponse> {
            return localVarFp.unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an unwanted incident process action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {CreateUnwantedIncidentProcessActionDto} createUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerCreate(unwantedIncidentId: string, unwantedIncidentProcessId: string, createUnwantedIncidentProcessActionDto: CreateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessActionControllerCreate(unwantedIncidentId, unwantedIncidentProcessId, createUnwantedIncidentProcessActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.unwantedIncidentProcessActionControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessActionControllerRead(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read all unwanted incident\'s process\' actions
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId: string, unwantedIncidentProcessId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessActionDtoPageResponse> {
            return localVarFp.unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId, unwantedIncidentProcessId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process\' action
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {string} unwantedIncidentProcessActionId 
         * @param {UpdateUnwantedIncidentProcessActionDto} updateUnwantedIncidentProcessActionDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, updateUnwantedIncidentProcessActionDto: UpdateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessActionDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, updateUnwantedIncidentProcessActionDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {CreateUnwantedIncidentProcessDto} createUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerCreate(unwantedIncidentId: string, createUnwantedIncidentProcessDto: CreateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessControllerCreate(unwantedIncidentId, createUnwantedIncidentProcessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.unwantedIncidentProcessControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessControllerRead(unwantedIncidentId, unwantedIncidentProcessId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read an unwanted incident\'s processes
         * @param {string} unwantedIncidentId 
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {PageOptionsDefaultOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerReadCollection(unwantedIncidentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessDtoPageResponse> {
            return localVarFp.unwantedIncidentProcessControllerReadCollection(unwantedIncidentId, page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update an unwanted incident\'s process
         * @param {string} unwantedIncidentId 
         * @param {string} unwantedIncidentProcessId 
         * @param {UpdateUnwantedIncidentProcessDto} updateUnwantedIncidentProcessDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProcessControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, updateUnwantedIncidentProcessDto: UpdateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProcessDtoEntityResponse> {
            return localVarFp.unwantedIncidentProcessControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, updateUnwantedIncidentProcessDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} page 
         * @param {number} limit 
         * @param {Order} [order] 
         * @param {UnwantedIncidentProjectPageOptionsOrderBy} [orderBy] 
         * @param {string} [search] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProjectControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentProjectPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentProjectDtoPageResponse> {
            return localVarFp.unwantedIncidentProjectControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a collection of projects with UnwantedIncidents enabled
         * @param {number} lng 
         * @param {number} lat 
         * @param {number} [distance] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentProjectControllerReadNearbyCollection(lng: number, lat: number, distance?: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseNearbyUnwantedIncidentProjectDtoCollectionResponse> {
            return localVarFp.unwantedIncidentProjectControllerReadNearbyCollection(lng, lat, distance, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig): AxiosPromise<ResponseUnwantedIncidentReportingProjectDtoCollectionResponse> {
            return localVarFp.unwantedIncidentReportingControllerReadProjectCollection(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UnwantedIncidentApi - object-oriented interface
 */
export class UnwantedIncidentApi extends BaseAPI {
    /**
     * Count all FileUsages in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesCount(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add a file to \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {CreateFileUsageDto} createFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId: string, createFileUsageDto: CreateFileUsageDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesCreate(unwantedIncidentId, createFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete a File in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {boolean} [deleteFile] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId: string, fileId: number, deleteFile?: boolean, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesDelete(unwantedIncidentId, fileId, deleteFile, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all FileUsages \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesReadCollection(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Sort all FileUsages in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {FileUsageSortDto} fileUsageSortDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId: string, fileUsageSortDto: FileUsageSortDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesSort(unwantedIncidentId, fileUsageSortDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Swap a File in FileUsage in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {SwapFileDto} swapFileDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId: string, fileId: number, swapFileDto: SwapFileDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesSwap(unwantedIncidentId, fileId, swapFileDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update a FileUsage in \"Files\" for UnwantedIncident
     * @summary 
     * @param {string} unwantedIncidentId 
     * @param {number} fileId 
     * @param {UpdateFileUsageDto} updateFileUsageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId: string, fileId: number, updateFileUsageDto: UpdateFileUsageDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).fileUsageControllerUnwantedIncidentFilesUpdate(unwantedIncidentId, fileId, updateFileUsageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an unwanted incident without being authenticated
     * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).nonAuthUnwantedIncidentControllerCreate(createUnwantedIncidentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an unwanted incident
     * @param {CreateUnwantedIncidentDto} createUnwantedIncidentDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentControllerCreate(createUnwantedIncidentDto: CreateUnwantedIncidentDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentControllerCreate(createUnwantedIncidentDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentControllerDelete(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentControllerDelete(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read an unwanted incident
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentControllerRead(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentControllerRead(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all unwanted incidents on projects the user is UnwantedIncidentManager on
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {UnwantedIncidentPageOptionsOrderBy} [orderBy] 
     * @param {number | null} [projectId] Filter results on ProjectId
     * @param {number | null} [objectId] Filter results on ObjectId
     * @param {Array<UnwantedIncidentControllerReadCollectionTypesEnum>} [types] The types of unwanted incident you want to filer on. If provided will only show those types
     * @param {UnwantedIncidentType} [type] Use types instead
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentPageOptionsOrderBy, projectId?: number | null, objectId?: number | null, types?: Array<UnwantedIncidentControllerReadCollectionTypesEnum>, type?: UnwantedIncidentType, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentControllerReadCollection(page, limit, order, orderBy, projectId, objectId, types, type, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {string} unwantedIncidentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentControllerUpdate(unwantedIncidentId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentControllerUpdate(unwantedIncidentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentFilterControllerReadObjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentFilterControllerReadObjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentFilterControllerReadProjectFilterCollection(page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentFilterControllerReadProjectFilterCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an unwanted incident process action
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {CreateUnwantedIncidentProcessActionDto} createUnwantedIncidentProcessActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessActionControllerCreate(unwantedIncidentId: string, unwantedIncidentProcessId: string, createUnwantedIncidentProcessActionDto: CreateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessActionControllerCreate(unwantedIncidentId, unwantedIncidentProcessId, createUnwantedIncidentProcessActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an unwanted incident\'s process\' action
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {string} unwantedIncidentProcessActionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessActionControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessActionControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read an unwanted incident\'s process\' action
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {string} unwantedIncidentProcessActionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessActionControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessActionControllerRead(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read all unwanted incident\'s process\' actions
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId: string, unwantedIncidentProcessId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessActionControllerReadCollection(unwantedIncidentId, unwantedIncidentProcessId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an unwanted incident\'s process\' action
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {string} unwantedIncidentProcessActionId 
     * @param {UpdateUnwantedIncidentProcessActionDto} updateUnwantedIncidentProcessActionDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, unwantedIncidentProcessActionId: string, updateUnwantedIncidentProcessActionDto: UpdateUnwantedIncidentProcessActionDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessActionControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, unwantedIncidentProcessActionId, updateUnwantedIncidentProcessActionDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create an unwanted incident\'s process
     * @param {string} unwantedIncidentId 
     * @param {CreateUnwantedIncidentProcessDto} createUnwantedIncidentProcessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessControllerCreate(unwantedIncidentId: string, createUnwantedIncidentProcessDto: CreateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessControllerCreate(unwantedIncidentId, createUnwantedIncidentProcessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete an unwanted incident\'s process
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessControllerDelete(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessControllerDelete(unwantedIncidentId, unwantedIncidentProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read an unwanted incident\'s process
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessControllerRead(unwantedIncidentId: string, unwantedIncidentProcessId: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessControllerRead(unwantedIncidentId, unwantedIncidentProcessId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read an unwanted incident\'s processes
     * @param {string} unwantedIncidentId 
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {PageOptionsDefaultOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessControllerReadCollection(unwantedIncidentId: string, page: number, limit: number, order?: Order, orderBy?: PageOptionsDefaultOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessControllerReadCollection(unwantedIncidentId, page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update an unwanted incident\'s process
     * @param {string} unwantedIncidentId 
     * @param {string} unwantedIncidentProcessId 
     * @param {UpdateUnwantedIncidentProcessDto} updateUnwantedIncidentProcessDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProcessControllerUpdate(unwantedIncidentId: string, unwantedIncidentProcessId: string, updateUnwantedIncidentProcessDto: UpdateUnwantedIncidentProcessDto, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProcessControllerUpdate(unwantedIncidentId, unwantedIncidentProcessId, updateUnwantedIncidentProcessDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a collection of projects with UnwantedIncidents enabled
     * @param {number} page 
     * @param {number} limit 
     * @param {Order} [order] 
     * @param {UnwantedIncidentProjectPageOptionsOrderBy} [orderBy] 
     * @param {string} [search] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProjectControllerReadCollection(page: number, limit: number, order?: Order, orderBy?: UnwantedIncidentProjectPageOptionsOrderBy, search?: string, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProjectControllerReadCollection(page, limit, order, orderBy, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a collection of projects with UnwantedIncidents enabled
     * @param {number} lng 
     * @param {number} lat 
     * @param {number} [distance] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentProjectControllerReadNearbyCollection(lng: number, lat: number, distance?: number, options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentProjectControllerReadNearbyCollection(lng, lat, distance, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public unwantedIncidentReportingControllerReadProjectCollection(options?: RawAxiosRequestConfig) {
        return UnwantedIncidentApiFp(this.configuration).unwantedIncidentReportingControllerReadProjectCollection(options).then((request) => request(this.axios, this.basePath));
    }
}

export const UnwantedIncidentControllerReadCollectionTypesEnum = {
    PersonInjury: 'person-injury',
    MaterialDamage: 'material-damage',
    Accident: 'accident',
    NearAccident: 'near-accident',
    Observation: 'observation',
} as const;
export type UnwantedIncidentControllerReadCollectionTypesEnum = typeof UnwantedIncidentControllerReadCollectionTypesEnum[keyof typeof UnwantedIncidentControllerReadCollectionTypesEnum];


/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an Address for User
         * @summary 
         * @param {string} userId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserCreate: async (userId: string, createAddressDto: CreateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addressControllerUserCreate', 'userId', userId)
            // verify required parameter 'createAddressDto' is not null or undefined
            assertParamExists('addressControllerUserCreate', 'createAddressDto', createAddressDto)
            const localVarPath = `/user/{userId}/addresses`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserDelete: async (userId: string, addressId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addressControllerUserDelete', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerUserDelete', 'addressId', addressId)
            const localVarPath = `/user/{userId}/addresses/{addressId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Read all Addresses for User
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserReadCollection: async (userId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addressControllerUserReadCollection', 'userId', userId)
            const localVarPath = `/user/{userId}/addresses`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Update an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserUpdate: async (userId: string, addressId: string, updateAddressDto: UpdateAddressDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('addressControllerUserUpdate', 'userId', userId)
            // verify required parameter 'addressId' is not null or undefined
            assertParamExists('addressControllerUserUpdate', 'addressId', addressId)
            // verify required parameter 'updateAddressDto' is not null or undefined
            assertParamExists('addressControllerUserUpdate', 'updateAddressDto', updateAddressDto)
            const localVarPath = `/user/{userId}/addresses/{addressId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)))
                .replace(`{${"addressId"}}`, encodeURIComponent(String(addressId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateAddressDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Sets a users start page
         * @param {number} userId 
         * @param {CreateUserStartPageDto} createUserStartPageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateStartPage: async (userId: number, createUserStartPageDto: CreateUserStartPageDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerCreateStartPage', 'userId', userId)
            // verify required parameter 'createUserStartPageDto' is not null or undefined
            assertParamExists('userControllerCreateStartPage', 'createUserStartPageDto', createUserStartPageDto)
            const localVarPath = `/users/{userId}/startpage`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(createUserStartPageDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Delete a users start page
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteStartPage: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerDeleteStartPage', 'userId', userId)
            const localVarPath = `/users/{userId}/startpage`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary List of users that you can be
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAssumeUsers: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerGetAssumeUsers', 'userId', userId)
            const localVarPath = `/users/{userId}/assume`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRead: async (userId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerRead', 'userId', userId)
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Update user
         * @param {number} userId 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdate: async (userId: number, updateUserDto: UpdateUserDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userId' is not null or undefined
            assertParamExists('userControllerUpdate', 'userId', userId)
            // verify required parameter 'updateUserDto' is not null or undefined
            assertParamExists('userControllerUpdate', 'updateUserDto', updateUserDto)
            const localVarPath = `/users/{userId}`
                .replace(`{${"userId"}}`, encodeURIComponent(String(userId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateUserDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Read a User profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerRead: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/profile`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication CompanyToken required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration)
    return {
        /**
         * Create an Address for User
         * @summary 
         * @param {string} userId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerUserCreate(userId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerUserCreate(userId, createAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.addressControllerUserCreate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Delete an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerUserDelete(userId: string, addressId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerUserDelete(userId, addressId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.addressControllerUserDelete']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Read all Addresses for User
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerUserReadCollection(userId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerUserReadCollection(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.addressControllerUserReadCollection']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Update an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async addressControllerUserUpdate(userId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAddressDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.addressControllerUserUpdate(userId, addressId, updateAddressDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.addressControllerUserUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Sets a users start page
         * @param {number} userId 
         * @param {CreateUserStartPageDto} createUserStartPageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerCreateStartPage(userId: number, createUserStartPageDto: CreateUserStartPageDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerCreateStartPage(userId, createUserStartPageDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerCreateStartPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Delete a users start page
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerDeleteStartPage(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DeleteResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerDeleteStartPage(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerDeleteStartPage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary List of users that you can be
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerGetAssumeUsers(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseAssumeUserDtoCollectionResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerGetAssumeUsers(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerGetAssumeUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerRead(userId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerRead(userId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Update user
         * @param {number} userId 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userControllerUpdate(userId: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userControllerUpdate(userId, updateUserDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userControllerUpdate']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Read a User profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userProfileControllerRead(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ResponseUserProfileDtoEntityResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userProfileControllerRead(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userProfileControllerRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserApiFp(configuration)
    return {
        /**
         * Create an Address for User
         * @summary 
         * @param {string} userId 
         * @param {CreateAddressDto} createAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserCreate(userId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerUserCreate(userId, createAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Delete an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserDelete(userId: string, addressId: string, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.addressControllerUserDelete(userId, addressId, options).then((request) => request(axios, basePath));
        },
        /**
         * Read all Addresses for User
         * @summary 
         * @param {string} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserReadCollection(userId: string, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoCollectionResponse> {
            return localVarFp.addressControllerUserReadCollection(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * Update an Address for User
         * @summary 
         * @param {string} userId 
         * @param {string} addressId 
         * @param {UpdateAddressDto} updateAddressDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addressControllerUserUpdate(userId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAddressDtoEntityResponse> {
            return localVarFp.addressControllerUserUpdate(userId, addressId, updateAddressDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Sets a users start page
         * @param {number} userId 
         * @param {CreateUserStartPageDto} createUserStartPageDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerCreateStartPage(userId: number, createUserStartPageDto: CreateUserStartPageDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.userControllerCreateStartPage(userId, createUserStartPageDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Delete a users start page
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerDeleteStartPage(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<DeleteResponseDto> {
            return localVarFp.userControllerDeleteStartPage(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary List of users that you can be
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerGetAssumeUsers(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseAssumeUserDtoCollectionResponse> {
            return localVarFp.userControllerGetAssumeUsers(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read user
         * @param {number} userId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerRead(userId: number, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserDtoEntityResponse> {
            return localVarFp.userControllerRead(userId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Update user
         * @param {number} userId 
         * @param {UpdateUserDto} updateUserDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userControllerUpdate(userId: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserDtoEntityResponse> {
            return localVarFp.userControllerUpdate(userId, updateUserDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Read a User profile
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userProfileControllerRead(options?: RawAxiosRequestConfig): AxiosPromise<ResponseUserProfileDtoEntityResponse> {
            return localVarFp.userProfileControllerRead(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Create an Address for User
     * @summary 
     * @param {string} userId 
     * @param {CreateAddressDto} createAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerUserCreate(userId: string, createAddressDto: CreateAddressDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).addressControllerUserCreate(userId, createAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Delete an Address for User
     * @summary 
     * @param {string} userId 
     * @param {string} addressId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerUserDelete(userId: string, addressId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).addressControllerUserDelete(userId, addressId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Read all Addresses for User
     * @summary 
     * @param {string} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerUserReadCollection(userId: string, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).addressControllerUserReadCollection(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Update an Address for User
     * @summary 
     * @param {string} userId 
     * @param {string} addressId 
     * @param {UpdateAddressDto} updateAddressDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public addressControllerUserUpdate(userId: string, addressId: string, updateAddressDto: UpdateAddressDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).addressControllerUserUpdate(userId, addressId, updateAddressDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Sets a users start page
     * @param {number} userId 
     * @param {CreateUserStartPageDto} createUserStartPageDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerCreateStartPage(userId: number, createUserStartPageDto: CreateUserStartPageDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerCreateStartPage(userId, createUserStartPageDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Delete a users start page
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerDeleteStartPage(userId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerDeleteStartPage(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary List of users that you can be
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerGetAssumeUsers(userId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerGetAssumeUsers(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read user
     * @param {number} userId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerRead(userId: number, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerRead(userId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Update user
     * @param {number} userId 
     * @param {UpdateUserDto} updateUserDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userControllerUpdate(userId: number, updateUserDto: UpdateUserDto, options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userControllerUpdate(userId, updateUserDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Read a User profile
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public userProfileControllerRead(options?: RawAxiosRequestConfig) {
        return UserApiFp(this.configuration).userProfileControllerRead(options).then((request) => request(this.axios, this.basePath));
    }
}



